// Generated from OpenAPI. Do not edit.
export const modelSchemas = {
  PatrimonyJobList: {
    type: "array",
    items: {
      $ref: "#/components/schemas/PatrimonyJob",
    },
  },
  MandateLinksInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      expectedRevision: {
        type: "integer",
      },
      links: {
        type: "array",
        maxItems: 1000,
        items: {
          type: "object",
          additionalProperties: false,
          properties: {
            pointId: {
              type: "string",
            },
            deliveryPointId: {
              type: ["string", "null"],
            },
          },
          required: ["pointId", "deliveryPointId"],
        },
      },
    },
    required: ["expectedRevision", "links"],
  },
  MandateFollowupInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      expectedRevision: {
        type: "integer",
      },
      ownerUserId: {
        type: "string",
      },
      networkStage: {
        type: "string",
        enum: ["none", "waiting", "resolved"],
      },
      networkAction: {
        type: "string",
        maxLength: 1000,
      },
    },
    required: ["expectedRevision"],
  },
  MandateFollowup: {
    type: "object",
    additionalProperties: false,
    properties: {
      revision: {
        type: "integer",
      },
      ownerUserId: {
        type: "string",
      },
      networkStage: {
        type: "string",
        enum: ["none", "waiting", "resolved"],
      },
      networkAction: {
        type: "string",
      },
      networkSince: {
        type: ["string", "null"],
      },
      points: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandatePointFollowup",
        },
      },
    },
    required: [
      "revision",
      "ownerUserId",
      "networkStage",
      "networkAction",
      "networkSince",
      "points",
    ],
  },
  MandatePointFollowup: {
    type: "object",
    additionalProperties: false,
    properties: {
      pointId: {
        type: "string",
      },
      type: {
        type: "string",
      },
      reference: {
        type: "string",
      },
      deliveryPointId: {
        type: ["string", "null"],
      },
      suggestedDeliveryPointId: {
        type: ["string", "null"],
      },
      siteId: {
        type: ["string", "null"],
      },
      siteName: {
        type: ["string", "null"],
      },
      networkStatus: {
        type: "string",
      },
      networkCheckedAt: {
        type: ["string", "null"],
      },
      latestDataAt: {
        type: ["string", "null"],
      },
    },
    required: [
      "pointId",
      "type",
      "reference",
      "deliveryPointId",
      "suggestedDeliveryPointId",
      "siteId",
      "siteName",
      "networkStatus",
      "networkCheckedAt",
      "latestDataAt",
    ],
  },
  PatrimonyJob: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      version: {
        type: "integer",
      },
      state: {
        type: "string",
        enum: ["prepared", "running", "completed", "partial", "cancelled"],
      },
      createdAt: {
        type: "string",
      },
      operations: {
        type: "array",
        items: {
          $ref: "#/components/schemas/PatrimonyOperation",
        },
      },
    },
    required: ["id", "version", "state", "createdAt", "operations"],
  },
  PatrimonyCreateInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      input: {
        $ref: "#/components/schemas/PatrimonyWorkbook",
      },
      previewToken: {
        type: "string",
      },
      idempotencyKey: {
        type: "string",
        minLength: 16,
        maxLength: 80,
      },
      operationKeys: {
        type: "array",
        maxItems: 100000,
        items: {
          type: "string",
        },
      },
    },
    required: ["input", "previewToken", "idempotencyKey", "operationKeys"],
  },
  PatrimonyPreview: {
    type: "object",
    additionalProperties: false,
    properties: {
      input: {
        $ref: "#/components/schemas/PatrimonyWorkbook",
      },
      token: {
        type: "string",
      },
      expiresAt: {
        type: "string",
      },
      operations: {
        type: "array",
        items: {
          $ref: "#/components/schemas/PatrimonyOperation",
        },
      },
    },
    required: ["input", "token", "expiresAt", "operations"],
  },
  PatrimonyOperation: {
    type: "object",
    additionalProperties: false,
    properties: {
      key: {
        type: "string",
      },
      kind: {
        type: "string",
        enum: [
          "companies",
          "sites",
          "delivery-points",
          "tags",
          "schedule",
          "closures",
        ],
      },
      sheet: {
        type: "string",
      },
      line: {
        type: "integer",
      },
      entityId: {
        type: "string",
      },
      parentId: {
        type: ["string", "null"],
      },
      state: {
        type: "string",
        enum: [
          "ready",
          "ignored",
          "invalid",
          "applied",
          "failed",
          "blocked",
          "cancelled",
        ],
      },
      before: {
        type: ["object", "null"],
        additionalProperties: true,
      },
      after: {
        type: ["object", "null"],
        additionalProperties: true,
      },
      issues: {
        type: "array",
        items: {
          type: "string",
        },
      },
      dependencies: {
        type: "array",
        items: {
          type: "string",
        },
      },
    },
    required: [
      "key",
      "kind",
      "sheet",
      "line",
      "entityId",
      "parentId",
      "state",
      "before",
      "after",
      "issues",
      "dependencies",
    ],
  },
  PatrimonyWorkbook: {
    description:
      "Représentation interne après lecture Excel. Le modèle utilisateur utilise entreprise, site et les champs métier. Les identifiants et révisions nécessaires au traitement sont résolus par le serveur. La feuille Excel PDL est représentée en interne par Points.",
    type: "object",
    additionalProperties: false,
    properties: {
      version: {
        type: "integer",
        const: 2,
      },
      sheets: {
        type: "array",
        minItems: 1,
        maxItems: 6,
        items: {
          $ref: "#/components/schemas/PatrimonySheet",
        },
      },
    },
    required: ["version", "sheets"],
  },
  PatrimonySheet: {
    type: "object",
    additionalProperties: false,
    properties: {
      name: {
        type: "string",
        enum: [
          "Entreprises",
          "Sites",
          "Points",
          "Catégories",
          "Horaires",
          "Fermetures",
        ],
      },
      columns: {
        type: "array",
        maxItems: 40,
        items: {
          type: "string",
        },
      },
      rows: {
        type: "array",
        maxItems: 30000,
        items: {
          type: "array",
          maxItems: 40,
          items: {
            type: "string",
            maxLength: 2000,
          },
        },
      },
    },
    required: ["name", "columns", "rows"],
  },
  MandatePointImportResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      rows: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandatePointImportRow",
        },
      },
    },
    required: ["rows"],
  },
  MandatePointImportRow: {
    type: "object",
    additionalProperties: false,
    properties: {
      line: {
        type: "integer",
      },
      type: {
        type: "string",
      },
      reference: {
        type: "string",
      },
      issues: {
        type: "array",
        items: {
          type: "string",
        },
      },
    },
    required: ["line", "type", "reference", "issues"],
  },
  ImportWorkbookFile: {
    type: "object",
    additionalProperties: false,
    properties: {
      filename: {
        type: "string",
      },
      base64: {
        type: "string",
        maxLength: 7000000,
      },
    },
    required: ["filename", "base64"],
  },
  AtrdSettings: {
    type: "object",
    additionalProperties: false,
    required: ["enabled", "scheduleTime"],
    properties: {
      enabled: {
        type: "boolean",
      },
      scheduleTime: {
        type: "string",
        pattern: "^([01]\\d|2[0-3]):[0-5]\\d$",
      },
      weekDay: {
        type: "integer",
        minimum: 0,
        maximum: 6,
      },
      monthDay: {
        type: "integer",
        minimum: 1,
        maximum: 28,
      },
    },
  },
  AtrdDocument: {
    type: "object",
    additionalProperties: false,
    required: [
      "id",
      "title",
      "decisionNumber",
      "documentOn",
      "effectiveOn",
      "pageUrl",
      "sourceUrl",
      "retrievedAt",
      "sizeBytes",
    ],
    properties: {
      id: {
        type: "string",
        pattern: "^[a-f0-9]{64}$",
      },
      title: {
        type: "string",
      },
      decisionNumber: {
        type: ["string", "null"],
      },
      documentOn: {
        type: ["string", "null"],
      },
      effectiveOn: {
        type: ["string", "null"],
      },
      pageUrl: {
        type: "string",
      },
      sourceUrl: {
        type: "string",
      },
      retrievedAt: {
        type: "string",
      },
      sizeBytes: {
        type: "integer",
        minimum: 1,
      },
    },
  },
  AtrdStatus: {
    type: "object",
    additionalProperties: false,
    required: [
      "settings",
      "nextRunAt",
      "running",
      "lastCheckedAt",
      "errors",
      "summary",
      "documents",
    ],
    properties: {
      settings: {
        $ref: "#/components/schemas/AtrdSettings",
      },
      nextRunAt: {
        type: ["string", "null"],
      },
      running: {
        type: "boolean",
      },
      lastCheckedAt: {
        type: ["string", "null"],
      },
      errors: {
        type: "array",
        items: {
          type: "string",
        },
      },
      summary: {
        type: ["string", "null"],
      },
      documents: {
        type: "array",
        items: {
          $ref: "#/components/schemas/AtrdDocument",
        },
      },
    },
  },
  InvoiceImportInput: {
    type: "object",
    additionalProperties: false,
    required: ["scope", "file"],
    properties: {
      scope: {
        $ref: "#/components/schemas/DataScope",
      },
      file: {
        $ref: "#/components/schemas/ReferenceImportFile",
      },
      token: {
        type: "string",
        maxLength: 100,
      },
    },
  },
  InvoiceImportRow: {
    type: "object",
    additionalProperties: false,
    required: ["line", "status", "messages", "invoice"],
    properties: {
      line: {
        type: "integer",
      },
      status: {
        type: "string",
        enum: ["importable", "duplicate", "error"],
      },
      messages: {
        type: "array",
        items: {
          type: "string",
        },
      },
      invoice: {
        anyOf: [
          {
            $ref: "#/components/schemas/SupplierInvoiceInput",
          },
          {
            type: "null",
          },
        ],
      },
    },
  },
  InvoiceImportPreview: {
    type: "object",
    additionalProperties: false,
    required: ["token", "expiresAt", "rows"],
    properties: {
      token: {
        type: "string",
      },
      expiresAt: {
        type: "string",
      },
      rows: {
        type: "array",
        items: {
          $ref: "#/components/schemas/InvoiceImportRow",
        },
      },
    },
  },
  InvoiceImportResult: {
    type: "object",
    additionalProperties: false,
    required: ["created", "duplicates"],
    properties: {
      created: {
        type: "integer",
      },
      duplicates: {
        type: "integer",
      },
    },
  },
  ScopeAnalysisInput: {
    description:
      "Pour energy=gas, les dates locales Europe/Paris de periodStart et periodEnd sont bornées à 06:00, début inclus et fin exclue. La provenance des résultats restitue les instants effectifs.",
    type: "object",
    additionalProperties: false,
    required: ["scope", "code", "periodStart", "periodEnd"],
    properties: {
      scope: {
        $ref: "#/components/schemas/DataScope",
      },
      code: {
        $ref: "#/components/schemas/AnalysisCode",
      },
      energy: {
        type: "string",
        enum: ["electricity", "gas", "total"],
      },
      periodStart: {
        type: "string",
        format: "date-time",
      },
      periodEnd: {
        type: "string",
        format: "date-time",
      },
    },
  },
  ScopeAnalysisResult: {
    type: "object",
    additionalProperties: false,
    required: [
      "scope",
      "scopeLabel",
      "primary",
      "code",
      "results",
      "metrics",
      "coverageRatio",
      "method",
      "warnings",
    ],
    properties: {
      scope: {
        $ref: "#/components/schemas/DataScope",
      },
      scopeLabel: {
        type: "string",
      },
      primary: {
        $ref: "#/components/schemas/ScopeAnalysisChart",
      },
      code: {
        $ref: "#/components/schemas/AnalysisCode",
      },
      results: {
        type: "array",
        items: {
          type: "object",
          additionalProperties: false,
          required: ["siteId", "pointId", "label", "result"],
          properties: {
            siteId: {
              type: "string",
            },
            pointId: {
              type: "string",
            },
            label: {
              type: "string",
            },
            result: {
              $ref: "#/components/schemas/AnalysisResponse",
            },
          },
        },
      },
      metrics: {
        type: "array",
        items: {
          $ref: "#/components/schemas/AnalysisMetric",
        },
      },
      coverageRatio: {
        type: "number",
        minimum: 0,
        maximum: 1,
      },
      method: {
        type: "string",
      },
      warnings: {
        type: "array",
        items: {
          type: "string",
        },
      },
    },
  },
  ScopeAnalysisRow: {
    type: "object",
    additionalProperties: false,
    required: [
      "label",
      "x",
      "value",
      "comparison",
      "lower",
      "upper",
      "coverage",
    ],
    properties: {
      label: {
        type: "string",
      },
      x: {
        type: ["number", "null"],
      },
      value: {
        type: ["number", "null"],
      },
      comparison: {
        type: ["number", "null"],
      },
      lower: {
        type: ["number", "null"],
      },
      upper: {
        type: ["number", "null"],
      },
      coverage: {
        type: "number",
        minimum: 0,
        maximum: 1,
      },
    },
  },
  ScopeAnalysisChart: {
    type: "object",
    additionalProperties: false,
    required: [
      "title",
      "kind",
      "unit",
      "xLabel",
      "valueLabel",
      "comparisonLabel",
      "rows",
      "metrics",
      "method",
      "warnings",
      "sourceIds",
      "freshAt",
      "synthetic",
      "timezone",
    ],
    properties: {
      title: {
        type: "string",
      },
      kind: {
        type: "string",
        enum: ["heatmap", "line", "bar", "scatter"],
      },
      unit: {
        type: "string",
      },
      xLabel: {
        type: "string",
      },
      valueLabel: {
        type: "string",
      },
      comparisonLabel: {
        type: "string",
      },
      rows: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ScopeAnalysisRow",
        },
      },
      metrics: {
        type: "array",
        items: {
          $ref: "#/components/schemas/AnalysisMetric",
        },
      },
      method: {
        type: "string",
      },
      warnings: {
        type: "array",
        items: {
          type: "string",
        },
      },
      sourceIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
      freshAt: {
        type: ["string", "null"],
      },
      synthetic: {
        type: "boolean",
      },
      timezone: {
        type: "string",
      },
    },
  },
  DataScope: {
    type: "object",
    additionalProperties: false,
    properties: {
      level: {
        type: "string",
        enum: ["brand", "company", "site", "delivery_point"],
      },
      id: {
        type: "string",
        minLength: 1,
        maxLength: 200,
      },
    },
    required: ["level", "id"],
  },
  ExplorerInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      scope: {
        $ref: "#/components/schemas/DataScope",
      },
      from: {
        type: "string",
        format: "date-time",
      },
      to: {
        type: "string",
        format: "date-time",
      },
      timezone: {
        type: "string",
        maxLength: 100,
      },
      cursor: {
        type: "string",
        minLength: 1,
        maxLength: 2000,
      },
      pageSize: {
        type: "integer",
        minimum: 1,
        maximum: 5000,
      },
      step: {
        type: "string",
        enum: ["native", "hour", "day", "month"],
      },
      sourceIds: {
        type: "array",
        items: {
          type: "string",
          maxLength: 250,
        },
        maxItems: 6,
        uniqueItems: true,
      },
    },
    required: ["scope", "from", "to", "timezone", "step", "sourceIds"],
  },
  ExplorerSource: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      label: {
        type: "string",
      },
      unit: {
        type: "string",
        enum: ["kWh", "kW", "m3", "°C"],
      },
      quantity: {
        type: "string",
        enum: ["energy", "power", "volume", "temperature"],
      },
      origin: {
        type: "string",
      },
      steps: {
        type: "array",
        items: {
          type: "string",
          enum: ["native", "hour", "day", "month"],
        },
      },
      sourceIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
      freshAt: {
        type: ["string", "null"],
      },
      synthetic: {
        type: "boolean",
      },
      siteId: {
        type: "string",
      },
      stationId: {
        type: "string",
      },
      siteIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
      availableFrom: {
        type: ["string", "null"],
      },
      availableTo: {
        type: ["string", "null"],
      },
      compatibleUnits: {
        type: "array",
        items: {
          type: "string",
        },
      },
      reason: {
        type: "string",
      },
    },
    required: [
      "id",
      "label",
      "unit",
      "quantity",
      "origin",
      "steps",
      "sourceIds",
      "freshAt",
      "synthetic",
    ],
  },
  ExplorerPoint: {
    type: "object",
    additionalProperties: false,
    properties: {
      from: {
        type: "string",
      },
      to: {
        type: "string",
      },
      value: {
        type: ["number", "null"],
      },
      availableValue: {
        type: ["number", "null"],
      },
      coverage: {
        type: "number",
        minimum: 0,
        maximum: 1,
      },
      contributors: {
        type: "integer",
      },
      expectedContributors: {
        type: "integer",
      },
      quality: {
        type: "string",
      },
    },
    required: [
      "from",
      "to",
      "value",
      "availableValue",
      "coverage",
      "contributors",
      "expectedContributors",
      "quality",
    ],
  },
  ExplorerCurve: {
    type: "object",
    additionalProperties: false,
    properties: {
      source: {
        $ref: "#/components/schemas/ExplorerSource",
      },
      points: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ExplorerPoint",
        },
      },
    },
    required: ["source", "points"],
  },
  ExplorerResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      scope: {
        $ref: "#/components/schemas/DataScope",
      },
      scopeLabel: {
        type: "string",
      },
      timezone: {
        type: "string",
      },
      from: {
        type: "string",
      },
      to: {
        type: "string",
      },
      step: {
        type: "string",
        enum: ["native", "hour", "day", "month"],
      },
      curves: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ExplorerCurve",
        },
      },
      warnings: {
        type: "array",
        items: {
          type: "string",
        },
      },
      calculatedAt: {
        type: "string",
      },
      method: {
        type: "string",
      },
      page: {
        $ref: "#/components/schemas/ExplorerPage",
      },
    },
    required: [
      "scope",
      "scopeLabel",
      "timezone",
      "from",
      "to",
      "step",
      "curves",
      "warnings",
      "calculatedAt",
      "method",
    ],
  },
  ExplorerPage: {
    type: "object",
    additionalProperties: false,
    properties: {
      nextCursor: {
        type: ["string", "null"],
      },
      hasMore: {
        type: "boolean",
      },
      from: {
        type: "string",
      },
      to: {
        type: "string",
      },
      intervals: {
        type: "integer",
      },
    },
    required: ["nextCursor", "hasMore", "from", "to", "intervals"],
  },
  BrandDomain: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      hostname: {
        type: "string",
      },
      primary: {
        type: "boolean",
      },
      verified: {
        type: "boolean",
      },
      verifiedAt: {
        type: "string",
      },
    },
    required: ["id", "hostname", "primary", "verified"],
  },
  BrandStatistics: {
    type: "object",
    additionalProperties: false,
    required: ["brandId", "companies", "sites", "deliveryPoints", "managers"],
    properties: {
      brandId: {
        type: "string",
      },
      companies: {
        type: "integer",
        minimum: 0,
      },
      sites: {
        type: "integer",
        minimum: 0,
      },
      deliveryPoints: {
        type: "integer",
        minimum: 0,
      },
      managers: {
        type: "integer",
        minimum: 0,
      },
    },
  },
  Brand: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      slug: {
        type: "string",
      },
      displayName: {
        type: "string",
      },
      ownerType: {
        $ref: "#/components/schemas/BrandOwnerType",
      },
      ownerId: {
        type: "string",
      },
      logoLightUrl: {
        type: "string",
      },
      logoDarkUrl: {
        type: "string",
      },
      faviconUrl: {
        type: "string",
      },
      primaryColor: {
        type: "string",
      },
      secondaryColor: {
        type: "string",
      },
      supportEmail: {
        type: "string",
      },
      senderName: {
        type: "string",
      },
      senderEmail: {
        type: "string",
      },
      legalNoticeUrl: {
        type: "string",
      },
      privacyPolicyUrl: {
        type: "string",
      },
      defaultLegalEntityId: {
        type: "string",
      },
      legalEntities: {
        type: "array",
        items: {
          $ref: "#/components/schemas/LegalEntity",
        },
      },
      enabledFeatures: {
        type: "array",
        items: {
          type: "string",
        },
      },
      domains: {
        type: "array",
        items: {
          $ref: "#/components/schemas/BrandDomain",
        },
      },
      status: {
        $ref: "#/components/schemas/BrandStatus",
      },
      isDefault: {
        type: "boolean",
      },
      version: {
        type: "number",
      },
      updatedAt: {
        type: "string",
      },
    },
    required: [
      "id",
      "slug",
      "displayName",
      "ownerType",
      "logoLightUrl",
      "logoDarkUrl",
      "faviconUrl",
      "primaryColor",
      "secondaryColor",
      "supportEmail",
      "senderName",
      "senderEmail",
      "legalNoticeUrl",
      "privacyPolicyUrl",
      "enabledFeatures",
      "domains",
      "status",
      "isDefault",
      "version",
      "updatedAt",
    ],
  },
  MeasurementValue: {
    description:
      "Valeur identifiée et révisable. Les révisions fournisseur (`measured`, `estimated`, `missing`) sont partagées par toutes les marques qui portent le compteur ; les corrections manuelles (`corrected`, `missing`) appartiennent à la marque, portent un identifiant préfixé `c` et sont numérotées après la dernière révision fournisseur de l'intervalle. Les calculs utilisent la dernière révision de chaque intervalle.",
    type: "object",
    required: [
      "id",
      "intervalStart",
      "intervalEnd",
      "value",
      "quality",
      "revision",
    ],
    properties: {
      id: {
        type: "string",
      },
      intervalStart: {
        type: "string",
        format: "date-time",
      },
      intervalEnd: {
        type: "string",
        format: "date-time",
      },
      value: {
        type: ["number", "null"],
      },
      quality: {
        enum: ["measured", "estimated", "corrected", "missing"],
      },
      revision: {
        type: "integer",
        minimum: 1,
      },
      supersedesValueId: {
        type: ["string", "null"],
      },
      attributes: {
        type: "object",
        additionalProperties: true,
        description:
          "Faits du fournisseur qui qualifient la valeur sans la remplacer (GRDF : index de début et de fin, volume converti, coefficients, qualification, raison du relevé). Enedis daily : energyBasis vaut index, curve ou unknown pour chaque valeur ; unknown ou absent exclut la valeur du total mesuré. modeCalcul conserve le mode brut R65, flux vaut R65. daily-from-index désigne le calcul depuis R64.",
      },
    },
  },
  GtbAssociationBatchPreview: {
    type: "object",
    additionalProperties: false,
    required: ["hash", "scannedSensors", "groups", "notices"],
    properties: {
      hash: {
        type: ["string", "null"],
      },
      scannedSensors: {
        type: "integer",
        minimum: 0,
      },
      groups: {
        type: "array",
        items: {
          $ref: "#/components/schemas/GtbAssociationPreview",
        },
      },
      notices: {
        type: "array",
        items: {
          $ref: "#/components/schemas/GtbAssociationBatchNotice",
        },
      },
    },
  },
  GtbAssociationBatchNotice: {
    type: "object",
    additionalProperties: false,
    required: ["label", "externalIds", "status", "reason"],
    properties: {
      label: {
        type: "string",
      },
      externalIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
      status: {
        type: "string",
        enum: [
          "blocked",
          "already_associated",
          "disabled",
          "single_version",
          "empty_versions",
        ],
      },
      reason: {
        type: "string",
      },
    },
  },
  GtbAssociationBatchApplyInput: {
    type: "object",
    additionalProperties: false,
    required: ["groups", "hash"],
    properties: {
      groups: {
        type: "array",
        minItems: 1,
        maxItems: 1000,
        items: {
          type: "array",
          minItems: 2,
          maxItems: 100,
          uniqueItems: true,
          items: {
            type: "string",
          },
        },
      },
      hash: {
        type: "string",
        pattern: "^[a-f0-9]{64}$",
      },
    },
  },
  GtbAssociationBatchResult: {
    type: "object",
    additionalProperties: false,
    required: ["appliedGroups"],
    properties: {
      appliedGroups: {
        type: "integer",
        minimum: 0,
      },
    },
  },
  GtbAssociationInput: {
    type: "object",
    additionalProperties: false,
    required: ["externalIds", "enabled"],
    properties: {
      externalIds: {
        type: "array",
        minItems: 2,
        maxItems: 100,
        uniqueItems: true,
        description:
          "Identifiants WIT complets, de la version la plus ancienne à la plus récente.",
        items: {
          type: "string",
        },
      },
      enabled: {
        type: "boolean",
      },
    },
  },
  GtbAssociationApplyInput: {
    type: "object",
    additionalProperties: false,
    required: ["externalIds", "enabled", "hash"],
    properties: {
      externalIds: {
        type: "array",
        minItems: 2,
        maxItems: 100,
        uniqueItems: true,
        description:
          "Identifiants WIT complets, de la version la plus ancienne à la plus récente.",
        items: {
          type: "string",
        },
      },
      enabled: {
        type: "boolean",
      },
      hash: {
        type: "string",
        pattern: "^[a-f0-9]{64}$",
      },
    },
  },
  GtbAssociationPreview: {
    type: "object",
    additionalProperties: false,
    required: ["hash", "enabled", "logicalSensorId", "label", "members"],
    properties: {
      hash: {
        type: "string",
      },
      enabled: {
        type: "boolean",
      },
      logicalSensorId: {
        type: "string",
      },
      label: {
        type: "string",
      },
      members: {
        type: "array",
        items: {
          $ref: "#/components/schemas/GtbAssociationMember",
        },
      },
    },
  },
  GtbAssociationMember: {
    type: "object",
    additionalProperties: false,
    required: [
      "sensorId",
      "externalId",
      "label",
      "unit",
      "valueCount",
      "firstAt",
      "lastAt",
      "firstIndex",
      "lastIndex",
      "indexUnit",
    ],
    properties: {
      sensorId: {
        type: "string",
      },
      externalId: {
        type: "string",
      },
      label: {
        type: "string",
      },
      unit: {
        type: "string",
      },
      valueCount: {
        type: "integer",
        minimum: 0,
      },
      firstAt: {
        type: ["string", "null"],
        format: "date-time",
      },
      lastAt: {
        type: ["string", "null"],
        format: "date-time",
      },
      firstIndex: {
        type: ["number", "null"],
      },
      lastIndex: {
        type: ["number", "null"],
      },
      indexUnit: {
        type: ["string", "null"],
      },
    },
  },
  GtbOverview: {
    description:
      "Écran de rattachement des GTB : les GTB connues et les Sites actifs auxquels une GTB peut être rattachée.",
    type: "object",
    additionalProperties: false,
    required: ["installations", "sites"],
    properties: {
      installations: {
        type: "array",
        items: {
          $ref: "#/components/schemas/GtbInstallation",
        },
      },
      sites: {
        type: "array",
        items: {
          $ref: "#/components/schemas/GtbSiteOption",
        },
      },
    },
  },
  GtbSiteOption: {
    description: "Site actif d'une marque, candidat au rattachement d'une GTB.",
    type: "object",
    additionalProperties: false,
    required: [
      "brandId",
      "brandName",
      "companyId",
      "companyName",
      "siteId",
      "siteName",
    ],
    properties: {
      brandId: {
        type: "string",
      },
      brandName: {
        type: "string",
      },
      companyId: {
        type: "string",
      },
      companyName: {
        type: "string",
      },
      siteId: {
        type: "string",
      },
      siteName: {
        type: "string",
      },
    },
  },
  GtbInstallation: {
    description:
      "GTB raccordée par un connecteur (WIT : identifiant `WAC…`), rattachée ou non à un Site, avec ses capteurs.",
    type: "object",
    additionalProperties: false,
    required: [
      "id",
      "connectorId",
      "provider",
      "externalId",
      "discoveredAt",
      "lastSeenAt",
      "attachment",
      "fluxes",
      "items",
    ],
    properties: {
      id: {
        type: "string",
      },
      connectorId: {
        type: "string",
      },
      provider: {
        type: "string",
        enum: ["wit"],
      },
      externalId: {
        type: "string",
        description:
          "Identifiant de la GTB chez le fournisseur (WIT : `WAC…`).",
      },
      discoveredAt: {
        type: "string",
        format: "date-time",
      },
      lastSeenAt: {
        type: "string",
        format: "date-time",
        description: "Dernière collecte qui a lu la GTB chez le fournisseur.",
      },
      attachment: {
        oneOf: [
          {
            $ref: "#/components/schemas/GtbAttachment",
          },
          {
            type: "null",
          },
        ],
      },
      fluxes: {
        type: "array",
        description:
          "Flux de la GTB, tels que la dernière collecte ou liste des flux les a relus.",
        items: {
          $ref: "#/components/schemas/GtbFlux",
        },
      },
      items: {
        type: "array",
        items: {
          $ref: "#/components/schemas/GtbInstallationItem",
        },
      },
    },
  },
  GtbFlux: {
    description:
      "Flux d'une GTB (WIT : un flux regroupe des fluxItems), tel que le connecteur l'a relu chez le fournisseur.",
    type: "object",
    additionalProperties: false,
    required: [
      "id",
      "externalId",
      "extKey",
      "label",
      "period",
      "providerStatus",
      "firstPointAt",
      "lastPointAt",
      "active",
    ],
    properties: {
      id: {
        type: "string",
      },
      externalId: {
        type: "string",
        description: "Identifiant du flux chez le fournisseur.",
      },
      extKey: {
        type: "string",
      },
      label: {
        type: "string",
      },
      period: {
        type: "string",
        description:
          "Période d'échange annoncée (`1ho` : horaire, `10mi` : 10 minutes…).",
      },
      providerStatus: {
        type: "string",
        description: "Statut chez le fournisseur (`validated`, `toValidate`…).",
      },
      firstPointAt: {
        type: ["string", "null"],
        format: "date-time",
      },
      lastPointAt: {
        type: ["string", "null"],
        format: "date-time",
      },
      active: {
        type: "boolean",
        description: "`false` : le fournisseur ne publie plus ce flux.",
      },
    },
  },
  GtbAttachment: {
    description:
      "Rattachement d'une GTB à un Site, et points internes créés pour ses capteurs.",
    type: "object",
    additionalProperties: false,
    required: [
      "brandId",
      "brandName",
      "companyId",
      "companyName",
      "siteId",
      "siteName",
      "attachedAt",
      "pointCount",
    ],
    properties: {
      brandId: {
        type: "string",
      },
      brandName: {
        type: "string",
      },
      companyId: {
        type: "string",
      },
      companyName: {
        type: "string",
      },
      siteId: {
        type: "string",
      },
      siteName: {
        type: "string",
      },
      attachedAt: {
        type: "string",
        format: "date-time",
      },
      attachedBy: {
        type: "string",
        description: "Nom du super-admin qui a rattaché la GTB.",
      },
      pointCount: {
        type: "integer",
        minimum: 0,
        description:
          "Points internes présents dans le Site pour les capteurs de la GTB.",
      },
    },
  },
  WitHistoryProgress: {
    type: "object",
    additionalProperties: false,
    required: ["status", "from", "to", "pagesRead", "pointsRead"],
    properties: {
      status: {
        type: "string",
        enum: ["pending", "complete"],
      },
      from: {
        type: "string",
        format: "date-time",
      },
      to: {
        type: "string",
        format: "date-time",
      },
      pagesRead: {
        type: "integer",
        minimum: 0,
      },
      pointsRead: {
        type: "integer",
        minimum: 0,
      },
    },
  },
  GtbInstallationItem: {
    description:
      "Capteur d'une GTB (WIT : un fluxItem). Un capteur d'index porte un compteur interne de plateforme et, quand la GTB est rattachée, un point interne dans le Site.",
    type: "object",
    additionalProperties: false,
    required: [
      "sensorId",
      "externalId",
      "label",
      "kind",
      "unit",
      "active",
      "meterReference",
      "deliveryPointId",
      "valueCount",
      "lastAt",
      "fluxId",
      "extKey",
    ],
    properties: {
      logicalSensor: {
        type: "object",
        additionalProperties: false,
        required: ["id", "label", "representativeSensorId", "externalIds"],
        description:
          "Rapprochement explicite actif, réservé à la consultation de plateforme ; les sources et droits de marque restent distincts.",
        properties: {
          id: {
            type: "string",
          },
          label: {
            type: "string",
          },
          representativeSensorId: {
            type: "string",
          },
          externalIds: {
            type: "array",
            items: {
              type: "string",
            },
          },
        },
      },
      sensorId: {
        type: "string",
      },
      lastValueAt: {
        type: ["string", "null"],
        format: "date-time",
        description:
          "Date de la dernière valeur affichée ; horodatage WIT des observations instantanées ou fin d’heure enregistrée pour un index, distincte de lastAt si la dernière mesure est invalide.",
      },
      lastValueUnit: {
        type: ["string", "null"],
        description:
          "Unité de la dernière valeur affichée, issue de indexUnit pour les compteurs (Wh, kWh ou m3), sans conversion en consommation.",
      },
      lastValueText: {
        type: ["string", "null"],
        description:
          "Dernier état textuel enregistré du reflet ; null pour une valeur numérique ou sans observation. Seuls les changements textuels sont historisés.",
      },
      lastValue: {
        type: ["number", "null"],
        description:
          "Dernière observation numérique (fluxItem instantané ou reflet) ou dernier index de fin d’heure WIT issu des attributs de la mesure courante ; jamais la consommation horaire calculée. Null sans valeur valide disponible.",
      },
      lastCollectedAt: {
        type: ["string", "null"],
        format: "date-time",
        description:
          "Dernière lecture fournisseur valide et enregistrée avec succès ; indépendante de la dernière observation.",
      },
      history: {
        $ref: "#/components/schemas/WitHistoryProgress",
      },
      fluxId: {
        type: ["string", "null"],
        description:
          "Flux du capteur (`GtbFlux.id`) ; `null` avant la première liste des flux.",
      },
      extKey: {
        type: "string",
        description: "Clé du fluxItem chez le fournisseur ; vide si inconnue.",
      },
      externalId: {
        type: "string",
      },
      label: {
        type: "string",
      },
      kind: {
        type: "string",
        enum: ["energy", "power", "temperature", "state", "setpoint", "other"],
        description:
          "`energy` : index cumulé converti en énergie ou volume horaire.",
      },
      unit: {
        type: "string",
        description:
          "Unité appliquée à l'index (Wh, kWh, m3) ou unité de la grandeur.",
      },
      active: {
        type: "boolean",
      },
      meterReference: {
        type: ["string", "null"],
        description:
          "Référence du compteur interne (`WIT-<WAC>-<fluxItem>`), pour un index.",
      },
      deliveryPointId: {
        type: ["string", "null"],
        description: "Point interne créé dans le Site de rattachement.",
      },
      valueCount: {
        type: "integer",
        minimum: 0,
        description: "Valeurs horaires courantes de la série du compteur.",
      },
      firstAt: {
        type: ["string", "null"],
        format: "date-time",
        description:
          "Début du premier intervalle horaire enregistré pour un index, ou date de la première observation enregistrée pour un signal/reflet. Null en absence de valeur ; ne reprend pas une date de découverte ou de premier point annoncé par le fournisseur.",
      },
      lastAt: {
        type: ["string", "null"],
        format: "date-time",
        description: "Fin de la dernière valeur écrite.",
      },
    },
  },
  GtbSensorValues: {
    type: "object",
    additionalProperties: false,
    required: [
      "sensorId",
      "unit",
      "from",
      "to",
      "bucket",
      "total",
      "latestAt",
      "values",
    ],
    properties: {
      sensorId: {
        type: "string",
      },
      unit: {
        type: "string",
      },
      from: {
        type: "string",
        format: "date-time",
      },
      to: {
        type: "string",
        format: "date-time",
      },
      bucket: {
        type: "string",
        enum: ["raw", "hour", "day"],
      },
      aggregation: {
        type: "string",
        enum: ["raw", "mean", "min", "max", "last"],
      },
      total: {
        type: "integer",
        minimum: 0,
      },
      latestAt: {
        type: ["string", "null"],
        format: "date-time",
      },
      values: {
        type: "array",
        items: {
          $ref: "#/components/schemas/GtbObservation",
        },
      },
    },
  },
  GtbObservation: {
    type: "object",
    additionalProperties: false,
    required: ["at", "value", "quality", "samples"],
    properties: {
      at: {
        type: "string",
        format: "date-time",
      },
      value: {
        type: ["number", "null"],
      },
      valueText: {
        type: ["string", "null"],
        description:
          "État textuel WIT ; exclusif de value. En agrégation, dernière observation du créneau contenant du texte.",
      },
      quality: {
        type: "string",
        enum: ["measured", "estimated", "provisional", "missing"],
      },
      samples: {
        type: "integer",
        minimum: 0,
      },
    },
  },
  GtbAttachmentInput: {
    description: "Site (et sa marque) auquel rattacher une GTB.",
    type: "object",
    additionalProperties: false,
    required: ["brandId", "siteId"],
    properties: {
      brandId: {
        type: "string",
        minLength: 1,
      },
      siteId: {
        type: "string",
        minLength: 1,
      },
    },
  },
  MeteringPointSeries: {
    description:
      "Série de mesure d'un compteur vue de la plateforme, sans marque : ce que les connecteurs y ont écrit. Sert à la vérification visuelle des données d'un PRM ou d'un PCE.",
    type: "object",
    additionalProperties: false,
    required: [
      "id",
      "label",
      "unit",
      "granularity",
      "source",
      "freshAt",
      "valueCount",
    ],
    properties: {
      id: {
        type: "string",
      },
      kind: {
        type: ["string", "null"],
        description:
          "Nature dans la source (`cdc`, `daily`, `daily-from-index`, `pmax`, `index:HPH`, `billing:HPH`…).",
      },
      label: {
        type: "string",
      },
      unit: {
        type: "string",
        enum: ["kWh", "kW", "m3", "degC", "VA", "W", "kvar", "kvarh"],
      },
      granularity: {
        type: "string",
        enum: [
          "ten_minutes",
          "thirty_minutes",
          "hour",
          "day",
          "month",
          "period",
        ],
      },
      intervalSeconds: {
        type: ["integer", "null"],
      },
      source: {
        type: "string",
      },
      freshAt: {
        type: "string",
        format: "date-time",
      },
      valueCount: {
        type: "integer",
        minimum: 0,
      },
      firstAt: {
        type: ["string", "null"],
        description: "Début du premier intervalle publié.",
      },
      lastAt: {
        type: ["string", "null"],
        description: "Fin du dernier intervalle publié.",
      },
    },
  },
  MeteringPointMeasurements: {
    description:
      "Page de valeurs d'une série d'un compteur, brutes ou agrégées.",
    type: "object",
    additionalProperties: false,
    required: ["series", "total", "bucket", "values"],
    properties: {
      series: {
        $ref: "#/components/schemas/MeteringPointSeries",
      },
      total: {
        type: "integer",
        minimum: 0,
        description:
          "Intervalles (ou agrégats) de la période, toutes pages confondues.",
      },
      bucket: {
        type: "string",
        enum: ["raw", "hour", "day"],
      },
      values: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MeasurementValue",
        },
      },
    },
  },
  MeasurementCorrectionResult: {
    description:
      "Résultat ciblé d’une correction, suffisant pour mettre à jour le client sans retransmettre tout le portefeuille.",
    type: "object",
    additionalProperties: false,
    required: ["seriesId", "measurement", "auditEvent"],
    properties: {
      seriesId: {
        type: "string",
      },
      measurement: {
        $ref: "#/components/schemas/MeasurementValue",
      },
      auditEvent: {
        $ref: "#/components/schemas/AuditEvent",
      },
    },
  },
  DataGap: {
    type: "object",
    required: ["start", "end", "status"],
    properties: {
      start: {
        type: "string",
        format: "date-time",
      },
      end: {
        type: "string",
        format: "date-time",
      },
      reason: {
        type: "string",
      },
      status: {
        enum: ["open", "acknowledged", "resolved"],
      },
    },
  },
  StoredDocument: {
    type: "object",
    required: ["id", "name", "mimeType", "sha256"],
    properties: {
      id: {
        type: "string",
      },
      name: {
        type: "string",
      },
      mimeType: {
        type: "string",
      },
      sha256: {
        type: "string",
      },
    },
  },
  MandateCase: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      brandSnapshot: {
        $ref: "#/components/schemas/MandateBrandSnapshot",
      },
      companyId: {
        type: "string",
      },
      beneficiaryLegalEntityId: {
        type: "string",
      },
      beneficiarySnapshot: {
        $ref: "#/components/schemas/MandateBeneficiarySnapshot",
      },
      mode: {
        $ref: "#/components/schemas/MandateMode",
      },
      parties: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandatePartySnapshot",
        },
      },
      signers: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandateSignatureParticipant",
        },
      },
      flow: {
        $ref: "#/components/schemas/MandateFlow",
      },
      status: {
        $ref: "#/components/schemas/MandateStatus",
      },
      purpose: {
        type: "string",
      },
      privacyContactEmail: {
        type: "string",
      },
      holder: {
        $ref: "#/components/schemas/MandateHolderSnapshot",
      },
      signer: {
        $ref: "#/components/schemas/MandateSignerSnapshot",
      },
      points: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandatePointSnapshot",
        },
      },
      permissions: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandateDataCategory",
        },
      },
      validFrom: {
        type: "string",
      },
      validUntil: {
        type: ["string", "null"],
        description:
          "Date de fin d'un ancien mandat à durée déterminée. Null pour les nouveaux mandats, valables sans limite de durée jusqu'à révocation.",
      },
      historicalDataFrom: {
        type: "string",
        description:
          "Début figé des 24 mois calendaires précédant la création du mandat.",
      },
      historicalDataUntil: {
        type: "string",
        description:
          "Date de création du mandat, fin figée de la période historique demandée.",
      },
      documentVersion: {
        type: "string",
      },
      revision: {
        type: "integer",
      },
      createdByUserId: {
        type: "string",
      },
      createdAt: {
        type: "string",
      },
      updatedAt: {
        type: "string",
      },
      submittedAt: {
        type: "string",
      },
      signedAt: {
        type: "string",
      },
      revokedAt: {
        type: "string",
      },
      signatureRequest: {
        $ref: "#/components/schemas/MandateSignatureRequest",
      },
      collectionInvitation: {
        $ref: "#/components/schemas/MandateCollectionInvitation",
      },
      siteId: {
        type: "string",
        description:
          "Site ciblé facultatif ; absent pour une demande Entreprise.",
      },
      createdByMembershipId: {
        type: "string",
        description:
          "Membership à l’origine de la préparation ; ne remplace pas les grants sur les points existants.",
      },
    },
    required: [
      "id",
      "brandId",
      "brandSnapshot",
      "beneficiaryLegalEntityId",
      "beneficiarySnapshot",
      "mode",
      "parties",
      "signers",
      "flow",
      "status",
      "purpose",
      "privacyContactEmail",
      "holder",
      "signer",
      "points",
      "permissions",
      "validUntil",
      "historicalDataFrom",
      "historicalDataUntil",
      "documentVersion",
      "revision",
      "createdByUserId",
      "createdAt",
      "updatedAt",
    ],
  },
  Role: {
    type: "string",
    enum: ["super_admin", "manager", "client"],
  },
  UserStatus: {
    type: "string",
    enum: ["invited", "active", "suspended", "disabled"],
  },
  Energy: {
    type: "string",
    enum: ["electricity", "gas", "gtb"],
  },
  Quality: {
    type: "string",
    enum: ["complete", "partial", "missing"],
  },
  ScopeLevel: {
    type: "string",
    enum: ["brand", "site", "delivery_point"],
  },
  GrantScope: {
    $ref: "#/components/schemas/ScopeLevel",
  },
  PublicationStatus: {
    type: "string",
    enum: ["draft", "published", "archived"],
  },
  WorkflowStage: {
    type: "string",
    enum: [
      "detected",
      "pending_review",
      "confirmed",
      "rejected",
      "resolved",
      "accepted",
      "planned",
      "in_progress",
      "completed",
    ],
  },
  MandateFlow: {
    type: "string",
    enum: ["prefilled", "self_service"],
  },
  MandateMode: {
    type: "string",
    enum: ["direct", "maintainer"],
  },
  MandatePartyRole: {
    type: "string",
    enum: ["contract_holder", "principal", "beneficiary"],
  },
  MandateParticipantStatus: {
    type: "string",
    enum: ["pending", "invited", "signed", "declined", "error"],
  },
  MandateStatus: {
    type: "string",
    enum: [
      "draft",
      "ready",
      "sent",
      "opened",
      "submitted",
      "signature_pending",
      "signed",
      "activation_pending",
      "active",
      "refused",
      "expired",
      "revoked",
      "activation_failed",
    ],
  },
  MandateSignerCapacity: {
    type: "string",
    enum: ["legal_representative", "delegate", "authorized_contact"],
  },
  MandateDataCategory: {
    type: "string",
    enum: [
      "technical",
      "contractual",
      "published_consumption",
      "informative_consumption",
      "load_curve",
      "billing",
    ],
  },
  BrandOwnerType: {
    type: "string",
    enum: ["internal", "company", "partner"],
  },
  BrandStatus: {
    type: "string",
    enum: ["draft", "active", "suspended", "archived"],
  },
  MandateBrandSnapshot: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      displayName: {
        type: "string",
      },
      logoUrl: {
        type: "string",
      },
      primaryColor: {
        type: "string",
      },
      supportEmail: {
        type: "string",
      },
      senderName: {
        type: "string",
      },
      senderEmail: {
        type: "string",
      },
    },
    required: [
      "id",
      "displayName",
      "logoUrl",
      "primaryColor",
      "supportEmail",
      "senderName",
      "senderEmail",
    ],
  },
  MandateHolderSnapshot: {
    type: "object",
    additionalProperties: false,
    properties: {
      legalName: {
        type: "string",
      },
      tradeName: {
        type: "string",
      },
      legalForm: {
        type: "string",
      },
      siren: {
        type: "string",
      },
      siret: {
        type: "string",
      },
      address: {
        type: "string",
      },
      postalCode: {
        type: "string",
      },
      city: {
        type: "string",
      },
    },
    required: [
      "legalName",
      "tradeName",
      "legalForm",
      "siren",
      "siret",
      "address",
      "postalCode",
      "city",
    ],
  },
  MandateRepresentativeSnapshot: {
    type: "object",
    additionalProperties: false,
    properties: {
      firstName: {
        type: "string",
      },
      lastName: {
        type: "string",
      },
      email: {
        type: "string",
      },
      phone: {
        type: "string",
      },
      jobTitle: {
        type: "string",
      },
    },
    required: ["firstName", "lastName", "email", "jobTitle"],
  },
  MandateBeneficiarySnapshot: {
    type: "object",
    additionalProperties: false,
    properties: {
      legalEntity: {
        $ref: "#/components/schemas/MandateHolderSnapshot",
      },
      representative: {
        $ref: "#/components/schemas/MandateRepresentativeSnapshot",
      },
    },
    required: ["legalEntity", "representative"],
  },
  MandatePartySnapshot: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      roles: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandatePartyRole",
        },
      },
      legalEntity: {
        $ref: "#/components/schemas/MandateHolderSnapshot",
      },
      representative: {
        $ref: "#/components/schemas/MandateRepresentativeSnapshot",
      },
    },
    required: ["id", "roles", "legalEntity"],
  },
  MandateSignerSnapshot: {
    type: "object",
    additionalProperties: false,
    properties: {
      firstName: {
        type: "string",
      },
      lastName: {
        type: "string",
      },
      email: {
        type: "string",
      },
      phone: {
        type: "string",
      },
      jobTitle: {
        type: "string",
      },
      capacity: {
        $ref: "#/components/schemas/MandateSignerCapacity",
      },
    },
    required: [
      "firstName",
      "lastName",
      "email",
      "phone",
      "jobTitle",
      "capacity",
    ],
  },
  MandateSignatureParticipant: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      partyId: {
        type: "string",
      },
      signer: {
        $ref: "#/components/schemas/MandateSignerSnapshot",
      },
      required: {
        type: "boolean",
      },
      signingOrder: {
        type: "integer",
      },
      status: {
        $ref: "#/components/schemas/MandateParticipantStatus",
      },
      externalId: {
        type: "string",
      },
    },
    required: ["id", "partyId", "signer", "required", "signingOrder", "status"],
  },
  MandatePointSnapshot: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
        description: "Identifiant de déclaration attribué par le serveur.",
      },
      deliveryPointId: {
        type: "string",
      },
      type: {
        type: "string",
        enum: ["PRM", "PCE"],
      },
      reference: {
        type: "string",
      },
      label: {
        type: "string",
      },
      energy: {
        type: "string",
        enum: ["electricity", "gas"],
      },
      provider: {
        type: "string",
      },
      siteName: {
        type: "string",
      },
      holderLegalName: {
        type: "string",
      },
      holderSiret: {
        type: "string",
      },
      address: {
        type: "string",
      },
      postalCode: {
        type: "string",
      },
      city: {
        type: "string",
      },
      holderPartyId: {
        type: "string",
      },
    },
    required: ["type", "reference"],
  },
  MandateSignatureRequest: {
    type: "object",
    additionalProperties: false,
    properties: {
      provider: {
        const: "youtrust",
        type: "string",
      },
      environment: {
        type: "string",
        enum: ["sandbox", "production"],
      },
      externalId: {
        type: "string",
      },
      status: {
        type: "string",
      },
      createdAt: {
        type: "string",
      },
      activatedAt: {
        type: "string",
      },
      signedAt: {
        type: "string",
      },
      requestKey: {
        type: "string",
      },
      documentRevision: {
        type: "integer",
      },
      documentSha256: {
        type: "string",
      },
      signers: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandateProviderSigner",
        },
      },
      signedDocumentSha256: {
        type: "string",
      },
      auditTrailSha256: {
        type: "string",
      },
    },
    required: [
      "provider",
      "environment",
      "externalId",
      "status",
      "createdAt",
      "requestKey",
      "documentRevision",
      "documentSha256",
      "signers",
    ],
  },
  MandateProviderSigner: {
    type: "object",
    additionalProperties: false,
    properties: {
      participantId: {
        type: "string",
      },
      externalId: {
        type: "string",
      },
      status: {
        $ref: "#/components/schemas/MandateParticipantStatus",
      },
      fieldIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
    },
    required: ["participantId", "status", "fieldIds"],
  },
  MandateDraftInput: {
    type: "object",
    additionalProperties: false,
    description:
      "Données métier saisissables. Le serveur ajoute automatiquement les 24 mois d'historique précédant la création et une validité sans échéance jusqu'à révocation.",
    properties: {
      companyId: {
        type: "string",
      },
      flow: {
        $ref: "#/components/schemas/MandateFlow",
      },
      mode: {
        $ref: "#/components/schemas/MandateMode",
      },
      holder: {
        $ref: "#/components/schemas/MandateHolderSnapshot",
      },
      signer: {
        $ref: "#/components/schemas/MandateSignerSnapshot",
      },
      principal: {
        $ref: "#/components/schemas/MandateHolderSnapshot",
      },
      principalSigner: {
        $ref: "#/components/schemas/MandateSignerSnapshot",
      },
      principalSignatureRequired: {
        type: "boolean",
      },
      points: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandatePointSnapshot",
        },
      },
      permissions: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandateDataCategory",
        },
      },
      expectedRevision: {
        type: "integer",
      },
      siteId: {
        type: "string",
        description:
          "Site ciblé facultatif ; absent pour une demande Entreprise.",
      },
    },
    required: [
      "flow",
      "mode",
      "holder",
      "signer",
      "principalSignatureRequired",
      "points",
      "permissions",
    ],
  },
  MandateFormDraft: {
    type: "object",
    additionalProperties: false,
    properties: {
      payload: {
        $ref: "#/components/schemas/MandateDraftInput",
      },
      revision: {
        type: "integer",
        minimum: 1,
      },
      updatedAt: {
        type: "string",
        format: "date-time",
      },
    },
    required: ["payload", "revision", "updatedAt"],
  },
  SaveMandateFormDraftInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      payload: {
        $ref: "#/components/schemas/MandateDraftInput",
      },
      expectedRevision: {
        type: "integer",
        minimum: 1,
      },
    },
    required: ["payload"],
  },
  MandatePublicLink: {
    type: "object",
    additionalProperties: false,
    properties: {
      mandateCaseId: {
        type: "string",
      },
      url: {
        type: "string",
      },
      expiresAt: {
        type: "string",
      },
    },
    required: ["mandateCaseId", "url", "expiresAt"],
  },
  MandateCollectionInvitation: {
    type: "object",
    additionalProperties: false,
    properties: {
      channel: {
        type: "string",
        enum: ["email", "manual"],
      },
      status: {
        type: "string",
        enum: ["sent", "not_requested", "not_configured", "failed"],
      },
      provider: {
        type: "string",
        enum: ["postmark", "manual"],
      },
      recipient: {
        type: "string",
      },
      providerMessageId: {
        type: "string",
      },
      sentAt: {
        type: "string",
      },
      lastError: {
        type: "string",
      },
    },
    required: ["channel", "status", "provider"],
  },
  MandatePublicLinkResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      mandate: {
        $ref: "#/components/schemas/MandateCase",
      },
      link: {
        $ref: "#/components/schemas/MandatePublicLink",
      },
      delivery: {
        $ref: "#/components/schemas/MandateCollectionInvitation",
      },
    },
    required: ["mandate", "link", "delivery"],
  },
  PublicMandateForm: {
    type: "object",
    additionalProperties: false,
    properties: {
      companyName: {
        type: "string",
      },
      siteName: {
        type: "string",
      },
      mandateCaseId: {
        type: "string",
      },
      brand: {
        $ref: "#/components/schemas/MandateBrandSnapshot",
      },
      beneficiary: {
        $ref: "#/components/schemas/MandateBeneficiarySnapshot",
      },
      mode: {
        $ref: "#/components/schemas/MandateMode",
      },
      purpose: {
        type: "string",
      },
      permissions: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandateDataCategory",
        },
      },
      validUntil: {
        type: ["string", "null"],
        description:
          "Date de fin d'un ancien mandat à durée déterminée. Null pour un mandat valable sans limite de durée jusqu'à révocation.",
      },
      historicalDataFrom: {
        type: "string",
        description:
          "Début figé des 24 mois calendaires précédant la création du mandat.",
      },
      historicalDataUntil: {
        type: "string",
        description:
          "Date de création du mandat, fin figée de la période historique demandée.",
      },
      holder: {
        $ref: "#/components/schemas/MandateHolderSnapshot",
      },
      signer: {
        $ref: "#/components/schemas/MandateSignerSnapshot",
      },
      principal: {
        $ref: "#/components/schemas/MandateHolderSnapshot",
      },
      principalSigner: {
        $ref: "#/components/schemas/MandateSignerSnapshot",
      },
      principalSignatureRequired: {
        type: "boolean",
      },
      points: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MandatePointSnapshot",
        },
      },
      expiresAt: {
        type: "string",
      },
      revision: {
        type: "integer",
      },
    },
    required: [
      "mandateCaseId",
      "brand",
      "beneficiary",
      "mode",
      "purpose",
      "permissions",
      "validUntil",
      "historicalDataFrom",
      "historicalDataUntil",
      "holder",
      "signer",
      "principalSignatureRequired",
      "points",
      "expiresAt",
      "revision",
    ],
  },
  YoutrustProviderStatus: {
    type: "object",
    additionalProperties: false,
    properties: {
      provider: {
        const: "youtrust",
        type: "string",
      },
      environment: {
        type: "string",
        enum: ["sandbox", "production"],
      },
      apiKeyConfigured: {
        type: "boolean",
      },
      webhookSecretConfigured: {
        type: "boolean",
      },
      reachable: {
        type: "boolean",
      },
      message: {
        type: "string",
      },
    },
    required: [
      "provider",
      "environment",
      "apiKeyConfigured",
      "webhookSecretConfigured",
      "message",
    ],
  },
  LegalEntity: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      legalName: {
        type: "string",
      },
      tradeName: {
        type: "string",
      },
      legalForm: {
        type: "string",
      },
      siren: {
        type: "string",
      },
      siret: {
        type: "string",
      },
      address: {
        type: "string",
      },
      postalCode: {
        type: "string",
      },
      city: {
        type: "string",
      },
      representativeName: {
        type: "string",
      },
      representativeRole: {
        type: "string",
      },
      email: {
        type: "string",
      },
      phone: {
        type: "string",
      },
      status: {
        type: "string",
        enum: ["active", "inactive"],
      },
    },
    required: [
      "id",
      "legalName",
      "tradeName",
      "legalForm",
      "siren",
      "siret",
      "address",
      "postalCode",
      "city",
      "representativeName",
      "representativeRole",
      "email",
      "phone",
      "status",
    ],
  },
  User: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      email: {
        type: "string",
      },
      firstName: {
        type: "string",
      },
      lastName: {
        type: "string",
      },
      phone: {
        type: "string",
      },
      status: {
        $ref: "#/components/schemas/UserStatus",
      },
      platformRole: {
        const: "super_admin",
        type: "string",
      },
      memberships: {
        type: "array",
        items: {
          $ref: "#/components/schemas/Membership",
        },
      },
      lastLoginAt: {
        anyOf: [
          {
            type: "string",
          },
          {
            type: "null",
          },
        ],
      },
    },
    required: [
      "id",
      "email",
      "firstName",
      "lastName",
      "phone",
      "status",
      "memberships",
      "lastLoginAt",
    ],
  },
  Membership: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      role: {
        enum: ["manager", "client"],
        type: "string",
      },
      grants: {
        type: "array",
        items: {
          $ref: "#/components/schemas/AccessGrant",
        },
      },
      invitedByMembershipId: {
        type: "string",
      },
      createdAt: {
        type: "string",
      },
    },
    required: ["id", "brandId", "role", "grants"],
  },
  AccessGrant: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      scope: {
        $ref: "#/components/schemas/GrantScope",
      },
      scopeId: {
        type: "string",
      },
      assignedByMembershipId: {
        type: "string",
      },
      sourceGrantId: {
        type: "string",
      },
      createdAt: {
        type: "string",
      },
      reason: {
        type: "string",
      },
    },
    required: ["id", "scope", "scopeId"],
  },
  Company: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      name: {
        type: "string",
      },
      sector: {
        type: ["string", "null"],
      },
      siren: {
        type: ["string", "null"],
      },
      city: {
        type: ["string", "null"],
      },
      logoInitials: {
        type: "string",
      },
      lifecycleStatus: {
        type: "string",
        enum: ["active", "archived"],
      },
      createdByMembershipId: {
        type: "string",
        description:
          "Provenance de création attribuée par le serveur. Contexte Entreprise, jamais un grant Company.",
      },
      identitySource: {
        type: "string",
        enum: ["annuaire_entreprises"],
        description:
          "Source publique utilisée pour confirmer l'identité légale.",
      },
      identityCheckedAt: {
        type: "string",
        format: "date-time",
        description: "Date de consultation de la source publique.",
      },
      selectedEstablishmentSiret: {
        type: "string",
        pattern: "^[0-9]{14}$",
        description:
          "Établissement explicitement choisi, jamais construit depuis le SIREN.",
      },
      selectedEstablishmentStatus: {
        type: "string",
        enum: ["active", "closed"],
      },
      revision: {
        type: "integer",
        minimum: 1,
        description:
          "Révision optimiste renvoyée par l'API et exigée pour une modification.",
      },
      externalCode: {
        type: "string",
        maxLength: 100,
      },
    },
    required: [
      "id",
      "brandId",
      "name",
      "sector",
      "siren",
      "city",
      "logoInitials",
    ],
  },
  Weekday: {
    type: "string",
    enum: [
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
      "sunday",
    ],
  },
  OccupancyScheduleEntry: {
    type: "object",
    additionalProperties: false,
    properties: {
      day: {
        $ref: "#/components/schemas/Weekday",
      },
      closed: {
        type: "boolean",
      },
      opensAt: {
        type: "string",
      },
      closesAt: {
        type: "string",
      },
    },
    required: ["day", "closed", "opensAt", "closesAt"],
  },
  FieldProvenance: {
    type: "object",
    additionalProperties: false,
    properties: {
      origin: {
        type: "string",
        enum: ["api", "manual", "synthetic", "computed"],
        description:
          "`computed` : valeur calculée par l’API depuis les mesures (jamais saisie).",
      },
      validFrom: {
        type: "string",
      },
      validUntil: {
        type: "string",
      },
      reviewedAt: {
        type: "string",
      },
    },
    required: ["origin", "validFrom"],
  },
  SiteClosurePeriod: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      label: {
        type: "string",
      },
      startsAt: {
        type: "string",
      },
      endsAt: {
        type: "string",
      },
    },
    required: ["id", "label", "startsAt", "endsAt"],
  },
  WeatherStation: {
    type: "object",
    additionalProperties: false,
    description:
      "Station météo de la plateforme (schéma PostgreSQL `weather`, hors marque). Une station n'est jamais figée sur un Site : elle est choisie à chaque analyse, par paramètre.",
    properties: {
      id: {
        type: "string",
      },
      name: {
        type: "string",
      },
      latitude: {
        type: "number",
      },
      longitude: {
        type: "number",
      },
      altitudeM: {
        type: ["number", "null"],
      },
      timezone: {
        type: "string",
      },
      source: {
        type: "string",
      },
      kind: {
        type: "string",
        enum: ["observation", "model"],
      },
    },
    required: [
      "id",
      "name",
      "latitude",
      "longitude",
      "altitudeM",
      "timezone",
      "source",
      "kind",
    ],
  },
  WeatherParameter: {
    type: "object",
    additionalProperties: false,
    description:
      "Grandeur météo stockée à raison d'une ligne par station, paramètre et pas de temps.",
    properties: {
      code: {
        type: "string",
      },
      label: {
        type: "string",
      },
      unit: {
        type: "string",
      },
      aggregation: {
        type: "string",
        enum: ["mean", "sum", "max"],
      },
      step: {
        type: "string",
        enum: ["hour", "day"],
      },
    },
    required: ["code", "label", "unit", "aggregation", "step"],
  },
  SiteOfficialDegreeDays: {
    type: "object",
    additionalProperties: false,
    required: [
      "reference",
      "stationName",
      "selection",
      "distanceKm",
      "referenceVersion",
      "from",
      "to",
      "baseC",
      "method",
      "origin",
      "availableDays",
      "missingDays",
      "heating",
      "cooling",
      "days",
    ],
    properties: {
      qualification: {
        type: "string",
        enum: ["qualified", "unqualified", "unknown"],
        description: "Qualification du poste sur la période demandée",
        "distincte de la qualité des valeurs.": null,
      },
      reference: {
        type: ["string", "null"],
      },
      stationName: {
        type: ["string", "null"],
      },
      selection: {
        type: "string",
        enum: ["declared", "nearest", "unavailable"],
      },
      distanceKm: {
        type: ["number", "null"],
      },
      referenceVersion: {
        type: "string",
      },
      from: {
        type: "string",
      },
      to: {
        type: "string",
      },
      baseC: {
        type: "number",
        enum: [18],
      },
      method: {
        type: "string",
        enum: ["COSTIC"],
      },
      origin: {
        type: "string",
        enum: ["calculated_official_extremes"],
      },
      availableDays: {
        type: "integer",
        minimum: 0,
      },
      missingDays: {
        type: "integer",
        minimum: 0,
      },
      heating: {
        type: ["number", "null"],
        description: "Somme uniquement si tous les jours sont disponibles.",
      },
      cooling: {
        type: ["number", "null"],
        description: "Somme uniquement si tous les jours sont disponibles.",
      },
      days: {
        type: "array",
        items: {
          $ref: "#/components/schemas/SiteOfficialDegreeDay",
        },
      },
    },
  },
  SiteOfficialDegreeDay: {
    type: "object",
    additionalProperties: false,
    required: ["day", "heating", "cooling", "importedAt", "sourceReference"],
    properties: {
      day: {
        type: "string",
      },
      heating: {
        type: ["number", "null"],
      },
      cooling: {
        type: ["number", "null"],
      },
      importedAt: {
        type: ["string", "null"],
      },
      sourceReference: {
        type: ["string", "null"],
      },
    },
  },
  WeatherStationCatalog: {
    type: "object",
    additionalProperties: false,
    required: [
      "scope",
      "radiusKm",
      "referenceStationId",
      "stations",
      "parameters",
    ],
    properties: {
      scope: {
        type: "string",
        enum: ["site", "platform"],
      },
      radiusKm: {
        type: ["number", "null"],
      },
      referenceStationId: {
        type: ["string", "null"],
      },
      referenceStationIds: {
        type: "array",
        description:
          "Stations du référentiel DJ18 présentes dans le périmètre autorisé ; inclut aussi la référence déclarée ou retenue du Site.",
        items: {
          type: "string",
        },
      },
      stations: {
        type: "array",
        items: {
          $ref: "#/components/schemas/WeatherStation",
        },
      },
      parameters: {
        type: "array",
        items: {
          $ref: "#/components/schemas/WeatherParameter",
        },
      },
    },
  },
  WeatherObservationPoint: {
    type: "object",
    additionalProperties: false,
    required: ["at", "value", "quality"],
    properties: {
      at: {
        type: "string",
      },
      value: {
        type: ["number", "null"],
      },
      quality: {
        type: "string",
        enum: ["measured", "estimated", "provisional", "missing"],
      },
    },
  },
  WeatherObservations: {
    type: "object",
    additionalProperties: false,
    required: [
      "station",
      "parameter",
      "from",
      "to",
      "points",
      "availableHours",
      "missingHours",
      "latestAt",
      "officialRows",
      "officialTruncated",
    ],
    properties: {
      qualification: {
        type: "string",
        enum: ["qualified", "unqualified", "unknown"],
        description: "Qualification du poste sur la période demandée",
        "distincte de la qualité des valeurs.": null,
      },
      station: {
        $ref: "#/components/schemas/WeatherStation",
      },
      parameter: {
        $ref: "#/components/schemas/WeatherParameter",
      },
      from: {
        type: "string",
      },
      to: {
        type: "string",
      },
      points: {
        type: "array",
        items: {
          $ref: "#/components/schemas/WeatherObservationPoint",
        },
      },
      availableHours: {
        type: "integer",
        minimum: 0,
      },
      missingHours: {
        type: "integer",
        minimum: 0,
      },
      latestAt: {
        type: ["string", "null"],
        description: "Dernière observation présente sur la période",
        "pas une date d’import.": null,
      },
      officialRows: {
        type: "array",
        items: {
          $ref: "#/components/schemas/OfficialWeatherValue",
        },
      },
      officialTruncated: {
        type: "boolean",
      },
      metadata: {
        anyOf: [
          {
            type: "object",
            additionalProperties: true,
          },
          {
            type: "null",
          },
        ],
        description:
          "Métadonnées fournisseur éventuelles, réservées au super-admin de plateforme.",
      },
    },
  },
  SiteWeatherCoverage: {
    type: "object",
    additionalProperties: false,
    description:
      "Pour un Site et un paramètre, la station retenue sur la période : la plus proche parmi celles qui offrent la meilleure couverture (à 2 points près) dans le rayon de recherche, ou aucune si aucune valeur n'existe.",
    properties: {
      parameter: {
        $ref: "#/components/schemas/WeatherParameter",
      },
      station: {
        oneOf: [
          {
            $ref: "#/components/schemas/WeatherStation",
          },
          {
            type: "null",
          },
        ],
      },
      distanceKm: {
        type: ["number", "null"],
        minimum: 0,
      },
      coverageRatio: {
        type: "number",
        minimum: 0,
        maximum: 1,
      },
      valueCount: {
        type: "integer",
        minimum: 0,
      },
      periodStart: {
        type: "string",
      },
      periodEnd: {
        type: "string",
      },
      radiusKm: {
        type: "number",
        minimum: 0,
      },
    },
    required: [
      "parameter",
      "station",
      "distanceKm",
      "coverageRatio",
      "valueCount",
      "periodStart",
      "periodEnd",
      "radiusKm",
    ],
  },
  ThermalReference: {
    type: "object",
    additionalProperties: false,
    description:
      "Référence thermique d’un Site : talon et thermosensibilité normalisée par la surface utile. Calculée par l’API (`methodVersion: monthly-dju-costic-v1`) par régression de l’énergie mensuelle sur les degrés-jours COSTIC, ou saisie ; la provenance est portée par `SiteAnalysisConfiguration.thermalProvenance`.",
    properties: {
      methodVersion: {
        type: "string",
      },
      baseloadKw: {
        type: "number",
      },
      sensitivityKwhM2Dju: {
        type: "number",
      },
      periodStart: {
        type: "string",
      },
      periodEnd: {
        type: "string",
      },
      coolingSensitivityKwhM2Dju: {
        type: "number",
        description:
          "Thermosensibilité en rafraîchissement, même unité ; 0 si aucune.",
      },
      heatingKwhPerDju: {
        type: "number",
        description:
          "Pente brute de chauffage de la régression, en kWh par degré-jour.",
      },
      coolingKwhPerDju: {
        type: "number",
      },
      rSquared: {
        type: "number",
        minimum: 0,
        maximum: 1,
      },
      monthCount: {
        type: "integer",
        minimum: 0,
      },
      stationId: {
        type: "string",
        description: "Station de température ayant fourni les degrés-jours.",
      },
    },
    required: [
      "methodVersion",
      "baseloadKw",
      "sensitivityKwhM2Dju",
      "periodStart",
      "periodEnd",
    ],
  },
  SiteAnalysisConfiguration: {
    type: "object",
    additionalProperties: false,
    properties: {
      weatherStationReference: {
        type: "string",
        pattern: "^(?:[0-9]{8}|2[AB][0-9]{6})$",
        description:
          "Numéro de station de la déclaration annuelle pour les DJ18 officiels. Absent pour choisir la station de référence la plus proche. Jamais remplacé en cas de lacune.",
      },
      usefulSurfaceM2: {
        type: "number",
        exclusiveMinimum: 0,
        description:
          "Surface utile renseignée ; propriété absente si inconnue, jamais zéro de remplacement.",
      },
      heatedSurfaceM2: {
        type: "number",
        minimum: 0,
      },
      cooledSurfaceM2: {
        type: "number",
        minimum: 0,
      },
      buildingType: {
        type: "string",
        enum: [
          "office",
          "industry",
          "logistics",
          "healthcare",
          "retail",
          "hotel",
          "housing",
          "data_center",
          "other",
        ],
      },
      closures: {
        type: "array",
        items: {
          $ref: "#/components/schemas/SiteClosurePeriod",
        },
      },
      heatingSetpointC: {
        type: "number",
      },
      coolingSetpointC: {
        type: "number",
      },
      comparisonEventAt: {
        type: "string",
      },
      beforePeriodStart: {
        type: "string",
      },
      beforePeriodEnd: {
        type: "string",
      },
      afterPeriodStart: {
        type: "string",
      },
      afterPeriodEnd: {
        type: "string",
      },
      countPlanReady: {
        type: "boolean",
      },
      annualCoverageRatio: {
        type: "number",
        minimum: 0,
        maximum: 1,
        description:
          "Couverture connue ; absente si non évaluée. La couverture calculée depuis les mesures du Site est prioritaire.",
      },
      surfaceProvenance: {
        $ref: "#/components/schemas/FieldProvenance",
      },
      scheduleProvenance: {
        $ref: "#/components/schemas/FieldProvenance",
      },
      thermalProvenance: {
        $ref: "#/components/schemas/FieldProvenance",
        description:
          "Provenance de `thermalReference` : `computed` (régression mensuelle de l’API, recalculée après chaque synchronisation) ou `manual` (saisie, jamais écrasée par le calcul).",
      },
      thermalReference: {
        $ref: "#/components/schemas/ThermalReference",
      },
      beforeThermalReference: {
        $ref: "#/components/schemas/ThermalReference",
      },
      afterThermalReference: {
        $ref: "#/components/schemas/ThermalReference",
      },
    },
    required: ["closures"],
  },
  SiteDashboardDay: {
    type: "object",
    additionalProperties: false,
    properties: {
      day: {
        type: "string",
        description: "Jour civil local du Site (`AAAA-MM-JJ`).",
      },
      electricityKwh: {
        anyOf: [
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
        description:
          "Énergie électrique du jour, tous PRM actifs visibles ; `null` sans source.",
      },
      gasKwh: {
        anyOf: [
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
        description:
          "Énergie gaz du jour : périodes publiées GRDF réparties selon les consommations informatives quand elles couvrent toute la période, au prorata sinon (le total publié est conservé) ; `null` sans source.",
      },
      gasPeriodDays: {
        anyOf: [
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
        description:
          "Durée (jours) de la mesure qui donne sa forme à ce jour : 1 quand la période est répartie selon les informatives, sinon la plus longue période de relevé gaz couvrant ce jour, où la consommation est supposée uniforme. `null` sans gaz.",
      },
      peakKw: {
        anyOf: [
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
        description:
          "Pointe de puissance du jour (somme des PRM au même instant) ; `null` sans courbe de charge.",
      },
      heatingDegreeDays: {
        anyOf: [
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
        description:
          "Degrés-jours de chauffage du jour, selon `weather.method` et `weather.heatingBaseC` ; `null` sans température.",
      },
      coolingDegreeDays: {
        anyOf: [
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
        description:
          "Degrés-jours de rafraîchissement du jour, selon `weather.method` et `weather.coolingBaseC` ; `null` sans température.",
      },
    },
    required: [
      "day",
      "electricityKwh",
      "gasKwh",
      "gasPeriodDays",
      "peakKw",
      "heatingDegreeDays",
      "coolingDegreeDays",
    ],
  },
  SiteDashboardWeather: {
    type: "object",
    additionalProperties: false,
    description:
      "Station de température retenue pour les degrés-jours du Site et bases de calcul.",
    properties: {
      stationId: {
        type: "string",
      },
      stationName: {
        type: "string",
      },
      distanceKm: {
        type: ["number", "null"],
      },
      method: {
        type: "string",
        description:
          "Méthode de calcul retenue (`COSTIC` par défaut, ou `METEO`).",
        enum: ["COSTIC", "METEO"],
      },
      heatingBaseC: {
        type: "number",
      },
      coolingBaseC: {
        type: "number",
      },
    },
    required: [
      "stationId",
      "stationName",
      "distanceKm",
      "method",
      "heatingBaseC",
      "coolingBaseC",
    ],
  },
  SiteDashboard: {
    type: "object",
    additionalProperties: false,
    properties: {
      siteId: {
        type: "string",
      },
      timezone: {
        type: "string",
      },
      from: {
        type: "string",
        description:
          "Premier jour couvert (`AAAA-MM-JJ`, début du 24e mois civil précédent).",
      },
      to: {
        type: "string",
        description: "Dernier jour couvert (`AAAA-MM-JJ`, aujourd'hui).",
      },
      sources: {
        type: "array",
        items: {
          type: "string",
        },
        description: "Sources des séries retenues (`Enedis`, `GRDF`…).",
      },
      electricitySources: {
        type: "array",
        items: {
          type: "string",
        },
        description: "Sources des séries retenues pour les PRM.",
      },
      gasSources: {
        type: "array",
        items: {
          type: "string",
        },
        description: "Sources des séries retenues pour les PCE.",
      },
      synthetic: {
        type: "boolean",
        description:
          "Au moins une série synthétique du jeu de démonstration a été utilisée.",
      },
      electricityPoints: {
        type: "integer",
      },
      gasPoints: {
        type: "integer",
      },
      subscribedPowerKw: {
        anyOf: [
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
        description:
          "Somme des puissances souscrites des PRM actifs visibles ; `null` si aucune n'est renseignée.",
      },
      days: {
        type: "array",
        items: {
          $ref: "#/components/schemas/SiteDashboardDay",
        },
      },
      weather: {
        anyOf: [
          {
            $ref: "#/components/schemas/SiteDashboardWeather",
          },
          {
            type: "null",
          },
        ],
        description:
          "`null` : aucune station de température dans le rayon de recherche, aucun degré-jour.",
      },
      loadProfile: {
        anyOf: [
          {
            type: "object",
            additionalProperties: false,
            properties: {
              days: {
                type: "integer",
                description: "Nombre de jours observés.",
              },
              kw: {
                type: "array",
                description:
                  "7 lignes (lundi à dimanche) de 24 kW moyens par heure locale.",
                items: {
                  type: "array",
                  items: {
                    type: "number",
                  },
                },
              },
            },
            required: ["days", "kw"],
          },
          {
            type: "null",
          },
        ],
      },
    },
    required: [
      "siteId",
      "timezone",
      "from",
      "to",
      "sources",
      "electricitySources",
      "gasSources",
      "synthetic",
      "electricityPoints",
      "gasPoints",
      "subscribedPowerKw",
      "days",
      "weather",
      "loadProfile",
    ],
  },
  SiteAnnualCoverage: {
    type: "object",
    additionalProperties: false,
    description:
      "Couverture des relevés derrière `annualMwh` : fenêtre de 365 jours révolus, jours couverts par tous les points actifs du Site, jours manquants et points sans aucun relevé. Absent tant que rien n’a été calculé.",
    properties: {
      windowStart: {
        type: "string",
        description: "Début de la fenêtre (inclus), ISO 8601.",
      },
      windowEnd: {
        type: "string",
        description: "Fin de la fenêtre (exclue), ISO 8601.",
      },
      coveredDays: {
        type: "integer",
        description:
          "Jours de la fenêtre couverts par chaque point actif du Site (le point le moins couvert fait foi).",
      },
      missingDays: {
        type: "integer",
        description: "365 moins `coveredDays`.",
      },
      pendingPoints: {
        type: "integer",
        description: "Points actifs (PRM, PCE) sans aucun relevé réel.",
      },
      computedAt: {
        type: "string",
      },
    },
    required: [
      "windowStart",
      "windowEnd",
      "coveredDays",
      "missingDays",
      "pendingPoints",
      "computedAt",
    ],
  },
  Site: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      companyId: {
        type: "string",
      },
      name: {
        type: "string",
      },
      city: {
        type: ["string", "null"],
      },
      postalCode: {
        type: ["string", "null"],
      },
      address: {
        type: ["string", "null"],
      },
      cityCode: {
        type: ["string", "null"],
        pattern: "^[0-9A-Z]{5}$",
        description:
          "Code INSEE de la commune fourni par la BAN ; `null` pour une saisie manuelle ou historique non normalisée.",
      },
      latitude: {
        type: ["number", "null"],
        description:
          "`null` : coordonnées inconnues (jamais `0`, qui est un point réel) ; aucune station météo n’est alors choisie.",
      },
      longitude: {
        type: ["number", "null"],
      },
      timezone: {
        type: "string",
      },
      surfaceM2: {
        type: ["number", "null"],
        description:
          "`null` : surface inconnue, à qualifier dans la fiche Site.",
      },
      usage: {
        type: ["string", "null"],
      },
      status: {
        type: "string",
        enum: ["normal", "warning", "alert", "unknown"],
        description:
          "unknown pour les parents de contexte : aucun état global du Site n’est divulgué.",
      },
      annualMwh: {
        anyOf: [
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
        description:
          "Énergie des points actifs du Site (PRM et PCE, toutes énergies) sur les 365 derniers jours révolus, en MWh, recalculée par l’API à chaque synchronisation ; `null` tant qu’aucun relevé réel n’a été chargé. Jamais prise du client.",
      },
      changePercent: {
        anyOf: [
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
        description:
          "Variation par rapport aux 365 jours précédents, calculée seulement quand les deux fenêtres sont presque entièrement couvertes ; `null` sinon.",
      },
      annualCoverage: {
        $ref: "#/components/schemas/SiteAnnualCoverage",
      },
      dataAccess: {
        const: "context",
        type: "string",
      },
      occupancySchedule: {
        type: "array",
        items: {
          $ref: "#/components/schemas/OccupancyScheduleEntry",
        },
      },
      analysisConfiguration: {
        $ref: "#/components/schemas/SiteAnalysisConfiguration",
      },
      lifecycleStatus: {
        type: "string",
        enum: ["active", "archived"],
      },
      profiling: {
        type: "object",
        additionalProperties: false,
        properties: {
          quickQualificationDone: {
            type: "boolean",
          },
          apiPrefillReviewed: {
            type: "boolean",
          },
          firstVisitDone: {
            type: "boolean",
          },
          continuousUpdateEnabled: {
            type: "boolean",
          },
          constructionYear: {
            type: "number",
          },
          occupancyNotes: {
            type: "string",
          },
        },
        required: [
          "quickQualificationDone",
          "apiPrefillReviewed",
          "firstVisitDone",
          "continuousUpdateEnabled",
        ],
      },
      revision: {
        type: "integer",
        minimum: 1,
        description:
          "Révision optimiste renvoyée par l'API et exigée pour une modification.",
      },
      externalCode: {
        type: "string",
        maxLength: 100,
      },
    },
    required: [
      "id",
      "brandId",
      "companyId",
      "name",
      "city",
      "postalCode",
      "address",
      "latitude",
      "longitude",
      "timezone",
      "surfaceM2",
      "usage",
      "status",
      "annualMwh",
      "changePercent",
    ],
  },
  DeliveryPoint: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      siteId: {
        type: "string",
      },
      type: {
        type: "string",
        enum: ["PRM", "PCE", "internal"],
      },
      reference: {
        type: "string",
      },
      label: {
        type: "string",
      },
      energy: {
        $ref: "#/components/schemas/Energy",
      },
      provider: {
        type: "string",
      },
      subscribedPowerKw: {
        type: "number",
      },
      energyContract: {
        $ref: "#/components/schemas/EnergyContract",
      },
      status: {
        type: "string",
        enum: ["active", "inactive"],
      },
    },
    required: [
      "id",
      "brandId",
      "siteId",
      "type",
      "reference",
      "label",
      "energy",
      "provider",
      "status",
    ],
  },
  SheetPower: {
    type: "object",
    additionalProperties: false,
    description:
      "Puissance publiée par une fiche C68, avec son unité (kVA en BT, kW en HTA).",
    required: ["value", "unit"],
    properties: {
      value: {
        type: "number",
      },
      unit: {
        type: "string",
      },
    },
  },
  ClassPower: {
    type: "object",
    additionalProperties: false,
    required: ["classId", "value", "unit"],
    properties: {
      classId: {
        type: "string",
        description:
          "Classe temporelle TURPE (`PTE`, `HPH`, `HCH`, `HPE`, `HCE`, `JA`).",
      },
      value: {
        type: "number",
      },
      unit: {
        type: "string",
      },
    },
  },
  ElectricitySheetDetails: {
    description:
      "Champs de la fiche C68 d'un PRM au-delà des champs communs (mapping Enedis de Clément, §8 bis) : puissances souscrites par classe temporelle de la grille TURPE (Q11), leur ordre, facteurs de pertes, heures creuses et postes horaires, raccordement, transformateur de courant, dernières modifications. Un champ non publié est nul ; `losses` nul : aucun bloc de pertes, donc aucune correction.",
    type: "object",
    additionalProperties: false,
    required: [
      "classPowers",
      "classPowersOrdered",
      "losses",
      "offPeak",
      "connection",
      "currentTransformer",
      "voltageTransformer",
      "breaker",
      "customerCategory",
      "supplierCalendar",
      "lastChanges",
    ],
    properties: {
      classPowers: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ClassPower",
        },
      },
      classPowersOrdered: {
        type: ["boolean", "null"],
        description:
          "Puissances croissantes de la classe la plus chère à la moins chère (PTE ≤ HPH ≤ HCH ≤ HPE ≤ HCE ≤ JA), comme le TURPE l'exige ; nul sous deux classes connues.",
      },
      losses: {
        type: ["object", "null"],
        additionalProperties: false,
        required: ["iron", "joule", "reactive"],
        properties: {
          iron: {
            type: ["number", "null"],
          },
          joule: {
            type: ["number", "null"],
          },
          reactive: {
            type: ["number", "null"],
          },
        },
      },
      offPeak: {
        type: ["object", "null"],
        additionalProperties: false,
        required: ["slots", "relayLabel", "lowSeason", "highSeason"],
        properties: {
          slots: {
            type: "array",
            items: {
              type: "object",
              additionalProperties: false,
              required: ["classId", "periods"],
              properties: {
                classId: {
                  type: "string",
                },
                periods: {
                  type: "string",
                },
              },
            },
          },
          relayLabel: {
            type: ["string", "null"],
          },
          lowSeason: {
            type: ["string", "null"],
          },
          highSeason: {
            type: ["string", "null"],
          },
        },
      },
      connection: {
        type: ["object", "null"],
        additionalProperties: false,
        required: [
          "voltageDomain",
          "deliveryVoltage",
          "meteringVoltage",
          "withdrawalPower",
          "injectionPower",
          "withdrawalLimit",
          "overheadLengthKm",
          "undergroundLengthKm",
          "qualityZone",
          "backupSupply",
        ],
        properties: {
          voltageDomain: {
            type: ["string", "null"],
          },
          deliveryVoltage: {
            type: ["string", "null"],
          },
          meteringVoltage: {
            type: ["string", "null"],
            description:
              "Tension du comptage (HTA) ; égale à la tension de livraison, aucune perte de transformateur à corriger.",
          },
          withdrawalPower: {
            oneOf: [
              {
                $ref: "#/components/schemas/SheetPower",
              },
              {
                type: "null",
              },
            ],
          },
          injectionPower: {
            oneOf: [
              {
                $ref: "#/components/schemas/SheetPower",
              },
              {
                type: "null",
              },
            ],
          },
          withdrawalLimit: {
            oneOf: [
              {
                $ref: "#/components/schemas/SheetPower",
              },
              {
                type: "null",
              },
            ],
          },
          qualityZone: {
            type: ["string", "null"],
            description: "Zone de qualité de desserte (`ZONE1` à `ZONE4`).",
          },
          overheadLengthKm: {
            type: ["number", "null"],
          },
          undergroundLengthKm: {
            type: ["number", "null"],
          },
          backupSupply: {
            type: ["boolean", "null"],
          },
        },
      },
      currentTransformer: {
        type: ["object", "null"],
        additionalProperties: false,
        required: [
          "caliber",
          "ratio",
          "accuracyClass",
          "position",
          "ownership",
        ],
        properties: {
          caliber: {
            type: ["string", "null"],
          },
          ratio: {
            type: ["string", "null"],
          },
          accuracyClass: {
            type: ["string", "null"],
          },
          position: {
            type: ["string", "null"],
            description: "`PRIM` ou `SCND`.",
          },
          ownership: {
            type: ["string", "null"],
          },
        },
      },
      voltageTransformer: {
        type: ["object", "null"],
        additionalProperties: false,
        description: "Transformateur de tension du comptage (HTA).",
        required: ["caliber", "ratio", "accuracyClass"],
        properties: {
          caliber: {
            type: ["string", "null"],
          },
          ratio: {
            type: ["string", "null"],
          },
          accuracyClass: {
            type: ["string", "null"],
          },
        },
      },
      breaker: {
        type: ["object", "null"],
        additionalProperties: false,
        description: "Disjoncteur de branchement (C5).",
        required: ["caliber", "settingA"],
        properties: {
          caliber: {
            type: ["string", "null"],
          },
          settingA: {
            type: ["number", "null"],
          },
        },
      },
      customerCategory: {
        type: ["string", "null"],
        description: "Catégorie du client final (`RES`, `PRO`).",
      },
      supplierCalendar: {
        type: ["string", "null"],
        description: "Calendrier de la grille fournisseur (`FC000032`…).",
      },
      lastChanges: {
        type: "object",
        additionalProperties: false,
        required: [
          "commissionedOn",
          "tariffChangedOn",
          "powerChangedOn",
          "linkyInstalledOn",
        ],
        properties: {
          linkyInstalledOn: {
            type: ["string", "null"],
            format: "date",
          },
          commissionedOn: {
            type: ["string", "null"],
            format: "date",
          },
          tariffChangedOn: {
            type: ["string", "null"],
            format: "date",
          },
          powerChangedOn: {
            type: ["string", "null"],
            format: "date",
          },
        },
      },
    },
  },
  InjectionSheet: {
    description: "Fiche C68 d'un PRM producteur demandée en injection.",
    type: "object",
    additionalProperties: false,
    required: [
      "receivedAt",
      "contractState",
      "tariffCode",
      "subscribedPower",
      "classPowers",
      "sheet",
    ],
    properties: {
      receivedAt: {
        type: "string",
        format: "date-time",
      },
      contractState: {
        type: ["string", "null"],
      },
      tariffCode: {
        type: ["string", "null"],
      },
      subscribedPower: {
        type: ["object", "null"],
        additionalProperties: false,
        required: ["value", "unit"],
        properties: {
          value: {
            type: "number",
          },
          unit: {
            type: "string",
          },
        },
      },
      classPowers: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ClassPower",
        },
      },
      sheet: {
        type: "object",
        additionalProperties: true,
      },
    },
  },
  GasInformativeControl: {
    description:
      "Contrôle publiées / informatives d'un PCE (mapping GRDF de Clément, §6) : la somme des journées gazières informatives d'une période contre l'énergie publiée de cette période. Les publiées font foi ; les informatives, mesures journalières de la télérelève, ne facturent pas mais donnent la forme. `tolerancePercent` borne l'écart jugé normal sur une période complète.",
    type: "object",
    additionalProperties: false,
    required: [
      "pointId",
      "reference",
      "from",
      "to",
      "tolerancePercent",
      "synthetic",
      "informativeDays",
      "informativeFirstAt",
      "informativeLastAt",
      "periods",
    ],
    properties: {
      gasWeather: {
        $ref: "#/components/schemas/GasDayWeatherControl",
      },
      pointId: {
        type: "string",
      },
      reference: {
        type: "string",
      },
      synthetic: {
        type: "boolean",
        description:
          "Les relevés publiés sont ceux du jeu de démonstration, pas de GRDF.",
      },
      from: {
        type: "string",
        format: "date-time",
      },
      to: {
        type: "string",
        format: "date-time",
      },
      tolerancePercent: {
        type: "number",
      },
      informativeDays: {
        type: "integer",
        description: "Journées informatives reçues sur la période demandée.",
      },
      informativeFirstAt: {
        type: ["string", "null"],
        format: "date-time",
        description:
          "Début de la première journée informative du compteur ; nul sans aucune.",
      },
      informativeLastAt: {
        type: ["string", "null"],
        format: "date-time",
      },
      periods: {
        type: "array",
        items: {
          $ref: "#/components/schemas/GasControlPeriod",
        },
      },
    },
  },
  GasControlPeriod: {
    type: "object",
    additionalProperties: false,
    description:
      "Une période de relevé publiée et ce qu'en disent les informatives : `complete` (toutes les journées reçues, écart dans la tolérance), `gap` (toutes reçues, écart au-delà), `pending` (écart provisoire en attente de régularisation), `partial` (journées manquantes : l'écart n'est pas jugé), `missing` (aucune journée).",
    required: [
      "start",
      "end",
      "publishedKwh",
      "quality",
      "informativeKwh",
      "informativeDays",
      "expectedDays",
      "deltaKwh",
      "deltaPercent",
      "status",
    ],
    properties: {
      diagnostics: {
        $ref: "#/components/schemas/GasPeriodDiagnostics",
      },
      start: {
        type: "string",
        format: "date-time",
      },
      end: {
        type: "string",
        format: "date-time",
      },
      publishedKwh: {
        type: ["number", "null"],
      },
      quality: {
        type: "string",
        description: "Qualité de la valeur publiée (`measured`, `estimated`…).",
      },
      informativeKwh: {
        type: ["number", "null"],
        description:
          "Somme des journées informatives reçues dans la période ; nulle sans aucune.",
      },
      informativeDays: {
        type: "integer",
      },
      expectedDays: {
        type: "integer",
      },
      deltaKwh: {
        type: ["number", "null"],
        description:
          "Informatives moins publiée, seulement sur une période complète.",
      },
      deltaPercent: {
        type: ["number", "null"],
      },
      status: {
        type: "string",
        enum: ["complete", "gap", "pending", "partial", "missing"],
      },
    },
  },
  GasPeriodDiagnostics: {
    type: "object",
    additionalProperties: false,
    required: [
      "publicationStatus",
      "expectedEnergyKwh",
      "energyDeltaKwh",
      "conversionDelta",
      "indexChain",
      "rawIndexDelta",
      "convertedIndexDelta",
      "pcs",
      "pcsChangePercent",
    ],
    description:
      "Faits de contrôle sans modification de la mesure. Identité énergie = volume brut × conversion ou volume converti × PCS ; conversion ≈ PTA × PCS. G3 reste sans tolérance validée ; le PCS est comparé à la période précédente sans inventer de plage PITD.",
    properties: {
      publicationStatus: {
        type: ["string", "null"],
      },
      expectedEnergyKwh: {
        type: ["number", "null"],
      },
      energyDeltaKwh: {
        type: ["number", "null"],
      },
      conversionDelta: {
        type: ["number", "null"],
      },
      indexChain: {
        type: "string",
        enum: [
          "continuous",
          "discontinuous",
          "reset",
          "unavailable",
          "not-adjacent",
        ],
      },
      rawIndexDelta: {
        type: ["number", "null"],
      },
      convertedIndexDelta: {
        type: ["number", "null"],
      },
      pcs: {
        type: ["number", "null"],
      },
      pcsChangePercent: {
        type: ["number", "null"],
      },
    },
  },
  GasDayWeatherControl: {
    type: "object",
    additionalProperties: false,
    required: ["convention", "source", "station", "days"],
    properties: {
      convention: {
        type: "string",
      },
      source: {
        type: "string",
      },
      station: {
        type: ["string", "null"],
      },
      days: {
        type: "array",
        items: {
          type: "object",
          additionalProperties: false,
          required: [
            "start",
            "end",
            "informativeKwh",
            "heatingDegreeDays",
            "coolingDegreeDays",
            "hours",
            "aligned",
          ],
          properties: {
            start: {
              type: "string",
              format: "date-time",
            },
            end: {
              type: "string",
              format: "date-time",
            },
            informativeKwh: {
              type: ["number", "null"],
            },
            heatingDegreeDays: {
              type: ["number", "null"],
            },
            coolingDegreeDays: {
              type: ["number", "null"],
            },
            hours: {
              type: "integer",
            },
            aligned: {
              type: "boolean",
              description:
                "Faux pour les DJU issus des TN/TX quotidiens fournisseur, rapprochés par date sans recalage sur la journée gazière. hours vaut alors zéro (aucune couverture horaire calculée).",
            },
          },
        },
      },
    },
  },
  GasMeterSheet: {
    description:
      "Fiche d'un PCE d'après ADICT (atelier fonctionnel et technique v1.8) : données contractuelles (`hasContractual`) et techniques (`hasTechnical`), chacune présente seulement si le droit d'accès la couvre. Énergies en kWh, pression en bar ; un champ non publié est nul.",
    type: "object",
    additionalProperties: false,
    required: [
      "hasContractual",
      "hasTechnical",
      "commissionedOn",
      "publishedOn",
      "dailyCapKwh",
      "carCurrentKwh",
      "carFutureKwh",
      "cjaKwh",
      "cjaDailyKwh",
      "cjaMonthlyKwh",
      "profile",
      "profileFrom",
      "profileTo",
      "profileNext",
      "modulation",
      "modulationBase",
      "sensitiveCustomer",
      "flowCode",
      "normalizedFlowCode",
      "deliveryPressureBar",
      "meterNumber",
      "pitdId",
      "pitdLabel",
      "ownership",
    ],
    properties: {
      hasContractual: {
        type: "boolean",
      },
      hasTechnical: {
        type: "boolean",
      },
      commissionedOn: {
        type: ["string", "null"],
        format: "date",
        description: "Date de mise en service.",
      },
      publishedOn: {
        type: ["string", "null"],
        format: "date",
        description: "Date de publication des données contractuelles.",
      },
      dailyCapKwh: {
        type: ["number", "null"],
        description: "Consommation journalière plafond.",
      },
      carCurrentKwh: {
        type: ["number", "null"],
        description: "Consommation annuelle de référence actuelle.",
      },
      carFutureKwh: {
        type: ["number", "null"],
        description:
          "Consommation annuelle de référence future (prochain recalcul de GRDF).",
      },
      cjaKwh: {
        type: ["number", "null"],
        description: "Capacité journalière d'acheminement souscrite (T4, TP).",
      },
      cjaDailyKwh: {
        type: ["number", "null"],
      },
      cjaMonthlyKwh: {
        type: ["number", "null"],
      },
      profile: {
        type: ["string", "null"],
        description: "Profil de consommation actuel (`P011` à `P019`).",
      },
      profileFrom: {
        type: ["string", "null"],
        format: "date",
      },
      profileTo: {
        type: ["string", "null"],
        format: "date",
        description:
          "Fin du profil actuel ; nulle quand il est sans fin (`9999-12-31`).",
      },
      profileNext: {
        type: ["string", "null"],
      },
      modulation: {
        type: "array",
        description:
          "Modulations des années N-1, N-2 et N-3 (obligations de stockage).",
        items: {
          type: ["number", "null"],
        },
      },
      modulationBase: {
        type: ["number", "null"],
        description: "Assiette de la modulation.",
      },
      sensitiveCustomer: {
        type: ["string", "null"],
        description: "Client sensible MIG (« Oui », « Non »).",
      },
      flowCode: {
        type: ["string", "null"],
      },
      normalizedFlowCode: {
        type: ["string", "null"],
      },
      deliveryPressureBar: {
        type: ["number", "null"],
        description: "Pression de livraison, en bar.",
      },
      meterNumber: {
        type: ["string", "null"],
        description: "Matricule du compteur.",
      },
      pitdId: {
        type: ["string", "null"],
        description:
          "Point d'interface transport-distribution (`GD1057`), clé du PCS.",
      },
      pitdLabel: {
        type: ["string", "null"],
      },
      ownership: {
        type: "object",
        additionalProperties: false,
        required: ["meter", "converter", "station", "recorder"],
        properties: {
          meter: {
            type: ["string", "null"],
          },
          converter: {
            type: ["string", "null"],
          },
          station: {
            type: ["string", "null"],
          },
          recorder: {
            type: ["string", "null"],
          },
        },
      },
    },
  },
  DeliveryPointTechnical: {
    description:
      "Fiche technique et contractuelle du compteur d'un point de livraison, telle que le gestionnaire de réseau l'a publiée (Enedis : flux C68 d'une commande `CommandeInformationsTechniquesEtContractuelles`) : segment, état contractuel, formule tarifaire d'acheminement, puissance souscrite, dispositif de comptage, adresse de l'installation, et la fiche complète. GRDF : données contractuelles et techniques d'ADICT (`donnees_contractuelles`, `donnees_techniques`), lues chaque mois ; l'option tarifaire va dans `tariffCode`, le calibre dans `meterType`, la fréquence de relève dans `readingPeriodicity`, le reste dans `gas`. Donnée de plateforme portée par le compteur, lue par tout acteur qui voit le point. Tous les champs sont nuls tant qu'aucune fiche n'a été reçue (point interne, PRM ou PCE jamais décrit).",
    type: "object",
    additionalProperties: false,
    required: [
      "pointId",
      "reference",
      "receivedAt",
      "segment",
      "contractState",
      "tariffCode",
      "subscribedPower",
      "meterType",
      "readingMode",
      "readingPeriodicity",
      "address",
      "sheet",
      "exclusion",
      "history",
      "gas",
      "electricity",
      "injection",
    ],
    properties: {
      electricity: {
        oneOf: [
          {
            $ref: "#/components/schemas/ElectricitySheetDetails",
          },
          {
            type: "null",
          },
        ],
        description:
          "PRM : ce que la fiche C68 en soutirage dit de plus que les champs communs (puissances par classe, pertes, heures creuses, raccordement) ; `null` pour un PCE ou un PRM sans fiche.",
      },
      injection: {
        oneOf: [
          {
            $ref: "#/components/schemas/InjectionSheet",
          },
          {
            type: "null",
          },
        ],
        description:
          "PRM producteur : la fiche C68 demandée en injection (une demande ne porte qu'un sens) ; `null` sans fiche d'injection.",
      },
      pointId: {
        type: "string",
      },
      reference: {
        type: "string",
        description: "Référence du compteur (PRM ou PCE).",
      },
      receivedAt: {
        type: ["string", "null"],
        format: "date-time",
        description:
          "Réception de la fiche par le connecteur ; nul sans fiche.",
      },
      segment: {
        type: ["string", "null"],
        description: "`C1` à `C5`.",
      },
      contractState: {
        type: ["string", "null"],
        description: "`SERVC` en service, `RESIL` résilié…",
      },
      tariffCode: {
        type: ["string", "null"],
        description:
          "Formule tarifaire d'acheminement (`BTSUPLU4`, `BTINFCU4`…).",
      },
      subscribedPower: {
        type: ["object", "null"],
        additionalProperties: false,
        required: ["value", "unit"],
        properties: {
          value: {
            type: "number",
          },
          unit: {
            type: "string",
          },
        },
      },
      meterType: {
        type: ["string", "null"],
        description: "Type de comptage (`PMEI`, `LINKY`…).",
      },
      readingMode: {
        type: ["string", "null"],
        description: "Mode de relève (`TRLV` télérelève…).",
      },
      readingPeriodicity: {
        type: ["string", "null"],
      },
      address: {
        type: ["object", "null"],
        additionalProperties: false,
        required: ["street", "postalCode", "city"],
        properties: {
          street: {
            type: ["string", "null"],
          },
          postalCode: {
            type: ["string", "null"],
          },
          city: {
            type: ["string", "null"],
          },
        },
      },
      sheet: {
        type: ["object", "null"],
        additionalProperties: true,
        description:
          "Fiche complète telle que publiée par le gestionnaire de réseau.",
      },
      history: {
        type: "array",
        description:
          "Changements de fiche reçus pour ce compteur, du plus récent au plus ancien : une fiche identique à celle qui la précède dans le temps n'en crée pas de nouveau (elle avance `lastSeenAt`) ; un retour à une fiche antérieure (A puis B puis A) en crée un. `receivedAt` est l'arrivée du fichier sur le serveur SFTP (Enedis) ou la lecture à l'API (GRDF) ; `effectiveAt` la date d'effet du changement, tirée de la période de facturation R67 close par le changement (motif MCT), nulle tant qu'elle n'est pas reçue. Vide sans fiche.",
        items: {
          type: "object",
          additionalProperties: false,
          required: [
            "receivedAt",
            "fileName",
            "segment",
            "contractState",
            "tariffCode",
            "subscribedPower",
            "sheet",
            "direction",
          ],
          properties: {
            direction: {
              type: "string",
              enum: ["SOUTIRAGE", "INJECTION"],
              description:
                "Sens de la fiche ; toute fiche GRDF est en soutirage.",
            },
            receivedAt: {
              type: "string",
              format: "date-time",
            },
            lastSeenAt: {
              type: ["string", "null"],
              format: "date-time",
              description:
                "Dernière réception de cette fiche à l'identique : elle valait encore à cette date.",
            },
            effectiveAt: {
              type: ["string", "null"],
              format: "date-time",
              description:
                "Date d'effet du changement (Enedis) : fin de la période de facturation R67 close par le changement de formule ou de puissance (motif MCT) ; nulle sans cette période.",
            },
            effectiveSource: {
              type: ["string", "null"],
              description:
                "Origine de la date d'effet (`R67 MCT`), nulle sans date d'effet.",
            },
            sheet: {
              type: "object",
              additionalProperties: true,
              description:
                "Fiche complète telle que publiée (entrée du PRM dans le fichier C68), pour comparer deux fiches champ par champ.",
            },
            fileName: {
              type: ["string", "null"],
              description:
                "Fichier C68 qui portait la fiche (`ADICT` pour une fiche de PCE lue à l'API GRDF) ; nul pour une fiche antérieure à l'historique.",
            },
            segment: {
              type: ["string", "null"],
            },
            contractState: {
              type: ["string", "null"],
            },
            tariffCode: {
              type: ["string", "null"],
            },
            subscribedPower: {
              type: ["object", "null"],
              additionalProperties: false,
              required: ["value", "unit"],
              properties: {
                value: {
                  type: "number",
                },
                unit: {
                  type: "string",
                },
              },
            },
          },
        },
      },
      gas: {
        oneOf: [
          {
            $ref: "#/components/schemas/GasMeterSheet",
          },
          {
            type: "null",
          },
        ],
        description:
          "PCE : ce que les données contractuelles et techniques d'ADICT disent du compteur (CAR, CJA, profil, PITD, calibre, pression) ; `null` pour un PRM ou un PCE sans fiche.",
      },
      exclusion: {
        type: ["object", "null"],
        additionalProperties: false,
        description:
          "Exclusion du PRM de toute commande SGE posée par un super-admin (motif, auteur, date) : le PRM reste relevé mais n'est ni commandé, ni signalé en retard. `null` quand le PRM est commandé normalement.",
        required: ["reason", "excludedAt", "excludedBy"],
        properties: {
          reason: {
            type: "string",
            description:
              "Motif donné par l'auteur (compteur déposé, site cédé…).",
          },
          excludedAt: {
            type: "string",
            format: "date-time",
          },
          excludedBy: {
            type: "string",
            description: "Nom affiché de l'auteur au moment du geste.",
          },
        },
      },
    },
  },
  DeliveryPointAssignment: {
    description:
      "Affectation d'un point de livraison à une marque et à un site sur une période. `validTo` nul désigne l'affectation courante, celle que porte `DeliveryPoint.brandId`/`siteId`.",
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      deliveryPointId: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      siteId: {
        type: "string",
      },
      validFrom: {
        type: "string",
        format: "date-time",
      },
      validTo: {
        type: ["string", "null"],
        format: "date-time",
      },
      reason: {
        type: "string",
      },
      changedByUserId: {
        type: "string",
      },
    },
    required: [
      "id",
      "deliveryPointId",
      "brandId",
      "siteId",
      "validFrom",
      "validTo",
    ],
  },
  DeliveryPointTransferInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      targetBrandId: {
        type: "string",
      },
      targetSiteId: {
        type: "string",
      },
      reason: {
        type: "string",
        maxLength: 500,
      },
    },
    required: ["targetBrandId", "targetSiteId"],
  },
  TariffScenario: {
    type: "object",
    additionalProperties: false,
    properties: {
      subscribedPower: {
        type: "number",
        minimum: 0,
      },
      annualSubscriptionEur: {
        type: "number",
        minimum: 0,
      },
      penaltiesEur: {
        type: "number",
        minimum: 0,
      },
    },
    required: ["subscribedPower", "annualSubscriptionEur", "penaltiesEur"],
  },
  EnergyContract: {
    type: "object",
    additionalProperties: false,
    description:
      "Données contractuelles connues uniquement ; puissance et dates absentes tant qu’elles ne sont pas renseignées.",
    properties: {
      powerUnit: {
        type: "string",
        enum: ["kW", "kVA"],
      },
      subscribedPower: {
        type: "number",
        minimum: 0,
      },
      currency: {
        type: "string",
        enum: ["EUR"],
      },
      validFrom: {
        type: "string",
      },
      validUntil: {
        type: "string",
      },
      scenarios: {
        type: "array",
        items: {
          $ref: "#/components/schemas/TariffScenario",
        },
      },
      energyRateEurPerKwh: {
        type: "number",
        minimum: 0,
      },
      flexibilityThreshold: {
        type: "number",
        minimum: 0,
      },
      provenance: {
        $ref: "#/components/schemas/FieldProvenance",
      },
    },
    required: ["powerUnit", "currency", "scenarios", "provenance"],
  },
  MeasurementPoint: {
    type: "object",
    additionalProperties: false,
    properties: {
      timestamp: {
        type: "string",
      },
      value: {
        anyOf: [
          {
            type: "number",
          },
          {
            type: "null",
          },
        ],
      },
      quality: {
        $ref: "#/components/schemas/Quality",
      },
    },
    required: ["timestamp", "value", "quality"],
  },
  DataSeries: {
    type: "object",
    additionalProperties: false,
    description:
      "Série de mesure d'un compteur physique (PRM, PCE, point interne), vue depuis une marque. Identifiant stable `<nature>:<source>:<référence>:<sorte>` (`elec:enedis:<PRM>:cdc`, `gas:grdf:<PCE>:energy`, `elec:enedis:<PRM>:cdc-injection` pour l'injection) ; deux marques qui déclarent le même compteur voient la même série.",
    properties: {
      id: {
        type: "string",
      },
      deliveryPointId: {
        type: "string",
        description:
          "Point de livraison de la marque qui porte le compteur de la série.",
      },
      kind: {
        type: ["string", "null"],
        description:
          "Nature déclarée par le connecteur, dans le catalogue de la plateforme (`cdc`, `daily` (R65 fourni, méthode conservée par valeur dans attributes.energyBasis), `energy` ou `energy:<capteur>`, `volume` pour une consommation ; `pmax`, `cdc-ri` et `cdc-rc`, `daily-ri` et `daily-rc`, `index:HPH`, `billing:HPH`… pour le reste ; `daily-from-index` est la variante calculée depuis R64, réservée au total mesuré) ; absente pour une série synthétique ou ancienne. Les écrans, les analyses et les agrégats retiennent la consommation d'un point par cette nature : une nature hors catalogue (index cumulatif, énergie facturée par période, puissance) n'est jamais prise pour une consommation, une série sans nature ne l'est qu'à défaut, d'après son unité.",
      },
      label: {
        type: "string",
      },
      unit: {
        type: "string",
        description:
          "`VA` et `W` portent les puissances maximales atteintes publiées par Enedis (série `pmax`), dans l'unité du flux ; `kvar` et `kvarh` les puissances et énergies réactives (séries `cdc-ri` et `cdc-rc` et `daily-ri` et `daily-rc`) ; `V` la tension (série `voltage`).",
        enum: ["kWh", "kW", "m3", "degC", "VA", "W", "kvar", "kvarh", "V"],
      },
      source: {
        type: "string",
        description:
          "Source de la série, discriminant de son descripteur (`enedis`, `grdf`, `gtb` ; `packages/contracts/src/seriesDescriptor.ts`).",
      },
      nature: {
        type: "string",
        enum: ["elec", "gas", "heat", "water", "unknown"],
        description:
          "Domaine mesuré par la série : électricité, gaz, chaleur, eau, ou inconnu quand la source ne le dit pas (sous-compteur de GTB).",
      },
      granularity: {
        type: "string",
        enum: [
          "ten_minutes",
          "thirty_minutes",
          "hour",
          "day",
          "month",
          "period",
        ],
        description:
          "Pas source. `period` désigne des relevés à périodes irrégulières (relevé mensuel GRDF) : chaque valeur porte ses propres bornes et `intervalSeconds` n'est qu'une durée médiane indicative.",
      },
      intervalSeconds: {
        type: "integer",
        minimum: 1,
        description:
          "Durée réelle d’un intervalle source. Obligatoire pour toute nouvelle série.",
      },
      groupKey: {
        type: "string",
        description:
          "Regroupe les séries issues d'un même relevé (énergie et volume d'un PCE) ; absent pour une série isolée.",
      },
      freshAt: {
        type: "string",
      },
      synthetic: {
        type: "boolean",
      },
      points: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MeasurementPoint",
        },
      },
      values: {
        description:
          "Valeurs identifiées et révisées. Lorsqu’elles sont présentes, elles remplacent `points` comme source de calcul ; `points` demeure une compatibilité de migration additive.",
        type: "array",
        items: {
          $ref: "#/components/schemas/MeasurementValue",
        },
      },
    },
    required: [
      "id",
      "deliveryPointId",
      "label",
      "unit",
      "source",
      "granularity",
      "freshAt",
      "synthetic",
      "points",
    ],
  },
  BillingPeriodTotal: {
    type: "object",
    additionalProperties: false,
    description:
      "Énergie d'une période de facturation, avec ses bornes réelles.",
    required: ["from", "to", "energyKwh", "estimated"],
    properties: {
      from: {
        type: "string",
        format: "date-time",
      },
      to: {
        type: "string",
        format: "date-time",
      },
      energyKwh: {
        type: "number",
      },
      estimated: {
        type: "boolean",
      },
    },
  },
  ConsumptionTotal: {
    type: "object",
    additionalProperties: false,
    description:
      "Total facturant (`billing` : R67, publiées GRDF, périodes de facturation qui chevauchent la période demandée, entières, sans prorata) ou mesuré (`measured` : énergie informative, index avant courbe, bornée à la période demandée). `energyKwh` vaut `null` sans aucune donnée : jamais un zéro.",
    required: [
      "kind",
      "energyKwh",
      "span",
      "coveredDays",
      "sourceSeriesIds",
      "basis",
      "estimated",
    ],
    properties: {
      kind: {
        type: "string",
        enum: ["billing", "measured"],
      },
      energyKwh: {
        type: ["number", "null"],
      },
      span: {
        type: ["object", "null"],
        additionalProperties: false,
        required: ["from", "to"],
        properties: {
          from: {
            type: "string",
            format: "date-time",
          },
          to: {
            type: "string",
            format: "date-time",
          },
        },
      },
      coveredDays: {
        type: "number",
        minimum: 0,
      },
      sourceSeriesIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
      basis: {
        type: "array",
        items: {
          type: "string",
          enum: ["billing_period", "index", "curve"],
        },
      },
      estimated: {
        type: "boolean",
      },
      periods: {
        type: "array",
        items: {
          $ref: "#/components/schemas/BillingPeriodTotal",
        },
      },
    },
  },
  NatureTotals: {
    type: "object",
    additionalProperties: false,
    required: ["nature", "billing", "measured"],
    properties: {
      nature: {
        type: "string",
        enum: ["elec", "gas", "heat", "water"],
      },
      billing: {
        $ref: "#/components/schemas/ConsumptionTotal",
      },
      measured: {
        $ref: "#/components/schemas/ConsumptionTotal",
      },
    },
  },
  ConsumptionTotals: {
    type: "object",
    additionalProperties: false,
    description:
      "Les deux totaux d'un point de livraison ou d'un Site, par nature ; deux natures ne s'additionnent jamais.",
    required: ["requested", "natures"],
    properties: {
      requested: {
        type: "object",
        additionalProperties: false,
        required: ["from", "to"],
        properties: {
          from: {
            type: "string",
            format: "date-time",
          },
          to: {
            type: "string",
            format: "date-time",
          },
        },
      },
      natures: {
        type: "array",
        items: {
          $ref: "#/components/schemas/NatureTotals",
        },
      },
    },
  },
  AnalysisCode: {
    type: "string",
    enum: [
      "A1",
      "A2",
      "A3",
      "A4",
      "A5",
      "A6",
      "A7",
      "A8",
      "A9",
      "A10",
      "A11",
      "A12",
    ],
  },
  AnalysisStatus: {
    type: "string",
    enum: ["available", "partial", "not_calculable", "not_authorized"],
  },
  AnalysisRequest: {
    description:
      "Pour un PDL gaz, sauf références patrimoniales A7/A9/A12, les dates locales Europe/Paris des bornes sont recalées à 06:00 (début inclus, fin exclue). La provenance restitue les instants effectifs et la convention de journée gaz.",
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        $ref: "#/components/schemas/AnalysisCode",
      },
      siteId: {
        type: "string",
      },
      deliveryPointId: {
        type: "string",
      },
      seriesId: {
        type: "string",
      },
      periodStart: {
        type: "string",
      },
      periodEnd: {
        type: "string",
      },
      selectedDate: {
        type: "string",
      },
    },
    required: ["code", "siteId", "periodStart", "periodEnd"],
  },
  AnalysisScope: {
    type: "object",
    additionalProperties: false,
    properties: {
      kind: {
        type: "string",
        enum: ["delivery_point", "site", "portfolio"],
      },
      brandId: {
        type: "string",
      },
      siteIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
      deliveryPointId: {
        type: "string",
      },
    },
    required: ["kind", "brandId", "siteIds"],
  },
  AnalysisProvenance: {
    type: "object",
    additionalProperties: false,
    properties: {
      analysisId: {
        type: "string",
      },
      code: {
        $ref: "#/components/schemas/AnalysisCode",
      },
      methodVersion: {
        type: "string",
      },
      scope: {
        $ref: "#/components/schemas/AnalysisScope",
      },
      requestedStart: {
        type: "string",
      },
      requestedEnd: {
        type: "string",
      },
      coveredStart: {
        type: ["string", "null"],
      },
      coveredEnd: {
        type: ["string", "null"],
      },
      timezone: {
        type: "string",
      },
      quantity: {
        type: "string",
      },
      unit: {
        type: "string",
      },
      sourceIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
      freshAt: {
        type: ["string", "null"],
      },
      expectedIntervals: {
        type: "integer",
        minimum: 0,
      },
      observedIntervals: {
        type: "integer",
        minimum: 0,
      },
      missingIntervals: {
        type: "integer",
        minimum: 0,
      },
      coverageRatio: {
        type: "number",
      },
      revisionIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
      status: {
        $ref: "#/components/schemas/AnalysisStatus",
      },
      reasons: {
        type: "array",
        items: {
          type: "string",
        },
      },
      synthetic: {
        type: "boolean",
      },
    },
    required: [
      "analysisId",
      "code",
      "methodVersion",
      "scope",
      "requestedStart",
      "requestedEnd",
      "coveredStart",
      "coveredEnd",
      "timezone",
      "quantity",
      "unit",
      "sourceIds",
      "freshAt",
      "expectedIntervals",
      "observedIntervals",
      "missingIntervals",
      "coverageRatio",
      "revisionIds",
      "status",
      "reasons",
      "synthetic",
    ],
  },
  AnalysisAvailability: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        $ref: "#/components/schemas/AnalysisCode",
      },
      status: {
        $ref: "#/components/schemas/AnalysisStatus",
      },
      present: {
        type: "array",
        items: {
          type: "string",
        },
      },
      missing: {
        type: "array",
        items: {
          type: "string",
        },
      },
      blocking: {
        type: "array",
        items: {
          type: "string",
        },
      },
      href: {
        type: "string",
      },
    },
    required: ["code", "status", "present", "missing", "blocking", "href"],
  },
  AnalysisCell: {
    type: "object",
    additionalProperties: false,
    properties: {
      label: {
        type: "string",
      },
      value: {
        type: ["number", "null"],
      },
      comparison: {
        type: ["number", "null"],
      },
      status: {
        type: "string",
        enum: ["observed", "missing"],
      },
    },
    required: ["label", "value", "comparison", "status"],
  },
  AnalysisMetric: {
    type: "object",
    additionalProperties: false,
    properties: {
      label: {
        type: "string",
      },
      value: {
        type: ["number", "null"],
      },
      unit: {
        type: "string",
      },
    },
    required: ["label", "value", "unit"],
  },
  A1Cell: {
    type: "object",
    additionalProperties: false,
    properties: {
      date: {
        type: "string",
      },
      localHour: {
        type: "string",
      },
      occurrence: {
        type: "integer",
      },
      powerKw: {
        type: ["number", "null"],
      },
      status: {
        type: "string",
        enum: ["observed", "missing"],
      },
    },
    required: ["date", "localHour", "occurrence", "powerKw", "status"],
  },
  A2Night: {
    type: "object",
    additionalProperties: false,
    properties: {
      date: {
        type: "string",
      },
      baseloadKw: {
        type: ["number", "null"],
      },
      valid: {
        type: "boolean",
      },
    },
    required: ["date", "baseloadKw", "valid"],
  },
  A3Slot: {
    type: "object",
    additionalProperties: false,
    properties: {
      localTime: {
        type: "string",
      },
      p10Kw: {
        type: ["number", "null"],
      },
      p50Kw: {
        type: ["number", "null"],
      },
      p90Kw: {
        type: ["number", "null"],
      },
      selectedKw: {
        type: ["number", "null"],
      },
    },
    required: ["localTime", "p10Kw", "p50Kw", "p90Kw", "selectedKw"],
  },
  A4Day: {
    type: "object",
    additionalProperties: false,
    properties: {
      date: {
        type: "string",
      },
      actualStart: {
        type: ["string", "null"],
      },
      actualEnd: {
        type: ["string", "null"],
      },
      advanceHours: {
        type: ["number", "null"],
      },
      delayHours: {
        type: ["number", "null"],
      },
      outsideHours: {
        type: ["number", "null"],
      },
    },
    required: [
      "date",
      "actualStart",
      "actualEnd",
      "advanceHours",
      "delayHours",
      "outsideHours",
    ],
  },
  A5Point: {
    type: "object",
    additionalProperties: false,
    properties: {
      temperatureC: {
        type: "number",
      },
      powerKw: {
        type: "number",
      },
      predictedKw: {
        type: ["number", "null"],
      },
    },
    required: ["temperatureC", "powerKw", "predictedKw"],
  },
  A8Day: {
    type: "object",
    additionalProperties: false,
    properties: {
      date: {
        type: "string",
      },
      residualKwh: {
        type: ["number", "null"],
      },
      observedKwh: {
        type: ["number", "null"],
      },
      predictedKwh: {
        type: ["number", "null"],
      },
      differencePercent: {
        type: ["number", "null"],
      },
      classification: {
        type: "string",
        enum: ["conforming", "drift", "alert", "missing"],
      },
      dayType: {
        type: "string",
      },
    },
    required: [
      "date",
      "residualKwh",
      "observedKwh",
      "predictedKwh",
      "differencePercent",
      "classification",
      "dayType",
    ],
  },
  A9SiteBenchmark: {
    type: "object",
    additionalProperties: false,
    properties: {
      siteId: {
        type: "string",
      },
      label: {
        type: "string",
      },
      intensityKwhM2: {
        type: "number",
      },
      selected: {
        type: "boolean",
      },
    },
    required: ["siteId", "label", "intensityKwhM2", "selected"],
  },
  A10Scenario: {
    type: "object",
    additionalProperties: false,
    properties: {
      subscribedPower: {
        type: "number",
      },
      subscriptionEur: {
        type: "number",
      },
      penaltiesEur: {
        type: "number",
      },
      totalCostEur: {
        type: "number",
      },
      current: {
        type: "boolean",
      },
    },
    required: [
      "subscribedPower",
      "subscriptionEur",
      "penaltiesEur",
      "totalCostEur",
      "current",
    ],
  },
  A11Group: {
    type: "object",
    additionalProperties: false,
    properties: {
      label: {
        type: "string",
      },
      hours: {
        type: "number",
      },
      energyKwh: {
        type: "number",
      },
      costSharePercent: {
        type: ["number", "null"],
      },
    },
    required: ["label", "hours", "energyKwh", "costSharePercent"],
  },
  A12Point: {
    type: "object",
    additionalProperties: false,
    properties: {
      siteId: {
        type: "string",
      },
      label: {
        type: "string",
      },
      baseloadWm2: {
        type: "number",
      },
      sensitivityKwhM2Dju: {
        type: "number",
      },
      annualEnergyKwh: {
        type: "number",
      },
      quadrant: {
        type: "string",
        enum: ["healthy", "envelope", "operations", "priority", "median"],
      },
    },
    required: [
      "siteId",
      "label",
      "baseloadWm2",
      "sensitivityKwhM2Dju",
      "annualEnergyKwh",
      "quadrant",
    ],
  },
  A1AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A1",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          cells: {
            type: "array",
            items: {
              $ref: "#/components/schemas/A1Cell",
            },
          },
          quantiles: {
            type: "array",
            items: {
              type: ["number", "null"],
            },
          },
          observedEnergyKwh: {
            type: ["number", "null"],
          },
          annualConclusionAllowed: {
            type: "boolean",
          },
        },
        required: [
          "cells",
          "quantiles",
          "observedEnergyKwh",
          "annualConclusionAllowed",
        ],
      },
    },
    required: ["code", "meta", "data"],
  },
  A2AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A2",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          nights: {
            type: "array",
            items: {
              $ref: "#/components/schemas/A2Night",
            },
          },
          referenceKw: {
            type: ["number", "null"],
          },
          madKw: {
            type: ["number", "null"],
          },
          toleranceKw: {
            type: ["number", "null"],
          },
          breakDate: {
            type: ["string", "null"],
          },
          currentRatio: {
            type: ["number", "null"],
          },
        },
        required: [
          "nights",
          "referenceKw",
          "madKw",
          "toleranceKw",
          "breakDate",
          "currentRatio",
        ],
      },
    },
    required: ["code", "meta", "data"],
  },
  A3AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A3",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          slots: {
            type: "array",
            items: {
              $ref: "#/components/schemas/A3Slot",
            },
          },
          selectedDate: {
            type: "string",
          },
          maximumDeviationKw: {
            type: ["number", "null"],
          },
        },
        required: ["slots", "selectedDate", "maximumDeviationKw"],
      },
    },
    required: ["code", "meta", "data"],
  },
  A4AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A4",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          days: {
            type: "array",
            items: {
              $ref: "#/components/schemas/A4Day",
            },
          },
          declaredStart: {
            type: ["string", "null"],
          },
          declaredEnd: {
            type: ["string", "null"],
          },
          averageAdvanceHours: {
            type: ["number", "null"],
          },
          averageDelayHours: {
            type: ["number", "null"],
          },
          annualOutsideHours: {
            type: ["number", "null"],
          },
        },
        required: [
          "days",
          "declaredStart",
          "declaredEnd",
          "averageAdvanceHours",
          "averageDelayHours",
          "annualOutsideHours",
        ],
      },
    },
    required: ["code", "meta", "data"],
  },
  A5AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A5",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          points: {
            type: "array",
            items: {
              $ref: "#/components/schemas/A5Point",
            },
          },
          baselineKw: {
            type: ["number", "null"],
          },
          heatingSlopeKwPerK: {
            type: ["number", "null"],
          },
          coolingSlopeKwPerK: {
            type: ["number", "null"],
          },
          heatingThresholdC: {
            type: ["number", "null"],
          },
          coolingThresholdC: {
            type: ["number", "null"],
          },
          rmseKw: {
            type: ["number", "null"],
          },
          rSquared: {
            type: ["number", "null"],
          },
        },
        required: [
          "points",
          "baselineKw",
          "heatingSlopeKwPerK",
          "coolingSlopeKwPerK",
          "heatingThresholdC",
          "coolingThresholdC",
          "rmseKw",
          "rSquared",
        ],
      },
    },
    required: ["code", "meta", "data"],
  },
  A6AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A6",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          components: {
            type: "array",
            items: {
              $ref: "#/components/schemas/AnalysisMetric",
            },
          },
          modeledEnergyKwh: {
            type: ["number", "null"],
          },
          observedEnergyKwh: {
            type: ["number", "null"],
          },
          residualKwh: {
            type: ["number", "null"],
          },
        },
        required: [
          "components",
          "modeledEnergyKwh",
          "observedEnergyKwh",
          "residualKwh",
        ],
      },
    },
    required: ["code", "meta", "data"],
  },
  A7AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A7",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          beforeSensitivity: {
            type: ["number", "null"],
          },
          afterSensitivity: {
            type: ["number", "null"],
          },
          sensitivityChangePercent: {
            type: ["number", "null"],
          },
          beforeBaseload: {
            type: ["number", "null"],
          },
          afterBaseload: {
            type: ["number", "null"],
          },
          baseloadChangePercent: {
            type: ["number", "null"],
          },
          comparable: {
            type: "boolean",
          },
          ipmvpValidated: {
            type: "boolean",
          },
        },
        required: [
          "beforeSensitivity",
          "afterSensitivity",
          "sensitivityChangePercent",
          "beforeBaseload",
          "afterBaseload",
          "baseloadChangePercent",
          "comparable",
          "ipmvpValidated",
        ],
      },
    },
    required: ["code", "meta", "data"],
  },
  A8AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A8",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          days: {
            type: "array",
            items: {
              $ref: "#/components/schemas/A8Day",
            },
          },
          conformingDays: {
            type: "integer",
          },
          driftDays: {
            type: "integer",
          },
          alertDays: {
            type: "integer",
          },
        },
        required: ["days", "conformingDays", "driftDays", "alertDays"],
      },
    },
    required: ["code", "meta", "data"],
  },
  A9AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A9",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          sites: {
            type: "array",
            items: {
              $ref: "#/components/schemas/A9SiteBenchmark",
            },
          },
          selectedIntensity: {
            type: ["number", "null"],
          },
          medianIntensity: {
            type: ["number", "null"],
          },
          bestIntensity: {
            type: ["number", "null"],
          },
          excessAgainstMedianKwh: {
            type: ["number", "null"],
          },
          annualized: {
            type: "boolean",
          },
        },
        required: [
          "sites",
          "selectedIntensity",
          "medianIntensity",
          "bestIntensity",
          "excessAgainstMedianKwh",
          "annualized",
        ],
      },
    },
    required: ["code", "meta", "data"],
  },
  A10AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A10",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          scenarios: {
            type: "array",
            items: {
              $ref: "#/components/schemas/A10Scenario",
            },
          },
          powerUnit: {
            type: ["string", "null"],
            enum: ["kW", "kVA", null],
          },
          currentPower: {
            type: ["number", "null"],
          },
          optimumPower: {
            type: ["number", "null"],
          },
          currentCostEur: {
            type: ["number", "null"],
          },
          optimumCostEur: {
            type: ["number", "null"],
          },
          savingEur: {
            type: ["number", "null"],
          },
        },
        required: [
          "scenarios",
          "powerUnit",
          "currentPower",
          "optimumPower",
          "currentCostEur",
          "optimumCostEur",
          "savingEur",
        ],
      },
    },
    required: ["code", "meta", "data"],
  },
  A11AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A11",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          groups: {
            type: "array",
            items: {
              $ref: "#/components/schemas/A11Group",
            },
          },
          topSixHundredSharePercent: {
            type: ["number", "null"],
          },
          seasonalConcentrationPercent: {
            type: ["number", "null"],
          },
          curtailableEnergyKwh: {
            type: ["number", "null"],
          },
          maximumReductionKw: {
            type: ["number", "null"],
          },
          revenueEur: {
            type: ["number", "null"],
          },
        },
        required: [
          "groups",
          "topSixHundredSharePercent",
          "seasonalConcentrationPercent",
          "curtailableEnergyKwh",
          "maximumReductionKw",
          "revenueEur",
        ],
      },
    },
    required: ["code", "meta", "data"],
  },
  A12AnalysisResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
        const: "A12",
      },
      meta: {
        $ref: "#/components/schemas/AnalysisProvenance",
      },
      data: {
        type: "object",
        additionalProperties: false,
        properties: {
          points: {
            type: "array",
            items: {
              $ref: "#/components/schemas/A12Point",
            },
          },
          medianBaseloadWm2: {
            type: ["number", "null"],
          },
          medianSensitivity: {
            type: ["number", "null"],
          },
          nonPositioned: {
            type: "array",
            items: {
              type: "string",
            },
          },
        },
        required: [
          "points",
          "medianBaseloadWm2",
          "medianSensitivity",
          "nonPositioned",
        ],
      },
    },
    required: ["code", "meta", "data"],
  },
  AnalysisResponse: {
    oneOf: [
      {
        $ref: "#/components/schemas/A1AnalysisResult",
      },
      {
        $ref: "#/components/schemas/A2AnalysisResult",
      },
      {
        $ref: "#/components/schemas/A3AnalysisResult",
      },
      {
        $ref: "#/components/schemas/A4AnalysisResult",
      },
      {
        $ref: "#/components/schemas/A5AnalysisResult",
      },
      {
        $ref: "#/components/schemas/A6AnalysisResult",
      },
      {
        $ref: "#/components/schemas/A7AnalysisResult",
      },
      {
        $ref: "#/components/schemas/A8AnalysisResult",
      },
      {
        $ref: "#/components/schemas/A9AnalysisResult",
      },
      {
        $ref: "#/components/schemas/A10AnalysisResult",
      },
      {
        $ref: "#/components/schemas/A11AnalysisResult",
      },
      {
        $ref: "#/components/schemas/A12AnalysisResult",
      },
    ],
  },
  CpePerformancePeriod: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
        description:
          "Identifiant de la période, nécessaire pour la remplacer ou la supprimer.",
      },
      siteId: {
        type: "string",
      },
      periodStart: {
        type: "string",
        format: "date-time",
      },
      periodEnd: {
        type: "string",
        format: "date-time",
      },
      referenceMwh: {
        type: "number",
      },
      observedMwh: {
        type: "number",
      },
      targetPercent: {
        type: "number",
      },
      methodVersion: {
        type: "string",
      },
      comparable: {
        type: "boolean",
      },
    },
    required: [
      "siteId",
      "periodStart",
      "periodEnd",
      "referenceMwh",
      "observedMwh",
      "targetPercent",
      "methodVersion",
      "comparable",
    ],
  },
  CpePerformancePeriodInput: {
    type: "object",
    additionalProperties: false,
    description:
      "Saisie d'une période de performance ; l'énergie observée est calculée si elle est absente.",
    properties: {
      siteId: {
        type: "string",
      },
      periodStart: {
        type: "string",
        format: "date-time",
      },
      periodEnd: {
        type: "string",
        format: "date-time",
      },
      referenceMwh: {
        type: "number",
        minimum: 0,
      },
      targetPercent: {
        type: "number",
        minimum: 0,
        maximum: 100,
      },
      observedMwh: {
        type: "number",
        minimum: 0,
      },
    },
    required: [
      "siteId",
      "periodStart",
      "periodEnd",
      "referenceMwh",
      "targetPercent",
    ],
  },
  PortfolioExportInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      config: {
        type: "object",
        additionalProperties: true,
      },
      selectedIds: {
        type: "array",
        items: {
          type: "string",
        },
        maxItems: 10000,
      },
      expectedCount: {
        type: "integer",
        minimum: 0,
        maximum: 10000,
      },
    },
    required: ["config", "expectedCount"],
  },
  PortfolioExport: {
    type: "object",
    additionalProperties: false,
    properties: {
      filename: {
        type: "string",
      },
      content: {
        type: "string",
      },
      count: {
        type: "integer",
      },
      generatedAt: {
        type: "string",
        format: "date-time",
      },
    },
    required: ["filename", "content", "count", "generatedAt"],
  },
  SavedViewScreen: {
    type: "string",
    enum: ["portfolio", "map", "workflow", "dashboard"],
  },
  SavedViewPreferenceInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      favorite: {
        type: "boolean",
      },
      opened: {
        type: "boolean",
      },
    },
  },
  SavedView: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      ownerUserId: {
        type: ["string", "null"],
      },
      ownerActive: {
        type: "boolean",
      },
      favorite: {
        type: "boolean",
      },
      compatible: {
        type: "boolean",
      },
      name: {
        type: "string",
      },
      screen: {
        $ref: "#/components/schemas/SavedViewScreen",
      },
      visibility: {
        type: "string",
        enum: ["personal", "shared"],
      },
      config: {
        type: "object",
        additionalProperties: true,
      },
      version: {
        type: "integer",
      },
      lastOpenedAt: {
        type: ["string", "null"],
        format: "date-time",
      },
      createdAt: {
        type: "string",
        format: "date-time",
      },
      updatedAt: {
        type: "string",
        format: "date-time",
      },
    },
    required: [
      "id",
      "brandId",
      "ownerUserId",
      "name",
      "screen",
      "visibility",
      "config",
      "version",
      "lastOpenedAt",
      "createdAt",
      "updatedAt",
    ],
  },
  SaveViewInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      name: {
        type: "string",
      },
      screen: {
        $ref: "#/components/schemas/SavedViewScreen",
      },
      visibility: {
        type: "string",
        enum: ["personal", "shared"],
      },
      config: {
        type: "object",
        additionalProperties: true,
      },
      expectedVersion: {
        type: "integer",
        minimum: 0,
      },
    },
    required: ["name", "screen", "visibility", "config", "expectedVersion"],
  },
  DashboardItem: {
    type: "object",
    additionalProperties: false,
    required: ["id", "kind", "siteId", "periodStart", "periodEnd"],
    properties: {
      id: {
        type: "string",
        minLength: 1,
        maxLength: 80,
      },
      kind: {
        type: "string",
        enum: ["energy", "actions"],
      },
      siteId: {
        type: ["string", "null"],
      },
      periodStart: {
        type: ["string", "null"],
      },
      periodEnd: {
        type: ["string", "null"],
      },
    },
  },
  DashboardComposition: {
    type: "object",
    additionalProperties: false,
    required: [
      "id",
      "ownerUserId",
      "revision",
      "title",
      "persona",
      "siteId",
      "periodStart",
      "periodEnd",
      "items",
      "published",
      "readOnly",
      "lastVisitedAt",
    ],
    properties: {
      id: {
        type: "string",
      },
      ownerUserId: {
        type: "string",
      },
      revision: {
        type: "integer",
        minimum: 0,
      },
      title: {
        type: "string",
        minLength: 1,
        maxLength: 120,
      },
      persona: {
        type: "string",
        enum: ["manager", "operations", "executive"],
      },
      siteId: {
        type: "string",
      },
      periodStart: {
        type: "string",
      },
      periodEnd: {
        type: "string",
      },
      items: {
        type: "array",
        maxItems: 6,
        items: {
          $ref: "#/components/schemas/DashboardItem",
        },
      },
      published: {
        type: "boolean",
      },
      readOnly: {
        type: "boolean",
      },
      lastVisitedAt: {
        type: ["string", "null"],
      },
    },
  },
  DashboardResult: {
    type: "object",
    additionalProperties: false,
    required: ["id", "parameterKey", "snapshot", "expiresAt"],
    properties: {
      id: {
        type: "string",
      },
      parameterKey: {
        type: "string",
      },
      snapshot: {
        $ref: "#/components/schemas/EnergyReportSnapshot",
      },
      expiresAt: {
        type: "string",
      },
    },
  },
  EnergyReportCreate: {
    type: "object",
    additionalProperties: false,
    required: ["snapshot", "token", "idempotencyKey"],
    properties: {
      snapshot: {
        $ref: "#/components/schemas/EnergyReportSnapshot",
      },
      token: {
        type: "string",
        maxLength: 200,
      },
      idempotencyKey: {
        type: "string",
        minLength: 1,
        maxLength: 100,
      },
    },
  },
  EnergyReportAction: {
    type: "object",
    additionalProperties: false,
    required: ["expectedRevision"],
    properties: {
      expectedRevision: {
        type: "integer",
        minimum: 1,
      },
    },
  },
  EnergyReportInput: {
    type: "object",
    additionalProperties: false,
    required: [
      "title",
      "template",
      "siteIds",
      "periodStart",
      "periodEnd",
      "locale",
      "sections",
      "audience",
    ],
    properties: {
      title: {
        type: "string",
        minLength: 1,
        maxLength: 160,
      },
      template: {
        type: "string",
        enum: ["monthly", "steering"],
      },
      siteIds: {
        type: "array",
        minItems: 1,
        maxItems: 10,
        uniqueItems: true,
        items: {
          type: "string",
        },
      },
      periodStart: {
        type: "string",
      },
      periodEnd: {
        type: "string",
      },
      locale: {
        type: "string",
        enum: ["fr-FR"],
      },
      sections: {
        type: "array",
        minItems: 1,
        maxItems: 3,
        uniqueItems: true,
        items: {
          type: "string",
          enum: ["energy", "actions", "daily"],
        },
      },
      audience: {
        type: "string",
        enum: ["internal", "client"],
      },
      supersedesId: {
        type: ["string", "null"],
      },
    },
  },
  EnergyReportSite: {
    type: "object",
    required: [
      "id",
      "name",
      "timezone",
      "pointIds",
      "sources",
      "freshAt",
      "synthetic",
      "days",
      "electricityKwh",
      "gasKwh",
      "missingDays",
      "expectedDays",
      "actions",
    ],
    properties: {
      id: {
        type: "string",
      },
      name: {
        type: "string",
      },
      timezone: {
        type: "string",
      },
      pointIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
      sources: {
        type: "array",
        items: {
          type: "string",
        },
      },
      freshAt: {
        type: ["string", "null"],
      },
      synthetic: {
        type: "boolean",
      },
      days: {
        type: "array",
        items: {
          $ref: "#/components/schemas/SiteDashboardDay",
        },
      },
      electricityKwh: {
        type: ["number", "null"],
      },
      gasKwh: {
        type: ["number", "null"],
      },
      missingDays: {
        type: "integer",
      },
      expectedDays: {
        type: "integer",
      },
      actions: {
        type: "array",
        items: {
          type: "object",
          required: ["id", "title", "summary", "stage", "dueAt"],
          properties: {
            id: {
              type: "string",
            },
            title: {
              type: "string",
            },
            summary: {
              type: "string",
            },
            stage: {
              type: "string",
            },
            dueAt: {
              type: ["string", "null"],
            },
          },
        },
      },
    },
  },
  EnergyReportSnapshot: {
    type: "object",
    required: [
      "id",
      "title",
      "brandName",
      "input",
      "methodVersion",
      "dataVersion",
      "generatedAt",
      "sites",
      "limits",
    ],
    properties: {
      id: {
        type: "string",
      },
      title: {
        type: "string",
      },
      brandName: {
        type: "string",
      },
      input: {
        $ref: "#/components/schemas/EnergyReportInput",
      },
      methodVersion: {
        type: "string",
      },
      dataVersion: {
        type: "integer",
      },
      generatedAt: {
        type: "string",
      },
      sites: {
        type: "array",
        items: {
          $ref: "#/components/schemas/EnergyReportSite",
        },
      },
      limits: {
        type: "array",
        items: {
          type: "string",
        },
      },
    },
  },
  EnergyReportPreview: {
    type: "object",
    required: ["snapshot", "token"],
    properties: {
      snapshot: {
        $ref: "#/components/schemas/EnergyReportSnapshot",
      },
      token: {
        type: "string",
      },
    },
  },
  EnergyReport: {
    type: "object",
    required: [
      "id",
      "revision",
      "state",
      "snapshot",
      "expiresAt",
      "approvedAt",
      "dispatchedAt",
      "recipientCount",
      "pdfSha256",
    ],
    properties: {
      authorUserId: {
        type: ["string", "null"],
      },
      id: {
        type: "string",
      },
      revision: {
        type: "integer",
      },
      state: {
        type: "string",
        enum: ["draft", "approved", "dispatched", "withdrawn", "expired"],
      },
      snapshot: {
        $ref: "#/components/schemas/EnergyReportSnapshot",
      },
      expiresAt: {
        type: "string",
      },
      approvedAt: {
        type: ["string", "null"],
      },
      dispatchedAt: {
        type: ["string", "null"],
      },
      recipientCount: {
        type: "integer",
      },
      pdfSha256: {
        type: "string",
      },
    },
  },
  EnergyReportPolicy: {
    type: "object",
    required: ["enabled", "retentionDays", "message"],
    properties: {
      enabled: {
        type: "boolean",
      },
      retentionDays: {
        type: ["integer", "null"],
      },
      message: {
        type: "string",
      },
    },
  },
  EnergyReportSchedule: {
    type: "object",
    required: [
      "id",
      "revision",
      "title",
      "siteIds",
      "template",
      "audience",
      "sections",
      "timezone",
      "dayOfMonth",
      "active",
      "lastPeriod",
      "lastError",
    ],
    properties: {
      id: {
        type: "string",
      },
      revision: {
        type: "integer",
      },
      title: {
        type: "string",
        minLength: 1,
        maxLength: 160,
      },
      siteIds: {
        type: "array",
        minItems: 1,
        maxItems: 10,
        uniqueItems: true,
        items: {
          type: "string",
        },
      },
      template: {
        type: "string",
        enum: ["monthly", "steering"],
      },
      audience: {
        type: "string",
        enum: ["internal", "client"],
      },
      sections: {
        type: "array",
        minItems: 1,
        maxItems: 3,
        uniqueItems: true,
        items: {
          type: "string",
          enum: ["energy", "actions", "daily"],
        },
      },
      timezone: {
        type: "string",
      },
      dayOfMonth: {
        type: "integer",
        minimum: 1,
        maximum: 28,
      },
      active: {
        type: "boolean",
      },
      lastPeriod: {
        type: ["string", "null"],
      },
      lastError: {
        type: ["string", "null"],
      },
    },
  },
  ReferenceImportFile: {
    type: "object",
    additionalProperties: false,
    required: ["filename", "base64", "separator", "encoding"],
    properties: {
      filename: {
        type: "string",
        maxLength: 200,
      },
      base64: {
        type: "string",
        maxLength: 1400000,
      },
      separator: {
        type: "string",
        enum: [";", ",", "\t"],
      },
      encoding: {
        type: "string",
        enum: ["utf-8", "windows-1252"],
      },
    },
  },
  ReferenceImportTable: {
    type: "object",
    additionalProperties: false,
    required: ["columns", "rows"],
    properties: {
      columns: {
        type: "array",
        items: {
          type: "string",
        },
      },
      rows: {
        type: "array",
        items: {
          type: "array",
          items: {
            type: "string",
          },
        },
      },
    },
  },
  ReferenceBatchInput: {
    type: "object",
    additionalProperties: false,
    required: ["operation", "kind"],
    properties: {
      operation: {
        type: "string",
        enum: ["import", "tags", "schedule", "duplicate", "assignee"],
      },
      kind: {
        type: "string",
        enum: ["companies", "sites", "delivery-points"],
      },
      rows: {
        type: "array",
        minItems: 1,
        maxItems: 250,
        items: {
          type: "object",
          additionalProperties: {
            type: "string",
            maxLength: 2000,
          },
        },
      },
      ids: {
        type: "array",
        minItems: 1,
        maxItems: 250,
        uniqueItems: true,
        items: {
          type: "string",
        },
      },
      tagIds: {
        type: "array",
        maxItems: 30,
        uniqueItems: true,
        items: {
          type: "string",
        },
      },
      schedule: {
        type: "array",
        maxItems: 28,
        items: {
          $ref: "#/components/schemas/OccupancyScheduleEntry",
        },
      },
      assigneeMembershipId: {
        type: ["string", "null"],
      },
      sourceSiteId: {
        type: "string",
      },
      companyId: {
        type: "string",
      },
      newName: {
        type: "string",
        minLength: 2,
        maxLength: 200,
      },
      copyFields: {
        type: "array",
        uniqueItems: true,
        items: {
          type: "string",
          enum: ["tags", "areas", "schedule"],
        },
      },
      surfaceUnit: {
        type: "string",
        enum: ["m2", "ha"],
      },
    },
  },
  ReferenceBatchRow: {
    type: "object",
    additionalProperties: false,
    required: [
      "line",
      "entityId",
      "label",
      "state",
      "before",
      "after",
      "issues",
    ],
    properties: {
      inputValues: {
        type: "object",
        additionalProperties: {
          type: "string",
          maxLength: 2000,
        },
      },
      surfaceUnit: {
        type: "string",
        enum: ["m2", "ha"],
      },
      line: {
        type: "integer",
        minimum: 1,
      },
      entityId: {
        type: "string",
      },
      label: {
        type: "string",
      },
      state: {
        type: "string",
        enum: [
          "ready",
          "ignored",
          "invalid",
          "applied",
          "failed",
          "cancelled",
          "compensated",
        ],
      },
      before: {
        type: ["object", "null"],
        additionalProperties: true,
      },
      after: {
        type: ["object", "null"],
        additionalProperties: true,
      },
      issues: {
        type: "array",
        items: {
          type: "object",
          additionalProperties: false,
          required: ["column", "value", "message", "severity"],
          properties: {
            column: {
              type: "string",
            },
            value: {
              type: "string",
            },
            message: {
              type: "string",
            },
            severity: {
              type: "string",
              enum: ["error", "warning"],
            },
          },
        },
      },
    },
  },
  ReferenceBatchPreview: {
    type: "object",
    additionalProperties: false,
    required: ["token", "expiresAt", "rows"],
    properties: {
      token: {
        type: "string",
      },
      expiresAt: {
        type: "string",
      },
      rows: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ReferenceBatchRow",
        },
      },
    },
  },
  ReferenceBatchAction: {
    type: "object",
    additionalProperties: false,
    required: ["expectedVersion"],
    properties: {
      expectedVersion: {
        type: "integer",
        minimum: 1,
      },
      retryFailures: {
        type: "boolean",
      },
    },
  },
  ReferenceBatchJob: {
    type: "object",
    additionalProperties: false,
    required: [
      "id",
      "operation",
      "kind",
      "state",
      "version",
      "createdAt",
      "rows",
    ],
    properties: {
      id: {
        type: "string",
      },
      operation: {
        type: "string",
        enum: ["import", "tags", "schedule", "duplicate", "assignee"],
      },
      kind: {
        type: "string",
        enum: ["companies", "sites", "delivery-points"],
      },
      state: {
        type: "string",
        enum: ["prepared", "running", "completed", "partial", "cancelled"],
      },
      version: {
        type: "integer",
        minimum: 1,
      },
      createdAt: {
        type: "string",
      },
      rows: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ReferenceBatchRow",
        },
      },
    },
  },
  WorkflowPublication: {
    type: "object",
    additionalProperties: false,
    required: [
      "id",
      "workflowItemId",
      "version",
      "createdAt",
      "item",
      "context",
    ],
    properties: {
      id: {
        type: "string",
      },
      workflowItemId: {
        type: "string",
      },
      version: {
        type: "integer",
        minimum: 1,
      },
      createdAt: {
        type: "string",
      },
      item: {
        $ref: "#/components/schemas/WorkflowItem",
      },
      context: {
        type: ["object", "null"],
        additionalProperties: false,
        required: ["comments", "attachments", "recipientCount"],
        properties: {
          comments: {
            type: "array",
            items: {
              type: "object",
              additionalProperties: false,
              required: ["id", "body"],
              properties: {
                id: {
                  type: "string",
                },
                body: {
                  type: "string",
                },
              },
            },
          },
          attachments: {
            type: "array",
            items: {
              type: "object",
              additionalProperties: false,
              required: ["id", "filename"],
              properties: {
                id: {
                  type: "string",
                },
                filename: {
                  type: "string",
                },
              },
            },
          },
          recipientCount: {
            type: "integer",
            minimum: 0,
          },
        },
      },
    },
  },
  WorkflowPublicationPreview: {
    type: "object",
    additionalProperties: false,
    required: [
      "token",
      "expiresAt",
      "expectedVersion",
      "item",
      "recipients",
      "recipientCount",
      "comments",
      "attachments",
    ],
    properties: {
      token: {
        type: "string",
      },
      expiresAt: {
        type: "string",
      },
      expectedVersion: {
        type: "integer",
        minimum: 1,
      },
      item: {
        $ref: "#/components/schemas/WorkflowItem",
      },
      recipients: {
        type: "array",
        items: {
          type: "object",
          additionalProperties: false,
          required: ["membershipId", "displayName"],
          properties: {
            membershipId: {
              type: "string",
            },
            displayName: {
              type: "string",
            },
          },
        },
      },
      recipientCount: {
        type: "integer",
        minimum: 0,
      },
      comments: {
        type: "array",
        items: {
          type: "object",
          additionalProperties: false,
          required: ["id", "body"],
          properties: {
            id: {
              type: "string",
            },
            body: {
              type: "string",
            },
          },
        },
      },
      attachments: {
        type: "array",
        items: {
          type: "object",
          additionalProperties: false,
          required: ["id", "filename"],
          properties: {
            id: {
              type: "string",
            },
            filename: {
              type: "string",
            },
          },
        },
      },
    },
  },
  AccessInvitationAction: {
    type: "object",
    additionalProperties: false,
    required: ["action", "expectedVersion"],
    properties: {
      action: {
        type: "string",
        enum: ["resend", "revoke"],
      },
      expectedVersion: {
        type: "integer",
        minimum: 1,
      },
    },
  },
  AccessInvitationState: {
    type: "object",
    additionalProperties: false,
    required: [
      "version",
      "state",
      "expiresAt",
      "deliveryState",
      "scopeAvailable",
    ],
    properties: {
      version: {
        type: "integer",
        minimum: 1,
      },
      state: {
        type: "string",
        enum: ["prepared", "expired", "revoked", "accepted", "unavailable"],
      },
      expiresAt: {
        type: ["string", "null"],
      },
      deliveryState: {
        type: "string",
        enum: [
          "unknown",
          "prepared",
          "accepted",
          "delivered",
          "not_sent",
          "bounced",
          "failed",
        ],
      },
      scopeAvailable: {
        type: "boolean",
      },
    },
  },
  WorkflowAttachmentInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      filename: {
        type: "string",
        minLength: 1,
        maxLength: 140,
      },
      base64: {
        type: "string",
        minLength: 1,
        maxLength: 1333336,
      },
      audience: {
        type: "string",
        enum: ["internal", "client"],
      },
    },
    required: ["filename", "base64", "audience"],
  },
  AttachmentTicket: {
    type: "object",
    additionalProperties: false,
    properties: {
      token: {
        type: "string",
      },
      expiresAt: {
        type: "string",
      },
    },
    required: ["token", "expiresAt"],
  },
  WorkflowAttachment: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      workflowItemId: {
        type: "string",
      },
      filename: {
        type: "string",
      },
      mediaType: {
        type: "string",
      },
      size: {
        type: "integer",
      },
      sha256: {
        type: "string",
      },
      audience: {
        type: "string",
        enum: ["internal", "client"],
      },
      status: {
        type: "string",
        enum: ["quarantine", "clean", "rejected", "expired"],
      },
      createdAt: {
        type: "string",
      },
      expiresAt: {
        type: "string",
      },
    },
    required: [
      "id",
      "workflowItemId",
      "filename",
      "mediaType",
      "size",
      "sha256",
      "audience",
      "status",
      "createdAt",
      "expiresAt",
    ],
  },
  WorkflowAttachments: {
    type: "object",
    additionalProperties: false,
    properties: {
      policy: {
        type: "object",
        additionalProperties: false,
        properties: {
          configured: {
            type: "boolean",
          },
          maxBytes: {
            type: "integer",
          },
          retentionDays: {
            type: ["integer", "null"],
          },
          message: {
            type: "string",
          },
        },
        required: ["configured", "maxBytes", "retentionDays", "message"],
      },
      items: {
        type: "array",
        items: {
          $ref: "#/components/schemas/WorkflowAttachment",
        },
      },
    },
    required: ["policy", "items"],
  },
  WorkflowComment: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      workflowItemId: {
        type: "string",
      },
      authorUserId: {
        type: ["string", "null"],
      },
      authorName: {
        type: "string",
      },
      body: {
        type: "string",
      },
      revision: {
        type: "integer",
      },
      mentionMembershipIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
      history: {
        type: "array",
        items: {
          $ref: "#/components/schemas/WorkflowCommentRevision",
        },
      },
      audience: {
        type: "string",
        enum: ["internal", "client"],
      },
      editedAt: {
        type: ["string", "null"],
        format: "date-time",
      },
      createdAt: {
        type: "string",
        format: "date-time",
      },
    },
    required: [
      "id",
      "brandId",
      "workflowItemId",
      "authorUserId",
      "authorName",
      "body",
      "audience",
      "editedAt",
      "createdAt",
    ],
  },
  WorkflowCommentRevision: {
    type: "object",
    additionalProperties: false,
    properties: {
      body: {
        type: "string",
      },
      at: {
        type: "string",
      },
      revision: {
        type: "integer",
      },
    },
    required: ["body", "at", "revision"],
  },
  WorkflowCommentEdit: {
    type: "object",
    additionalProperties: false,
    properties: {
      body: {
        type: "string",
        maxLength: 4000,
        minLength: 1,
      },
      expectedVersion: {
        type: "integer",
        minimum: 1,
      },
    },
    required: ["body", "expectedVersion"],
  },
  WorkflowCommentInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      body: {
        type: "string",
      },
      mentionMembershipIds: {
        type: "array",
        maxItems: 20,
        uniqueItems: true,
        items: {
          type: "string",
        },
      },
      audience: {
        type: "string",
        enum: ["internal", "client"],
      },
    },
    required: ["body", "audience"],
  },
  NotificationStateInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      read: {
        type: "boolean",
      },
      snoozedUntil: {
        type: ["string", "null"],
      },
    },
  },
  Notification: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      eventType: {
        type: "string",
      },
      title: {
        type: "string",
      },
      message: {
        type: "string",
      },
      path: {
        type: "string",
      },
      sourceType: {
        type: "string",
      },
      sourceId: {
        type: "string",
      },
      readAt: {
        type: ["string", "null"],
        format: "date-time",
      },
      snoozedUntil: {
        type: ["string", "null"],
      },
      emailState: {
        type: "string",
        enum: [
          "disabled",
          "queued",
          "sending",
          "accepted",
          "not_sent",
          "unknown",
          "cancelled",
        ],
      },
      createdAt: {
        type: "string",
        format: "date-time",
      },
    },
    required: [
      "id",
      "brandId",
      "eventType",
      "title",
      "message",
      "path",
      "sourceType",
      "sourceId",
      "readAt",
      "createdAt",
    ],
  },
  NotificationDigest: {
    type: "string",
    enum: ["immediate", "daily", "weekly", "off"],
  },
  NotificationPreference: {
    type: "object",
    additionalProperties: false,
    properties: {
      eventType: {
        type: "string",
      },
      inApp: {
        type: "boolean",
      },
      email: {
        type: "boolean",
      },
      digest: {
        $ref: "#/components/schemas/NotificationDigest",
      },
    },
    required: ["eventType", "inApp", "email", "digest"],
  },
  NotificationPreferenceInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      inApp: {
        type: "boolean",
      },
      email: {
        type: "boolean",
      },
      digest: {
        $ref: "#/components/schemas/NotificationDigest",
      },
    },
    required: ["inApp", "email", "digest"],
  },
  WorkflowAssignee: {
    type: "object",
    additionalProperties: false,
    properties: {
      membershipId: {
        type: "string",
      },
      userId: {
        type: "string",
      },
      displayName: {
        type: "string",
      },
    },
    required: ["membershipId", "userId", "displayName"],
  },
  WorkflowItem: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      companyId: {
        type: "string",
      },
      siteId: {
        type: "string",
      },
      title: {
        type: "string",
      },
      summary: {
        type: "string",
      },
      status: {
        $ref: "#/components/schemas/PublicationStatus",
      },
      priority: {
        type: "string",
        enum: ["low", "medium", "high"],
      },
      impactKwh: {
        type: ["number", "null"],
      },
      impactEur: {
        type: ["number", "null"],
      },
      owner: {
        type: "string",
      },
      revision: {
        type: "integer",
        minimum: 1,
      },
      assigneeMembershipId: {
        type: ["string", "null"],
      },
      deputyMembershipId: {
        type: ["string", "null"],
      },
      assigneeName: {
        type: ["string", "null"],
      },
      assignmentState: {
        type: "string",
        enum: ["assigned", "unassigned", "needs_reassignment"],
      },
      followerMembershipIds: {
        type: "array",
        maxItems: 20,
        uniqueItems: true,
        items: {
          type: "string",
        },
      },
      dueLocalDate: {
        type: ["string", "null"],
      },
      dueTimezone: {
        type: ["string", "null"],
      },
      dueAt: {
        type: ["string", "null"],
      },
      createdAt: {
        type: "string",
      },
      stage: {
        $ref: "#/components/schemas/WorkflowStage",
      },
      rule: {
        type: "string",
      },
      evidence: {
        type: "string",
      },
      rejectionReason: {
        type: "string",
      },
      beforeValue: {
        type: "number",
      },
      afterValue: {
        type: "number",
      },
      budgetEur: {
        type: "number",
      },
      verified: {
        type: "boolean",
      },
      sourceIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
      history: {
        type: "array",
        items: {
          $ref: "#/components/schemas/WorkflowHistoryEntry",
        },
      },
    },
    required: [
      "id",
      "brandId",
      "companyId",
      "siteId",
      "title",
      "summary",
      "status",
      "priority",
      "impactKwh",
      "impactEur",
      "owner",
      "dueAt",
      "createdAt",
    ],
  },
  WorkflowItemMutation: {
    type: "object",
    additionalProperties: false,
    properties: {
      kind: {
        type: "string",
        enum: ["anomalies", "recommendations", "works", "reports"],
      },
      item: {
        $ref: "#/components/schemas/WorkflowItem",
      },
      publicationToken: {
        type: "string",
        maxLength: 200,
      },
    },
    required: ["kind", "item"],
  },
  WorkflowHistoryEntry: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      at: {
        type: "string",
      },
      actor: {
        type: "string",
      },
      action: {
        type: "string",
      },
      detail: {
        type: "string",
      },
    },
    required: ["id", "at", "actor", "action"],
  },
  SiteArea: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      siteId: {
        type: "string",
      },
      parentAreaId: {
        type: "string",
      },
      type: {
        type: "string",
        enum: ["ensemble", "building", "floor", "zone", "other"],
      },
      name: {
        type: "string",
      },
      reference: {
        type: "string",
      },
      surfaceM2: {
        type: "number",
      },
    },
    required: ["id", "brandId", "siteId", "type", "name", "reference"],
  },
  TagDefinition: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      category: {
        type: "string",
      },
      label: {
        type: "string",
      },
    },
    required: ["id", "brandId", "category", "label"],
  },
  SiteTagAssignment: {
    type: "object",
    additionalProperties: false,
    properties: {
      siteId: {
        type: "string",
      },
      tagId: {
        type: "string",
      },
    },
    required: ["siteId", "tagId"],
  },
  Meter: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      siteId: {
        type: "string",
      },
      deliveryPointId: {
        type: "string",
      },
      siteAreaId: {
        type: "string",
      },
      parentMeterId: {
        type: "string",
      },
      kind: {
        type: "string",
        enum: ["network", "submeter", "virtual"],
      },
      energy: {
        $ref: "#/components/schemas/Energy",
      },
      serialNumber: {
        type: "string",
      },
      name: {
        type: "string",
      },
      status: {
        type: "string",
        enum: ["active", "inactive"],
      },
      coveragePercent: {
        type: ["number", "null"],
        minimum: 0,
        maximum: 100,
      },
      transformationRatio: {
        type: "number",
      },
    },
    required: [
      "id",
      "brandId",
      "siteId",
      "kind",
      "energy",
      "serialNumber",
      "name",
      "status",
      "coveragePercent",
    ],
  },
  Equipment: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      siteId: {
        type: "string",
      },
      siteAreaId: {
        type: "string",
      },
      meterId: {
        type: "string",
      },
      category: {
        type: "string",
      },
      name: {
        type: "string",
      },
      manufacturer: {
        type: "string",
      },
      model: {
        type: "string",
      },
      serialNumber: {
        type: "string",
      },
      status: {
        type: "string",
        enum: [
          "operational",
          "monitoring",
          "inspection",
          "inactive",
          "unknown",
        ],
      },
      commissionedAt: {
        type: "string",
      },
      ratedPowerKw: {
        type: "number",
      },
    },
    required: [
      "id",
      "brandId",
      "siteId",
      "category",
      "name",
      "manufacturer",
      "model",
      "serialNumber",
      "status",
    ],
  },
  Connector: {
    type: "object",
    additionalProperties: false,
    description:
      "Module technique de synchronisation de la plateforme. Indépendant des marques, administré et visible uniquement par le super-admin ; les managers et clients ne le connaissent pas.",
    properties: {
      id: {
        type: "string",
      },
      name: {
        type: "string",
      },
      category: {
        type: "string",
        enum: ["energy", "invoice", "weather", "gtb"],
      },
      provider: {
        type: "string",
        enum: ["enedis", "grdf", "meteo-france", "wit"],
        description:
          "Fournisseur réellement raccordé quand `mode` vaut `api`. `enedis` consomme les relevés chargés dans le schéma `ingest` par `ingest:import` pour tous les PRM actifs de la plateforme et alimente une série de puissance (kW) et une série d'énergie journalière (kWh) par point ; `grdf` alimente pour tous les PCE actifs une série d'énergie (kWh) et une série de volume (m3) à périodes irrégulières, par l'API GRDF ADICT du service des connecteurs (module `grdf` : appel quotidien du 1er au jour limite du mois tant que les données du mois précédent manquent, alerte journalisée le jour limite) ou, si le service n'héberge pas cette source, depuis les relevés publiés déposés en transit. `meteo-france` et `wit` n'ont pas de zone de transit : la collecte est confiée au service des connecteurs `apps/connectors`, qui télécharge les fichiers horaires Météo-France des départements demandés dans le schéma `weather`, ou lit chaque heure les capteurs de la GTB WIT (énergie dans `measurement_values`, états dans `gtb`) ; l'exécution reste `running` jusqu'à la relecture de son bilan (`GET …/module-sync`).",
      },
      status: {
        type: "string",
        enum: ["healthy", "warning", "error"],
      },
      lastSyncAt: {
        type: "string",
      },
      freshnessMinutes: {
        type: "number",
      },
      mode: {
        type: "string",
        enum: ["simulated", "api"],
      },
      schedule: {
        type: "string",
        description:
          "Fréquence cible de la collecte : `manual`, `hourly`, `daily` ou `monthly` (GRDF publie un relevé par mois).",
        enum: ["manual", "hourly", "daily", "monthly"],
      },
      lastHealthyAt: {
        type: "string",
      },
      lastError: {
        type: "string",
      },
      retryCount: {
        type: "number",
      },
      lastRunId: {
        type: "string",
      },
      lastItemCount: {
        type: "number",
      },
      openGapCount: {
        type: "number",
      },
    },
    required: [
      "id",
      "name",
      "category",
      "status",
      "lastSyncAt",
      "freshnessMinutes",
    ],
  },
  EmailLogStatus: {
    type: "string",
    enum: [
      "queued",
      "accepted",
      "delivered",
      "failed",
      "bounced",
      "complained",
      "not_sent",
      "unknown",
    ],
  },
  EmailLogListItem: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      brandName: {
        type: "string",
      },
      environment: {
        type: "string",
      },
      channel: {
        type: "string",
        enum: ["platform", "mandate"],
      },
      emailType: {
        type: "string",
      },
      provider: {
        type: "string",
        enum: ["postmark", "local"],
      },
      recipientEmail: {
        type: "string",
      },
      requestedRecipientEmail: {
        type: "string",
      },
      subject: {
        type: "string",
      },
      status: {
        $ref: "#/components/schemas/EmailLogStatus",
      },
      providerMessageId: {
        type: "string",
      },
      lastErrorMessage: {
        type: "string",
      },
      createdAt: {
        type: "string",
        format: "date-time",
      },
      acceptedAt: {
        type: "string",
        format: "date-time",
      },
      deliveredAt: {
        type: "string",
        format: "date-time",
      },
      lastEventAt: {
        type: "string",
        format: "date-time",
      },
      contentAvailable: {
        type: "boolean",
      },
      attemptCount: {
        type: "integer",
        minimum: 1,
        description:
          "Nombre de tentatives dans la ligne regroupée, après filtrage.",
      },
      statuses: {
        type: "array",
        items: {
          $ref: "#/components/schemas/EmailLogStatus",
        },
        description:
          "Statuts distincts des tentatives regroupées, sans masquer les incidents.",
      },
    },
    required: [
      "id",
      "brandName",
      "environment",
      "channel",
      "emailType",
      "provider",
      "recipientEmail",
      "requestedRecipientEmail",
      "subject",
      "status",
      "createdAt",
      "contentAvailable",
    ],
  },
  EmailLogStats: {
    type: "object",
    additionalProperties: false,
    properties: {
      total: {
        type: "integer",
      },
      delivered: {
        type: "integer",
      },
      accepted: {
        type: "integer",
      },
      incidents: {
        type: "integer",
      },
      notSent: {
        type: "integer",
      },
      unmatchedEvents: {
        type: "integer",
      },
    },
    required: [
      "total",
      "delivered",
      "accepted",
      "incidents",
      "notSent",
      "unmatchedEvents",
    ],
  },
  EmailLogListResponse: {
    type: "object",
    additionalProperties: false,
    properties: {
      stats: {
        $ref: "#/components/schemas/EmailLogStats",
      },
      items: {
        type: "array",
        items: {
          $ref: "#/components/schemas/EmailLogListItem",
        },
      },
      nextCursor: {
        type: "string",
      },
    },
    required: ["stats", "items"],
  },
  EmailDeliveryEvent: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      providerMessageId: {
        type: "string",
      },
      eventType: {
        type: "string",
        enum: ["delivery", "bounce", "spam_complaint"],
      },
      recipientEmail: {
        type: "string",
      },
      details: {
        type: "string",
      },
      bounceType: {
        type: "string",
      },
      bounceCode: {
        type: "integer",
      },
      inactiveRecipient: {
        type: "boolean",
      },
      canActivate: {
        type: "boolean",
      },
      occurredAt: {
        type: "string",
        format: "date-time",
      },
      matched: {
        type: "boolean",
      },
    },
    required: [
      "id",
      "providerMessageId",
      "eventType",
      "recipientEmail",
      "occurredAt",
      "matched",
    ],
  },
  EmailLogDetailRecord: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      brandName: {
        type: "string",
      },
      environment: {
        type: "string",
      },
      channel: {
        type: "string",
        enum: ["platform", "mandate"],
      },
      emailType: {
        type: "string",
      },
      provider: {
        type: "string",
        enum: ["postmark", "local"],
      },
      recipientEmail: {
        type: "string",
      },
      requestedRecipientEmail: {
        type: "string",
      },
      subject: {
        type: "string",
      },
      status: {
        $ref: "#/components/schemas/EmailLogStatus",
      },
      providerMessageId: {
        type: "string",
      },
      lastErrorMessage: {
        type: "string",
      },
      createdAt: {
        type: "string",
        format: "date-time",
      },
      acceptedAt: {
        type: "string",
        format: "date-time",
      },
      deliveredAt: {
        type: "string",
        format: "date-time",
      },
      lastEventAt: {
        type: "string",
        format: "date-time",
      },
      contentAvailable: {
        type: "boolean",
      },
      senderName: {
        type: "string",
      },
      senderEmail: {
        type: "string",
      },
      contextType: {
        type: "string",
      },
      contextId: {
        type: "string",
      },
      requestId: {
        type: "string",
      },
      messageStream: {
        type: "string",
      },
      contentSha256: {
        type: "string",
      },
      contentExpiresAt: {
        type: "string",
        format: "date-time",
      },
      contentPurgedAt: {
        type: "string",
        format: "date-time",
      },
      notSentReason: {
        type: "string",
      },
      lastErrorCode: {
        type: "string",
      },
    },
    required: [
      "id",
      "brandName",
      "environment",
      "channel",
      "emailType",
      "provider",
      "recipientEmail",
      "requestedRecipientEmail",
      "subject",
      "status",
      "createdAt",
      "contentAvailable",
      "senderName",
      "senderEmail",
      "messageStream",
      "contentSha256",
      "contentExpiresAt",
    ],
  },
  EmailPreview: {
    type: "object",
    additionalProperties: false,
    properties: {
      available: {
        type: "boolean",
      },
      html: {
        type: "string",
      },
      text: {
        type: "string",
      },
      reason: {
        type: "string",
        enum: ["expired", "unavailable"],
      },
    },
    required: ["available"],
  },
  EmailLogDetail: {
    type: "object",
    additionalProperties: false,
    properties: {
      log: {
        $ref: "#/components/schemas/EmailLogDetailRecord",
      },
      preview: {
        $ref: "#/components/schemas/EmailPreview",
      },
      events: {
        type: "array",
        items: {
          $ref: "#/components/schemas/EmailDeliveryEvent",
        },
      },
      recipients: {
        type: "array",
        items: {
          $ref: "#/components/schemas/EmailLogListItem",
        },
        description:
          "Tentatives du même contenu, contexte, expéditeur et journée de Paris, avec accès au détail individuel par identifiant.",
      },
    },
    required: ["log", "preview", "events"],
  },
  PostmarkWebhookReceipt: {
    type: "object",
    additionalProperties: false,
    properties: {
      accepted: {
        type: "boolean",
      },
      ignored: {
        type: "boolean",
      },
      duplicate: {
        type: "boolean",
      },
      matched: {
        type: "boolean",
      },
    },
    required: ["accepted"],
  },
  AuditActorRole: {
    type: "string",
    enum: ["super_admin", "manager", "client", "system", "unknown"],
  },
  AuditEvent: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
        description:
          "Marque concernée ; absente pour une opération de plateforme (journal du super-admin).",
      },
      actor: {
        type: "string",
      },
      actorUserId: {
        type: "string",
      },
      actorMembershipId: {
        type: "string",
        description:
          "Membership Brand utilisée pour l’action ; absente pour une action plateforme.",
      },
      actorRole: {
        $ref: "#/components/schemas/AuditActorRole",
        description:
          "Rôle figé au moment de l'action ; peut être inconnu pour une trace historique non qualifiable.",
      },
      action: {
        type: "string",
      },
      target: {
        type: "string",
      },
      reason: {
        type: "string",
      },
      beforeState: {
        type: "object",
        additionalProperties: true,
      },
      afterState: {
        type: "object",
        additionalProperties: true,
      },
      createdAt: {
        type: "string",
      },
    },
    required: ["id", "actor", "action", "target", "createdAt"],
  },
  AccountActivityPage: {
    type: "object",
    additionalProperties: false,
    properties: {
      items: {
        type: "array",
        items: {
          $ref: "#/components/schemas/AuditEvent",
        },
      },
      nextCursor: {
        type: "string",
      },
    },
    required: ["items"],
  },
  Session: {
    type: "object",
    additionalProperties: false,
    description:
      "Réponse de `GET /session` : identité complète (toutes adhésions), adhésion active, marque active et marques accessibles. Le jeton n'est jamais exposé au navigateur.",
    properties: {
      user: {
        $ref: "#/components/schemas/User",
      },
      activeMembership: {
        $ref: "#/components/schemas/Membership",
      },
      brand: {
        $ref: "#/components/schemas/Brand",
      },
      brands: {
        type: "array",
        items: {
          $ref: "#/components/schemas/Brand",
        },
      },
      totpEnrolled: {
        type: "boolean",
      },
    },
    required: ["user", "activeMembership", "brand", "brands", "totpEnrolled"],
  },
  DemoDatabase: {
    type: "object",
    additionalProperties: false,
    properties: {
      brands: {
        type: "array",
        items: {
          $ref: "#/components/schemas/Brand",
        },
      },
      users: {
        type: "array",
        items: {
          $ref: "#/components/schemas/User",
        },
      },
      companies: {
        type: "array",
        items: {
          $ref: "#/components/schemas/Company",
        },
      },
      sites: {
        type: "array",
        items: {
          $ref: "#/components/schemas/Site",
        },
      },
      deliveryPoints: {
        type: "array",
        items: {
          $ref: "#/components/schemas/DeliveryPoint",
        },
      },
      siteAreas: {
        type: "array",
        items: {
          $ref: "#/components/schemas/SiteArea",
        },
      },
      tags: {
        type: "array",
        items: {
          $ref: "#/components/schemas/TagDefinition",
        },
      },
      siteTags: {
        type: "array",
        items: {
          $ref: "#/components/schemas/SiteTagAssignment",
        },
      },
      meters: {
        type: "array",
        items: {
          $ref: "#/components/schemas/Meter",
        },
      },
      equipment: {
        type: "array",
        items: {
          $ref: "#/components/schemas/Equipment",
        },
      },
      series: {
        type: "array",
        items: {
          $ref: "#/components/schemas/DataSeries",
        },
      },
      performancePeriods: {
        type: "array",
        items: {
          $ref: "#/components/schemas/CpePerformancePeriod",
        },
      },
      anomalies: {
        type: "array",
        items: {
          $ref: "#/components/schemas/WorkflowItem",
        },
      },
      recommendations: {
        type: "array",
        items: {
          $ref: "#/components/schemas/WorkflowItem",
        },
      },
      works: {
        type: "array",
        items: {
          $ref: "#/components/schemas/WorkflowItem",
        },
      },
      reports: {
        type: "array",
        items: {
          $ref: "#/components/schemas/WorkflowItem",
        },
      },
      audit: {
        type: "array",
        items: {
          $ref: "#/components/schemas/AuditEvent",
        },
      },
    },
    required: [
      "brands",
      "users",
      "companies",
      "sites",
      "deliveryPoints",
      "siteAreas",
      "tags",
      "siteTags",
      "meters",
      "equipment",
      "series",
      "anomalies",
      "recommendations",
      "works",
      "reports",
      "audit",
    ],
  },
  ApiError: {
    type: "object",
    additionalProperties: false,
    properties: {
      message: {
        type: "string",
      },
      issues: {
        type: "array",
        items: {
          type: "string",
        },
      },
    },
    required: ["message"],
  },
  BrandMutation: {
    type: "object",
    additionalProperties: false,
    properties: {
      brand: {
        $ref: "#/components/schemas/Brand",
      },
      legalEntity: {
        $ref: "#/components/schemas/LegalEntity",
      },
    },
    required: ["brand"],
  },
  BrandSwitchInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      brandId: {
        type: "string",
      },
    },
    required: ["brandId"],
  },
  BrandSwitchResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      brandId: {
        type: "string",
      },
      membershipId: {
        type: "string",
      },
    },
    required: ["brandId", "membershipId"],
  },
  AccessInvitationInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      user: {
        $ref: "#/components/schemas/User",
      },
      reason: {
        type: "string",
      },
      initialGrant: {
        $ref: "#/components/schemas/AccessGrant",
      },
    },
    required: ["user", "initialGrant"],
  },
  AssignAccessGrantInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      userId: {
        type: "string",
      },
      membershipId: {
        type: "string",
      },
      grant: {
        $ref: "#/components/schemas/AccessGrant",
      },
      reason: {
        type: "string",
      },
    },
    required: ["userId", "membershipId", "grant"],
  },
  RevokeAccessGrantInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      userId: {
        type: "string",
      },
      membershipId: {
        type: "string",
      },
      grantId: {
        type: "string",
      },
      reason: {
        type: "string",
      },
    },
    required: ["userId", "membershipId", "grantId"],
  },
  AccessRevocationImpact: {
    type: "object",
    additionalProperties: false,
    properties: {
      grantId: {
        type: "string",
      },
      affectedClientAccesses: {
        type: "integer",
      },
      affectedClientUserIds: {
        type: "array",
        items: {
          type: "string",
        },
      },
    },
    required: ["grantId", "affectedClientAccesses", "affectedClientUserIds"],
  },
  CreateMandatePublicLinkInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      companyId: {
        type: "string",
      },
      email: {
        type: "string",
      },
      phone: {
        type: "string",
      },
      siteId: {
        type: "string",
        description:
          "Site ciblé facultatif ; absent pour une demande Entreprise.",
      },
    },
    required: [],
  },
  PublicMandateSubmission: {
    type: "object",
    additionalProperties: false,
    properties: {
      mandateCaseId: {
        type: "string",
      },
      status: {
        $ref: "#/components/schemas/MandateStatus",
      },
      message: {
        type: "string",
      },
    },
    required: ["mandateCaseId", "status", "message"],
  },
  YoutrustWebhook: {
    type: "object",
    required: ["event_id", "event_name", "data"],
    properties: {
      event_id: {
        type: "string",
      },
      event_name: {
        type: "string",
      },
      data: {
        type: "object",
        additionalProperties: true,
      },
    },
    additionalProperties: true,
  },
  WebhookReceipt: {
    type: "object",
    additionalProperties: false,
    properties: {
      received: {
        type: "boolean",
      },
      duplicate: {
        type: "boolean",
      },
      pending: {
        type: "boolean",
      },
    },
    required: ["received", "duplicate"],
  },
  Portfolio: {
    type: "object",
    additionalProperties: false,
    properties: {
      companies: {
        type: "array",
        items: {
          $ref: "#/components/schemas/Company",
        },
      },
      sites: {
        type: "array",
        items: {
          $ref: "#/components/schemas/Site",
        },
      },
      deliveryPoints: {
        type: "array",
        items: {
          $ref: "#/components/schemas/DeliveryPoint",
        },
      },
    },
    required: ["companies", "sites", "deliveryPoints"],
  },
  SearchResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      type: {
        type: "string",
        enum: ["company", "site", "delivery_point", "anomaly", "report"],
      },
      label: {
        type: "string",
      },
      description: {
        type: "string",
      },
      context: {
        type: "string",
      },
      path: {
        type: "string",
      },
      companyId: {
        type: "string",
      },
      siteId: {
        type: "string",
      },
      deliveryPointId: {
        type: "string",
      },
    },
    required: ["id", "type", "label", "description", "context", "path"],
  },
  SearchPage: {
    type: "object",
    additionalProperties: false,
    properties: {
      items: {
        type: "array",
        items: {
          $ref: "#/components/schemas/SearchResult",
        },
      },
      nextCursor: {
        type: "string",
      },
    },
    required: ["items"],
  },
  LoginInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      email: {
        type: "string",
      },
      password: {
        type: "string",
      },
    },
    required: ["email", "password"],
  },
  LoginResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      status: {
        type: "string",
        enum: ["authenticated", "totp_required"],
      },
      session: {
        $ref: "#/components/schemas/Session",
      },
      challengeId: {
        type: "string",
        description:
          "Jeton de défi à présenter à `POST /auth/totp` (valable cinq minutes).",
      },
    },
    required: ["status"],
  },
  TotpInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      challengeId: {
        type: "string",
      },
      code: {
        type: "string",
        description: "Code TOTP à six chiffres ou code de récupération.",
      },
    },
    required: ["challengeId", "code"],
  },
  AcceptedResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      accepted: {
        type: "boolean",
      },
    },
    required: ["accepted"],
  },
  PasswordRecoveryInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      email: {
        type: "string",
      },
    },
    required: ["email"],
  },
  PasswordResetInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      token: {
        type: "string",
      },
      password: {
        type: "string",
      },
    },
    required: ["token", "password"],
  },
  InvitationPreview: {
    type: "object",
    additionalProperties: false,
    properties: {
      email: {
        type: "string",
      },
      firstName: {
        type: "string",
      },
      lastName: {
        type: "string",
      },
      brandName: {
        type: "string",
      },
      expiresAt: {
        type: "string",
      },
    },
    required: ["email", "firstName", "lastName", "brandName", "expiresAt"],
  },
  InvitationAcceptInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      password: {
        type: "string",
      },
    },
    required: ["password"],
  },
  TotpEnrollment: {
    type: "object",
    additionalProperties: false,
    properties: {
      secret: {
        type: "string",
      },
      otpauthUrl: {
        type: "string",
      },
    },
    required: ["secret", "otpauthUrl"],
  },
  TotpConfirmInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      code: {
        type: "string",
      },
    },
    required: ["code"],
  },
  TotpConfirmResult: {
    type: "object",
    additionalProperties: false,
    properties: {
      recoveryCodes: {
        type: "array",
        items: {
          type: "string",
        },
      },
    },
    required: ["recoveryCodes"],
  },
  TotpDisableInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      password: {
        type: "string",
      },
    },
    required: ["password"],
  },
  UserSessionSummary: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      current: {
        type: "boolean",
      },
      createdAt: {
        type: "string",
      },
      lastSeenAt: {
        type: "string",
      },
      expiresAt: {
        type: "string",
      },
      ip: {
        type: "string",
      },
      userAgent: {
        type: "string",
      },
    },
    required: [
      "id",
      "current",
      "createdAt",
      "lastSeenAt",
      "expiresAt",
      "ip",
      "userAgent",
    ],
  },
  UserUpdateInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      firstName: {
        type: "string",
      },
      lastName: {
        type: "string",
      },
      phone: {
        type: "string",
      },
      status: {
        type: "string",
        enum: ["active", "suspended", "disabled"],
      },
    },
    required: [],
  },
  DeleteUserInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      confirmationEmail: {
        type: "string",
        format: "email",
      },
    },
    required: ["confirmationEmail"],
  },
  ConnectorEnedisFailedFile: {
    type: "object",
    additionalProperties: false,
    description:
      "Fichier du dépôt Enedis qui attend une décision. En erreur (`error` renseigné) : il reste dans le dépôt et le module le relit à chaque relève, jusqu'à réussir. Au nom inconnu (`kind` `unknown`, `error` nul) : il reste dans le dépôt sans jamais être lu. Dans les deux cas, jusqu'à ce que l'administrateur demande de l'écarter.",
    properties: {
      fileName: {
        type: "string",
      },
      flux: {
        type: "string",
        description:
          "`C68`, `R63`… ; vide pour un fichier que le module ne reconnaît pas.",
      },
      kind: {
        type: "string",
        enum: ["data", "report", "recurring", "unknown"],
      },
      idDemande: {
        type: ["string", "null"],
        description:
          "Identifiant de la commande SGE porté par le nom du fichier.",
      },
      receivedAt: {
        type: "string",
        format: "date-time",
        description: "Première relève du fichier.",
      },
      lastAttemptAt: {
        type: "string",
        format: "date-time",
        description:
          "Dernière lecture en échec ; pour un fichier inconnu, sa relève.",
      },
      attempts: {
        type: "integer",
        minimum: 1,
        description:
          "Nombre de lectures tentées (1 pour un fichier inconnu, jamais lu).",
      },
      error: {
        type: ["string", "null"],
        description:
          "Erreur de la dernière lecture ; `null` pour un fichier inconnu.",
      },
      archived: {
        type: "boolean",
        description:
          "`true` si le module a pu conserver une copie déchiffrée avant l'échec (`<dataDir>/enedis/flux/`), lisible à la main pour comprendre l'erreur.",
      },
      discardRequestedAt: {
        type: ["string", "null"],
        format: "date-time",
        description:
          "Demande de l'administrateur de retirer le fichier du dépôt sans le lire à la prochaine relève ; `null` : le fichier sera relu.",
      },
    },
    required: [
      "fileName",
      "flux",
      "kind",
      "idDemande",
      "receivedAt",
      "lastAttemptAt",
      "attempts",
      "error",
      "archived",
      "discardRequestedAt",
    ],
  },
  ConnectorEnedisFileDiscardInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      fileNames: {
        type: "array",
        minItems: 1,
        items: {
          type: "string",
        },
        description:
          "Fichiers en erreur ou inconnus concernés, par leur nom dans le dépôt.",
      },
      discard: {
        type: "boolean",
        description:
          "`true` : à écarter à la prochaine relève ; `false` : à conserver dans le dépôt.",
      },
    },
    required: ["fileNames", "discard"],
  },
  ConnectorExclusion: {
    type: "object",
    additionalProperties: false,
    description:
      "Exclusion d'un compteur de la collecte d'un connecteur. Enedis : le PRM reste relevé (ses flux déjà commandés arrivent encore) mais n'est ni commandé, ni signalé en retard, et la fiche de son point le dit. GRDF : le PCE n'est jamais interrogé chez ADICT ni signalé. Posée par un super-admin depuis l'écran Connecteurs, journalisée, lue par le service des connecteurs à chaque collecte.",
    required: ["reference", "reason", "excludedAt", "excludedBy"],
    properties: {
      reference: {
        type: "string",
        description:
          "PRM (14 chiffres) ou PCE (`GI` suivi de 6 chiffres, ou 14 chiffres).",
      },
      reason: {
        type: "string",
        description:
          "Motif donné par l'auteur (compteur déposé, pas de mandat, site cédé…).",
      },
      excludedAt: {
        type: "string",
        format: "date-time",
      },
      excludedBy: {
        type: "string",
        description: "Nom affiché de l'auteur au moment du geste.",
      },
    },
  },
  ConnectorAccessRights: {
    type: "object",
    additionalProperties: false,
    description:
      "Droits d'accès ADICT des PCE actifs, avec l'instant de leur lecture chez ADICT.",
    required: ["fetchedAt", "entries"],
    properties: {
      fetchedAt: {
        type: "string",
        format: "date-time",
      },
      entries: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ConnectorAccessRight",
        },
      },
    },
  },
  ConnectorAccessRight: {
    type: "object",
    additionalProperties: false,
    description:
      "Le droit d'accès ADICT qui compte pour un PCE : son état normalisé (`none` sans droit connu ; un droit « Active » dont la fin est passée est `expired`), l'état tel qu'ADICT l'écrit, son rôle (fourniture ou injection), ses dates, si son périmètre couvre les données publiées, le statut du contrôle de preuve, le titulaire et la raison d'une fin.",
    required: [
      "reference",
      "status",
      "state",
      "startsAt",
      "endsAt",
      "publishedData",
      "proofStatus",
      "holder",
      "reason",
      "rights",
    ],
    properties: {
      reference: {
        type: "string",
        description: "PCE, en majuscules.",
      },
      status: {
        type: "string",
        enum: [
          "active",
          "pending",
          "obsolete",
          "revoked",
          "expired",
          "refused",
          "unknown",
          "none",
        ],
      },
      state: {
        type: ["string", "null"],
        description:
          "`etat_droit_acces` tel qu'ADICT l'écrit (« Active », « Obsolète »…).",
      },
      role: {
        type: ["string", "null"],
        description:
          "`role_tiers` du droit retenu : AUTORISE_CONTRAT_FOURNITURE, DETENTEUR_CONTRAT_FOURNITURE, AUTORISE_CONTRAT_INJECTION ou DETENTEUR_CONTRAT_INJECTION. Une autre valeur est conservée telle quelle ; absent ou null quand le rôle est inconnu.",
      },
      startsAt: {
        type: ["string", "null"],
        description: "Jour civil `AAAA-MM-JJ`.",
      },
      endsAt: {
        type: ["string", "null"],
        description: "Jour civil `AAAA-MM-JJ`.",
      },
      publishedData: {
        type: ["boolean", "null"],
      },
      proofStatus: {
        type: ["string", "null"],
      },
      holder: {
        type: ["string", "null"],
        description: "Raison sociale du titulaire du PCE, d'après ADICT.",
      },
      reason: {
        type: ["string", "null"],
        description:
          "Raison d'une fin (obsolète, révoqué, refusé), quand ADICT la donne.",
      },
      rights: {
        type: "integer",
        description:
          "Nombre de droits connus pour ce PCE, tous états confondus.",
      },
    },
  },
  ConnectorAccessRightRecord: {
    type: "object",
    additionalProperties: false,
    description:
      "Un droit d'accès ADICT tel que le connecteur GRDF l'a conservé : état, dates, périmètre par catégorie de données (`null` quand ADICT ne le dit pas), période de consommation autorisée, preuve, titulaire, et ses première et dernière lectures.",
    required: [
      "rightKey",
      "reference",
      "status",
      "state",
      "startsAt",
      "endsAt",
      "publishedData",
      "informativeData",
      "contractualData",
      "technicalData",
      "consumptionFrom",
      "consumptionTo",
      "proofStatus",
      "holder",
      "reason",
      "createdOn",
      "firstSeenAt",
      "lastSeenAt",
    ],
    properties: {
      rightKey: {
        type: "string",
        description:
          "`id_droit_acces`, ou à défaut le PCE, le début et la création du droit.",
      },
      reference: {
        type: "string",
        description: "PCE, en majuscules.",
      },
      status: {
        type: "string",
        enum: [
          "active",
          "pending",
          "obsolete",
          "revoked",
          "expired",
          "refused",
          "unknown",
        ],
      },
      state: {
        type: "string",
        description: "`etat_droit_acces` tel qu'ADICT l'écrit.",
      },
      startsAt: {
        type: ["string", "null"],
        format: "date",
      },
      endsAt: {
        type: ["string", "null"],
        format: "date",
      },
      publishedData: {
        type: ["boolean", "null"],
      },
      informativeData: {
        type: ["boolean", "null"],
      },
      contractualData: {
        type: ["boolean", "null"],
      },
      technicalData: {
        type: ["boolean", "null"],
      },
      consumptionFrom: {
        type: ["string", "null"],
        format: "date",
        description:
          "Premier jour des consommations autorisées (`perim_donnees_conso_debut`).",
      },
      consumptionTo: {
        type: ["string", "null"],
        format: "date",
      },
      proofStatus: {
        type: ["string", "null"],
      },
      holder: {
        type: ["string", "null"],
        description: "Raison sociale du titulaire du PCE, d'après ADICT.",
      },
      reason: {
        type: ["string", "null"],
      },
      createdOn: {
        type: ["string", "null"],
        format: "date",
      },
      firstSeenAt: {
        type: "string",
        format: "date-time",
        description: "Première lecture du droit par le connecteur.",
      },
      lastSeenAt: {
        type: "string",
        format: "date-time",
        description: "Dernière lecture du droit par le connecteur.",
      },
    },
  },
  ConnectorExclusionInput: {
    type: "object",
    additionalProperties: false,
    required: ["reason"],
    properties: {
      reason: {
        type: "string",
        minLength: 1,
        maxLength: 200,
        description:
          "Motif de l'exclusion, montré au journal et, pour un PRM, sur la fiche du point.",
      },
    },
  },
  ConnectorEnedisOrderEntry: {
    type: "object",
    additionalProperties: false,
    description:
      "Commande SGE suivie par le connecteur Enedis, telle que son compte rendu la qualifie : service appelé, type de mesure, fenêtre demandée, état, fichiers annoncés, et l'issue de chaque PRM du lot avec le motif d'un refus. Tant que les commandes viennent du cron existant, elles sont découvertes par leur compte rendu et portent le déclencheur `unknown`.",
    properties: {
      id: {
        type: "string",
      },
      service: {
        type: "string",
        description:
          "Web-service SGE appelé (`CommandeHistoriqueDonneesMesuresFines`, `CommandeInformationsTechniquesEtContractuelles`, `CommandeHistoriqueDonneesMesuresFacturantes`).",
      },
      measureType: {
        type: "string",
        description:
          "`COURBES`, `INDEX`, `ENERGIE`, `PMAX`, ou `FACTURANTES` pour une commande de mesures facturantes ; vide pour une commande sans type (fiche technique).",
      },
      companyId: {
        type: ["string", "null"],
      },
      windowStart: {
        type: ["string", "null"],
        description:
          "Début de la fenêtre demandée, jour civil `AAAA-MM-JJ`. Pour une commande que le module n'a pas envoyée (déclencheur `unknown`), la période des fichiers de données reçus, posée quand ils sont lus ; `null` tant qu'aucun fichier n'est lu.",
      },
      windowEnd: {
        type: ["string", "null"],
      },
      affaireId: {
        type: ["string", "null"],
        description:
          "Identifiant rendu par SGE, porté par les fichiers (`idDemande`).",
      },
      orderedAt: {
        type: "string",
        format: "date-time",
      },
      trigger: {
        type: "string",
        enum: ["schedule", "manual", "repair", "unknown"],
      },
      status: {
        type: "string",
        enum: [
          "pending",
          "answered",
          "partial",
          "rejected",
          "expired",
          "unknown",
        ],
      },
      reportReceivedAt: {
        type: ["string", "null"],
        format: "date-time",
      },
      expectedFiles: {
        type: "array",
        items: {
          type: "string",
        },
        description: "Fichiers de données annoncés par le compte rendu.",
      },
      receivedFiles: {
        type: "array",
        items: {
          type: "string",
        },
        description:
          "Fichiers de données de cette commande déjà relevés et journalisés (`idDemande` égal à `affaireId`), qu'un compte rendu les ait annoncés ou non.",
      },
      error: {
        type: ["string", "null"],
      },
      prms: {
        type: "array",
        description: "Issue de chaque PRM du lot, d'après le compte rendu.",
        items: {
          type: "object",
          additionalProperties: false,
          properties: {
            prm: {
              type: "string",
            },
            admissibility: {
              type: ["string", "null"],
            },
            publication: {
              type: ["string", "null"],
            },
            reason: {
              type: ["string", "null"],
            },
            fileName: {
              type: ["string", "null"],
              description:
                "Fichier publié qui porte ce PRM, quand le compte rendu le dit.",
            },
          },
          required: ["prm"],
        },
      },
    },
    required: [
      "id",
      "service",
      "measureType",
      "orderedAt",
      "trigger",
      "status",
      "expectedFiles",
      "receivedFiles",
      "prms",
    ],
  },
  ConnectorTransitEntry: {
    type: "object",
    additionalProperties: false,
    description:
      "État d'une référence (PRM ou PCE) dans la zone de transit d'un connecteur, avant synchronisation.",
    properties: {
      provider: {
        type: "string",
        enum: ["enedis", "grdf"],
      },
      reference: {
        type: "string",
        description: "PRM (Enedis) ou PCE (GRDF) tel qu'importé.",
      },
      loadCurveCount: {
        type: "integer",
        description: "Intervalles de courbe de charge Enedis en transit.",
      },
      dailyCount: {
        type: "integer",
        description: "Journées d'énergie Enedis en transit.",
      },
      periodCount: {
        type: "integer",
        description: "Périodes de relevé GRDF en transit.",
      },
      firstAt: {
        type: "string",
        description:
          "Début de la période couverte (ISO 8601 ou journée `YYYY-MM-DD`).",
      },
      lastAt: {
        type: "string",
      },
      importedAt: {
        type: "string",
        description: "Dernier import ayant touché cette référence.",
      },
      points: {
        type: "array",
        description:
          "Points actifs du type attendu (PRM ou PCE) portant cette référence ; vide si aucun.",
        items: {
          type: "object",
          additionalProperties: false,
          properties: {
            id: {
              type: "string",
            },
            label: {
              type: "string",
            },
            brandId: {
              type: "string",
            },
            brandName: {
              type: "string",
            },
          },
          required: ["id", "label", "brandId", "brandName"],
        },
      },
    },
    required: [
      "provider",
      "reference",
      "loadCurveCount",
      "dailyCount",
      "periodCount",
      "importedAt",
      "points",
    ],
  },
  WeatherImportEntry: {
    type: "object",
    additionalProperties: false,
    description:
      "Dernier import d'un fichier horaire ou quotidien Météo-France (`ingest.imports`, fournisseur `meteo-france`).",
    properties: {
      fileName: {
        type: "string",
      },
      department: {
        type: "string",
        description:
          "Département porté par le nom du fichier (`H_<département>_<période>.csv[.gz]`).",
      },
      importedAt: {
        type: "string",
      },
      rowCount: {
        type: "integer",
        description:
          "Valeurs écrites dans `weather.values` lors de cet import.",
      },
      rejectedCount: {
        type: "integer",
      },
      firstAt: {
        type: "string",
        description: "Première observation du fichier (ISO 8601).",
      },
      lastAt: {
        type: "string",
      },
      stationCount: {
        type: "integer",
        description:
          "Stations d'observation connues pour ce département (`weather.stations`, code `mf-<département>…`).",
      },
    },
    required: [
      "fileName",
      "department",
      "importedAt",
      "rowCount",
      "rejectedCount",
      "stationCount",
    ],
  },
  ConnectorDigestSettingsInput: {
    type: "object",
    additionalProperties: false,
    required: ["scheduleTime"],
    properties: {
      scheduleTime: {
        type: "string",
        pattern: "^([01][0-9]|2[0-3]):[0-5][0-9]$",
      },
    },
  },
  ConnectorDigestSettings: {
    type: "object",
    additionalProperties: false,
    required: ["scheduleTime", "timezone", "lastSentDay"],
    properties: {
      scheduleTime: {
        type: "string",
      },
      timezone: {
        type: "string",
        enum: ["Europe/Paris"],
      },
      lastSentDay: {
        type: ["string", "null"],
      },
    },
  },
  ConnectorIssue: {
    type: "object",
    additionalProperties: false,
    description:
      "Constat structuré émis à la détection par le connecteur. Le code qualifie le problème indépendamment du message humain ; le niveau conserve les règles d’envoi (alert), d’état durable (warning) ou d’échec technique (error).",
    required: ["code", "level", "message"],
    properties: {
      code: {
        type: "string",
        enum: [
          "data_late",
          "zero_consumption",
          "certificate_expiring",
          "certificate_expired",
          "order_unanswered",
          "access_excluded",
          "access_expiring",
          "technical_failure",
          "module_unreachable",
          "collection_missing",
        ],
      },
      level: {
        type: "string",
        enum: ["error", "alert", "warning"],
      },
      message: {
        type: "string",
      },
      phase: {
        type: "string",
        enum: ["orders", "collect"],
      },
      referenceType: {
        type: "string",
        enum: ["PRM", "PCE"],
      },
      reference: {
        type: "string",
        pattern: "^(GI[0-9]{6}|[0-9]{14})$",
      },
      days: {
        type: "integer",
        minimum: 0,
      },
      thresholdDays: {
        type: "integer",
        minimum: 0,
      },
      observedAt: {
        type: "string",
      },
    },
  },
  ModuleRunEntry: {
    type: "object",
    additionalProperties: false,
    description:
      "Une collecte passée d'un module externe, telle que son journal la conserve : le résumé commun sans les compteurs propres à la source. Son journal se lit par `getConnectorModuleRunLog`.",
    required: [
      "id",
      "trigger",
      "startedAt",
      "finishedAt",
      "outcome",
      "itemsTotal",
      "itemsFailed",
      "valuesWritten",
      "rejectedCount",
      "errors",
    ],
    properties: {
      interruption: {
        $ref: "#/components/schemas/ConnectorRunInterruption",
      },
      id: {
        type: "string",
      },
      trigger: {
        type: "string",
        enum: ["manual", "schedule"],
      },
      startedAt: {
        type: "string",
      },
      finishedAt: {
        type: "string",
      },
      outcome: {
        type: "string",
        enum: ["success", "failure"],
      },
      itemsTotal: {
        type: "integer",
      },
      itemsFailed: {
        type: "integer",
      },
      valuesWritten: {
        type: "integer",
      },
      rejectedCount: {
        type: "integer",
      },
      errors: {
        type: "array",
        items: {
          type: "string",
        },
      },
      alerts: {
        type: "array",
        items: {
          type: "string",
        },
      },
      warnings: {
        type: "array",
        items: {
          type: "string",
        },
      },
      phase: {
        type: "string",
        enum: ["orders", "collect"],
      },
      issues: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ConnectorIssue",
        },
      },
      facts: {
        type: "string",
        description:
          "Ce que la collecte a traité, dans les mots de la source (Enedis : PRM relevés pour une relève, commandes et PRM pour un envoi) ; absent pour une source qui ne le dit pas, le décompte générique restant lisible.",
      },
    },
  },
  ConnectorHttpPurgeInput: {
    type: "object",
    additionalProperties: false,
    required: ["before"],
    properties: {
      before: {
        type: "string",
        format: "date-time",
      },
    },
  },
  ConnectorHttpPurgeReport: {
    type: "object",
    additionalProperties: false,
    required: ["requestsDeleted", "bytesDeleted"],
    properties: {
      requestsDeleted: {
        type: "integer",
        minimum: 0,
      },
      bytesDeleted: {
        type: "integer",
        minimum: 0,
      },
    },
  },
  ConnectorHttpRequest: {
    type: "object",
    required: [
      "id",
      "runId",
      "at",
      "method",
      "url",
      "resource",
      "wac",
      "itemId",
      "status",
      "durationMs",
      "contentType",
      "bytes",
      "storedBytes",
      "bodyStatus",
      "outcome",
      "errors",
    ],
    properties: {
      id: {
        type: "string",
      },
      runId: {
        type: "string",
      },
      at: {
        type: "string",
        format: "date-time",
      },
      method: {
        type: "string",
      },
      url: {
        type: "string",
      },
      resource: {
        type: "string",
      },
      wac: {
        type: "string",
      },
      itemId: {
        type: ["integer", "null"],
      },
      status: {
        type: ["integer", "null"],
      },
      durationMs: {
        type: "number",
      },
      contentType: {
        type: "string",
      },
      bytes: {
        type: "integer",
      },
      storedBytes: {
        type: "integer",
      },
      bodyFormat: {
        type: "string",
        enum: ["exchange-v1"],
      },
      bodyStatus: {
        type: "string",
        enum: [
          "available",
          "expired",
          "quota",
          "unavailable",
          "excluded",
          "no-response",
        ],
      },
      outcome: {
        type: "string",
        enum: ["received", "accepted", "ignored", "error"],
      },
      errors: {
        type: "array",
        items: {
          type: "string",
        },
      },
    },
  },
  ConnectorHttpFilter: {
    type: "object",
    additionalProperties: false,
    required: ["wac", "resource", "httpStatus", "outcome", "text"],
    properties: {
      wac: {
        type: "string",
        maxLength: 200,
      },
      resource: {
        type: "string",
        maxLength: 100,
      },
      httpStatus: {
        type: "string",
        pattern: "^($|network|[1-5][0-9]{2})$",
      },
      outcome: {
        type: "string",
        enum: [
          "",
          "received",
          "accepted",
          "ignored",
          "error",
          "body:available",
          "body:expired",
          "body:quota",
          "body:unavailable",
          "body:excluded",
          "body:no-response",
        ],
      },
      text: {
        type: "string",
        maxLength: 2000,
      },
    },
  },
  ConnectorHttpFilterOptions: {
    type: "object",
    additionalProperties: false,
    required: ["wacs", "resources", "httpStatuses"],
    properties: {
      wacs: {
        type: "array",
        items: {
          type: "string",
        },
      },
      resources: {
        type: "array",
        items: {
          type: "string",
        },
      },
      httpStatuses: {
        type: "array",
        items: {
          type: "string",
        },
      },
    },
  },
  ConnectorHttpRunSearch: {
    type: "object",
    additionalProperties: false,
    required: ["runs", "options"],
    properties: {
      runs: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ModuleRunEntry",
        },
      },
      options: {
        $ref: "#/components/schemas/ConnectorHttpFilterOptions",
      },
    },
  },
  ConnectorHttpJournal: {
    type: "object",
    required: ["requests", "warnings", "storedBytes"],
    properties: {
      requests: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ConnectorHttpRequest",
        },
      },
      warnings: {
        type: "array",
        items: {
          type: "string",
        },
      },
      storedBytes: {
        type: "integer",
      },
    },
  },
  ConnectorHttpResponse: {
    type: "object",
    required: ["request", "body"],
    properties: {
      request: {
        $ref: "#/components/schemas/ConnectorHttpRequest",
      },
      body: {
        type: ["string", "null"],
      },
      requestBody: {
        type: ["string", "null"],
      },
    },
  },
  ModuleRunLog: {
    type: "object",
    additionalProperties: false,
    description:
      "Lignes de journal d'une collecte, dans l'ordre où le service les a écrites.",
    required: ["id", "lines"],
    properties: {
      id: {
        type: "string",
      },
      lines: {
        type: "array",
        items: {
          type: "string",
        },
      },
    },
  },
  OfficialWeatherStation: {
    type: "object",
    additionalProperties: false,
    properties: {
      reference: {
        type: "string",
      },
      name: {
        type: "string",
      },
      metadata: {
        type: ["object", "null"],
        additionalProperties: true,
      },
      collectedAt: {
        type: ["string", "null"],
      },
      identifiers: {
        type: "array",
        items: {
          type: "object",
          additionalProperties: false,
          properties: {
            reference: {
              type: "string",
            },
            from: {
              type: "string",
            },
            to: {
              type: ["string", "null"],
            },
            evidence: {
              type: "string",
            },
          },
          required: ["reference", "from", "to", "evidence"],
        },
      },
    },
    required: ["reference", "name", "metadata", "collectedAt", "identifiers"],
  },
  OfficialWeatherOrder: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      reference: {
        type: "string",
      },
      from: {
        type: "string",
      },
      to: {
        type: "string",
      },
      state: {
        type: "string",
      },
      attempts: {
        type: "integer",
      },
      error: {
        type: ["string", "null"],
      },
      updatedAt: {
        type: "string",
      },
    },
    required: [
      "id",
      "reference",
      "from",
      "to",
      "state",
      "attempts",
      "error",
      "updatedAt",
    ],
  },
  OfficialWeatherDegreeDayPair: {
    type: "object",
    additionalProperties: false,
    properties: {
      heating: {
        type: "number",
      },
      cooling: {
        type: "number",
      },
    },
    required: ["heating", "cooling"],
  },
  OfficialWeatherDegreeDays: {
    type: ["object", "null"],
    additionalProperties: false,
    description:
      "DJU calculés sur la journée fournisseur, en °C.j, base 18 °C. Ne remplacent pas les DJU civils ou gaziers.",
    properties: {
      meanC: {
        type: "number",
      },
      meanSource: {
        type: "string",
        enum: ["TNTXM", "TN_TX"],
      },
      baseC: {
        type: "number",
      },
      meteo: {
        $ref: "#/components/schemas/OfficialWeatherDegreeDayPair",
      },
      costic: {
        anyOf: [
          {
            $ref: "#/components/schemas/OfficialWeatherDegreeDayPair",
          },
          {
            type: "null",
          },
        ],
      },
    },
    required: ["meanC", "meanSource", "baseC", "meteo", "costic"],
  },
  OfficialWeatherValue: {
    type: "object",
    additionalProperties: false,
    properties: {
      calculatedDegreeDays: {
        $ref: "#/components/schemas/OfficialWeatherDegreeDays",
      },
      reference: {
        type: "string",
      },
      from: {
        type: "string",
      },
      to: {
        type: "string",
      },
      period: {
        type: "string",
        enum: ["day", "decade"],
      },
      source: {
        type: "string",
      },
      values: {
        type: "object",
        additionalProperties: {
          type: "string",
        },
      },
      fileSha256: {
        type: "string",
      },
      importedAt: {
        type: "string",
      },
      revision: {
        type: "integer",
      },
    },
    required: [
      "reference",
      "from",
      "to",
      "period",
      "source",
      "values",
      "fileSha256",
      "importedAt",
      "revision",
    ],
  },
  OfficialWeatherArchive: {
    type: "object",
    additionalProperties: false,
    properties: {
      stations: {
        type: "array",
        items: {
          $ref: "#/components/schemas/OfficialWeatherStation",
        },
      },
      orders: {
        type: "array",
        items: {
          $ref: "#/components/schemas/OfficialWeatherOrder",
        },
      },
      rows: {
        type: "array",
        items: {
          $ref: "#/components/schemas/OfficialWeatherValue",
        },
      },
      truncated: {
        type: "boolean",
      },
      publishedDegreeDays: {
        type: "string",
        enum: ["unconfirmed"],
      },
    },
    required: [
      "stations",
      "orders",
      "rows",
      "truncated",
      "publishedDegreeDays",
    ],
  },
  WeatherStationIdentifierInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      stationReference: {
        type: "string",
      },
      reference: {
        type: "string",
      },
      from: {
        type: "string",
      },
      to: {
        type: ["string", "null"],
      },
      evidence: {
        type: "string",
        minLength: 1,
        maxLength: 2000,
      },
    },
    required: ["stationReference", "reference", "from", "evidence"],
  },
  WitReflectRule: {
    type: "object",
    additionalProperties: false,
    required: ["enabled", "unit", "kind"],
    properties: {
      enabled: {
        type: "boolean",
      },
      unit: {
        type: "string",
        maxLength: 32,
      },
      kind: {
        type: "string",
        enum: ["power", "temperature", "state", "setpoint", "other"],
      },
    },
  },
  ModuleSettingsInput: {
    type: "object",
    additionalProperties: true,
    description:
      "Mise à jour partielle des réglages d'un module externe, propres à la source et validés par le service des connecteurs (Enedis : `ordersTime`, `intervalMinutes`, `scheduleTime`, `lateAfterDays`… ; voir le README du service).",
    properties: {
      decadalEnabled: {
        type: "boolean",
        description:
          "Météo-France, active les fichiers décadaires publics après la collecte horaire, sans clé API.",
      },
      climatologyEnabled: {
        type: "boolean",
        description:
          "Météo-France : active les CSV quotidiens TN/TX publics après la collecte horaire, sans clé API ; actif par défaut. Nom technique conservé pour les réglages existants.",
      },
      climatologyRevisitDays: {
        type: "integer",
        minimum: 1,
        maximum: 365,
        description:
          "Ancien réglage API Climatologique, sans effet sur les CSV quotidiens (latest relu à chaque collecte).",
      },
      climatologyRetentionDays: {
        type: "integer",
        minimum: 1,
        maximum: 365,
        description:
          "Météo-France : conservation du cache décadaire, 30 jours par défaut ; les CSV quotidiens sont conservés pour le rejeu.",
      },
      ordersTime: {
        type: "string",
        description:
          "Enedis, heure `HH:MM` (heure de Paris, `Europe/Paris`) de l'envoi quotidien des commandes SGE.",
      },
      intervalMinutes: {
        type: ["integer", "null"],
        minimum: 1,
        maximum: 1440,
        description:
          "Cadence de la collecte en minutes ; `null` pour une collecte quotidienne à `scheduleTime`.",
      },
      scheduleTime: {
        type: "string",
        description:
          "Heure `HH:MM` de la collecte quotidienne, quand la cadence n'est pas à intervalle.",
      },
      lateAfterDays: {
        type: "integer",
        minimum: 1,
        maximum: 60,
        description:
          "Enedis : seuil de retard en journées dues manquantes (3 par défaut). La dernière journée due est l'avant-veille, en heure de Paris.",
      },
      zeroDaysAlert: {
        type: "integer",
        minimum: 1,
        maximum: 90,
        description:
          "Enedis, jours consécutifs de consommation nulle avant signalement (14 par défaut).",
      },
      orderTimeoutDays: {
        type: "integer",
        minimum: 1,
        maximum: 30,
        description:
          "Enedis, jours avant expiration d’une commande sans réponse (7 par défaut).",
      },
      gapLookbackDays: {
        type: "integer",
        minimum: 7,
        maximum: 365,
        description:
          "Enedis, profondeur de recherche des trous quotidiens en jours (60 par défaut).",
      },
      gapRetryDays: {
        type: "integer",
        minimum: 1,
        maximum: 30,
        description:
          "Enedis, jours avant une nouvelle tentative de réparation des trous (3 par défaut).",
      },
      historyEveryDays: {
        type: "integer",
        minimum: 1,
        maximum: 31,
        description:
          "Enedis : jours révolus depuis la dernière commande réussie d'un type à partir desquels un PRM est recommandé (1, le défaut : chaque jour).",
      },
      billingEnabled: {
        type: "boolean",
        description:
          "Enedis : `false` suspend l'envoi mensuel des mesures facturantes seul (les autres collectes programmées continuent) ; `true` le relance.",
      },
      billingOrdersDay: {
        type: "integer",
        minimum: 1,
        maximum: 28,
        description:
          "Enedis : jour du mois de l'envoi mensuel des commandes de mesures facturantes (R67), 1 par défaut. L'envoi quotidien n'en prévoit jamais.",
      },
      billingOrdersTime: {
        type: "string",
        description:
          "Enedis, heure `HH:MM` (heure de Paris) de cet envoi mensuel, 03:40 par défaut.",
      },
      billingMonths: {
        type: "integer",
        minimum: 1,
        maximum: 24,
        description:
          "Enedis : mois commandés à chaque envoi mensuel de mesures facturantes, jusqu'à la veille (2 par défaut).",
      },
      technicalEnabled: {
        type: "boolean",
        description:
          "Enedis : `false` suspend l'envoi mensuel des fiches techniques seul (les autres collectes programmées continuent) ; `true` le relance.",
      },
      technicalOrdersDay: {
        type: "integer",
        minimum: 1,
        maximum: 28,
        description:
          "Enedis : jour du mois de l'envoi mensuel des fiches techniques (C68) de tous les PRM, 2 par défaut.",
      },
      technicalOrdersTime: {
        type: "string",
        description:
          "Enedis, heure `HH:MM` (heure de Paris) de cet envoi mensuel, 03:50 par défaut.",
      },
      informativesTime: {
        type: "string",
        description:
          "GRDF, heure `HH:MM` (heure de Paris) de la collecte quotidienne des consommations informatives (journalières, non facturantes), 07:00 par défaut.",
      },
      informativesEnabled: {
        type: "boolean",
        description:
          "GRDF : `false` suspend la seule collecte quotidienne des consommations informatives (la collecte des relevés publiés continue) ; `true` la relance.",
      },
      referenceDay: {
        type: "integer",
        minimum: 1,
        maximum: 28,
        description:
          "GRDF : jour du mois de la lecture mensuelle des fiches des PCE (données contractuelles et techniques) et de leurs injections publiées, 15 par défaut.",
      },
      referenceTime: {
        type: "string",
        description:
          "GRDF, heure `HH:MM` (heure de Paris) de cette lecture mensuelle, 08:00 par défaut.",
      },
      referenceEnabled: {
        type: "boolean",
        description:
          "GRDF : `false` suspend la seule lecture mensuelle des fiches et des injections ; `true` la relance.",
      },
      fluxEnabled: {
        type: "boolean",
        description:
          "WIT, collecte des historiques de flux, active par défaut.",
      },
      reflectsEnabled: {
        type: "boolean",
        description: "WIT, collecte des états de reflets, active par défaut.",
      },
      reflectFutureToleranceMinutes: {
        type: "integer",
        minimum: 0,
        maximum: 60,
        default: 5,
        description:
          "WIT, avance maximale admise pour un reflet par rapport à l’heure serveur à sa lecture, en minutes. 5 par défaut ; 0 impose une date au plus égale à l’heure de lecture. L’horodatage fournisseur est conservé.",
      },
      reflectIntervalMinutes: {
        type: "integer",
        minimum: 1,
        maximum: 1440,
        description:
          "WIT, cadence propre aux reflets, en minutes (60 par défaut), indépendante des flux.",
      },
      httpRetentionDays: {
        type: "integer",
        minimum: 1,
        maximum: 365,
        description:
          "WIT, GRDF et Enedis SGE, jours de conservation des réponses réussies (30 par défaut).",
      },
      httpErrorRetentionDays: {
        type: "integer",
        minimum: 1,
        maximum: 730,
        description:
          "WIT, GRDF et Enedis SGE, jours de conservation des réponses en erreur (90 par défaut).",
      },
      httpIndexRetentionDays: {
        type: "integer",
        minimum: 1,
        maximum: 730,
        description:
          "WIT, GRDF et Enedis SGE, jours de conservation des métadonnées (366 par défaut).",
      },
      httpQuotaMiB: {
        type: "integer",
        minimum: 1,
        maximum: 1048576,
        description:
          "WIT, GRDF et Enedis SGE, quota compressé en Mio (5120 par défaut).",
      },
      historyPagesPerRun: {
        type: "integer",
        minimum: 2,
        maximum: 50,
        description:
          "WIT, pages historiques par fluxItem et passage (10 par défaut), reprise automatique au passage suivant.",
      },
      reflectMode: {
        type: "string",
        enum: ["temperature", "all", "selected"],
        description:
          "WIT, sondes T°C automatiques (défaut), tous les reflets numériques et textuels ou sélection explicite.",
      },
      reflects: {
        type: "object",
        description:
          "WIT, configuration complète par clé <WAC>:reflect:<id>, remplaçant la précédente ; les unités changées ne convertissent pas l'historique.",
        additionalProperties: {
          $ref: "#/components/schemas/WitReflectRule",
        },
      },
      lookbackHours: {
        type: "integer",
        minimum: 1,
        maximum: 720,
        description:
          "GTB WIT, heures relues à chaque collecte (24 par défaut).",
      },
      historyMonths: {
        type: "integer",
        minimum: 1,
        maximum: 120,
        description:
          "GTB WIT, mois d'historique relus au premier chargement d'un fluxItem (24 par défaut).",
      },
      units: {
        type: "object",
        description:
          "GTB WIT : unité imposée par fluxItem d'index (`<WAC>:<fluxItem>`), en mise à jour partielle ; `null` retire l'unité imposée et rend l'unité déduite du code WIT.",
        additionalProperties: {
          type: ["string", "null"],
          enum: ["Wh", "kWh", "m3", null],
        },
      },
      wacs: {
        type: "array",
        maxItems: 100,
        items: {
          type: "string",
          pattern: "^WAC[A-Za-z0-9]{1,40}$",
        },
        description:
          "GTB WIT : liste complète des GTB relevées (identifiants `WAC…`, casse indifférente, doublons retirés), qui remplace la précédente ; vide, aucune GTB n'est relevée. `WAC80QJK09AHJ3G` au départ.",
      },
      enabled: {
        type: "boolean",
        description:
          "`false` suspend les collectes programmées du module (et ses programmations supplémentaires, Enedis : l'envoi des commandes) ; une collecte manuelle reste possible. `true` les relance.",
      },
    },
  },
  ModuleSyncStatus: {
    type: "object",
    additionalProperties: false,
    description:
      "Collecte d'un module externe (`apps/connectors` : Météo-France, GTB WIT, GRDF) vue par l'API : état du module, avancement, dernier bilan et cadence. Le résumé du bilan est commun à toutes les sources ; `lastRun.details` porte les compteurs propres à la source (Météo-France : `filesLoaded`, `filesUnchanged`, `filesSkipped`, `departments`… ; WIT : `sensorsTotal`, `indexItems`, `unitsPending`… ; GRDF : `metersTotal`, `metersCalled`, `metersCovered`, `metersMissing`, `previousMonth`, `deadlineDay`…).",
    properties: {
      reachable: {
        type: "boolean",
        description:
          "Le module a répondu ; sinon `error` explique et les autres champs manquent.",
      },
      running: {
        type: "boolean",
      },
      runId: {
        type: "string",
        description:
          "Exécution `running` enregistrée par l'API pour cette collecte, s'il y en a une.",
      },
      error: {
        type: "string",
      },
      progress: {
        type: "object",
        additionalProperties: false,
        properties: {
          total: {
            type: "integer",
          },
          done: {
            type: "integer",
          },
          currentItem: {
            type: "string",
            description: "Élément en cours (fichier, capteur).",
          },
          startedAt: {
            type: "string",
          },
        },
        required: ["total", "done", "startedAt"],
      },
      lastRun: {
        type: "object",
        additionalProperties: false,
        properties: {
          interruption: {
            $ref: "#/components/schemas/ConnectorRunInterruption",
          },
          id: {
            type: "string",
            description:
              "Identifiant de la collecte dans le journal du module (`getConnectorModuleRunLog`) ; absent pour un bilan antérieur au journal.",
          },
          trigger: {
            type: "string",
            enum: ["manual", "schedule"],
          },
          startedAt: {
            type: "string",
          },
          finishedAt: {
            type: "string",
          },
          outcome: {
            type: "string",
            enum: ["success", "failure"],
            description:
              "Échec quand tous les éléments ont échoué, ou qu'aucun élément n'a été traité et que des erreurs sont rapportées.",
          },
          itemsTotal: {
            type: "integer",
            description: "Éléments traités (fichiers, capteurs…).",
          },
          itemsFailed: {
            type: "integer",
          },
          valuesWritten: {
            type: "integer",
          },
          rejectedCount: {
            type: "integer",
          },
          latestAt: {
            type: "string",
            description:
              "Donnée la plus récente écrite (ISO 8601), base de la fraîcheur du connecteur.",
          },
          errors: {
            type: "array",
            items: {
              type: "string",
            },
          },
          alerts: {
            type: "array",
            items: {
              type: "string",
            },
            description:
              "Faits remontés par le module et journalisés même quand la collecte réussit (GRDF : données du mois précédent toujours absentes au jour limite). Absent quand il n'y en a pas.",
          },
          warnings: {
            type: "array",
            items: {
              type: "string",
            },
            description:
              "État durable à traiter, constaté par la collecte (Enedis : chaque PRM en retard, commandes SGE expirées sans réponse). Porté par le connecteur comme avertissement tant qu'il dure, jamais journalisé. Absent quand tout est sain.",
          },
          issues: {
            type: "array",
            items: {
              $ref: "#/components/schemas/ConnectorIssue",
            },
          },
          details: {
            type: "object",
            additionalProperties: true,
            description: "Compteurs propres à la source, rendus tels quels.",
          },
        },
        required: [
          "trigger",
          "startedAt",
          "finishedAt",
          "outcome",
          "itemsTotal",
          "itemsFailed",
          "valuesWritten",
          "rejectedCount",
          "errors",
          "details",
        ],
      },
      nextRunAt: {
        type: "string",
        description: "Prochaine collecte programmée par le module.",
      },
      scheduleTime: {
        type: "string",
        description:
          "Heure de la collecte quotidienne (`HH:MM`, heure de Paris, `Europe/Paris`), quand `intervalMinutes` est absent.",
      },
      intervalMinutes: {
        type: "integer",
        description:
          "Collecte à intervalle régulier, aligné sur l'horloge (60 pour chaque heure pleine).",
      },
      cadence: {
        type: "string",
        description:
          "Cadence prête à afficher (« toutes les 60 min », « quotidienne à 03:30 »).",
      },
      enabled: {
        type: "boolean",
        description:
          "Collectes programmées actives ; `false` quand un administrateur les a suspendues (`nextRunAt` absent, l'absence de collecte n'est pas signalée). Absent quand le module ne répond pas.",
      },
      settings: {
        type: "object",
        additionalProperties: true,
        description: "Réglages courants du module, propres à la source.",
      },
      hosting: {
        type: "object",
        additionalProperties: true,
        description:
          "État d'hébergement propre à la source, tel que le module tourne maintenant, sans attendre son prochain bilan (Enedis : `tier`, `flux` ou `commands`). Absent pour une source qui n'en déclare pas.",
      },
      schedules: {
        type: "object",
        additionalProperties: true,
        description:
          "Prochaine occurrence (chaîne ISO 8601) des programmations supplémentaires de la source, par nom, à côté de `nextRunAt` (Enedis : `orders`, l'envoi quotidien des commandes SGE, et `billing`, l'envoi mensuel des mesures facturantes, quand `nextRunAt` est la prochaine relève horaire du dépôt). Une valeur `null` indique une programmation suspendue, dont la collecte manuelle reste disponible. Les clés sont conservées même sans prochaine occurrence ; une clé absente indique une collecte non raccordée. Absent sans programmation supplémentaire.",
      },
    },
    required: ["reachable", "running"],
  },
  SyncRunInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      outcome: {
        type: "string",
        enum: ["success", "failure"],
        description: "Résultat simulé ; `success` par défaut.",
      },
      collect: {
        type: "boolean",
        description:
          "Module GRDF : `true` confie la collecte au service des connecteurs (appel de l'API ADICT puis écriture des séries, tout le cycle) ; absent ou `false`, l'exécution consomme la zone de transit des exports déposés pour tous les PCE actifs sans appeler ADICT. `references` ou `from` valent `collect: true`. Ignoré par les autres connecteurs.",
      },
      references: {
        type: "array",
        items: {
          type: "string",
        },
        description:
          "Modules GRDF et Enedis : PCE ou PRM à collecter (liste non vide, casse indifférente) ; absent : tous les points actifs. Module GTB WIT : GTB (`WAC…`) à relever, parmi celles de ses réglages (`wacs`) ; absent : toutes. Ignoré par les autres connecteurs.",
      },
      from: {
        type: "string",
        description:
          "Module GRDF : date civile `AAAA-MM-JJ` à partir de laquelle les relevés publiés sont demandés à ADICT ; absent : depuis le dernier relevé de chaque PCE (ou l'historique réglé pour un PCE sans relevé). Module Enedis : début des fenêtres commandées à SGE. Module GTB WIT : les séries sont relues depuis minuit (heure de Paris) ce jour-là ; absent : depuis la dernière heure écrite moins la relecture réglée.",
      },
      to: {
        type: "string",
        description:
          "Module Enedis (avec `action: orders`) : fin des fenêtres commandées à SGE, date civile `AAAA-MM-JJ`, au plus tard hier (une date plus récente est ramenée à hier) ; absent : hier. Au plus tôt égale à `from` (422 sinon). Ignoré par les autres connecteurs.",
      },
      types: {
        type: "array",
        items: {
          type: "string",
          enum: ["COURBES", "INDEX", "ENERGIE", "PMAX", "FACTURANTES"],
        },
        description:
          "Module Enedis : types de mesure commandés à SGE, refus connus compris mais jamais hors segment (PMAX ne va qu'aux C5, FACTURANTES, les mesures facturantes, qu'à un segment connu) ; absent : ceux du segment de chaque PRM moins les refus. Vide seulement avec `describe` : la seule fiche technique (C68), sans aucune mesure ni réparation. Ignoré par les autres connecteurs.",
      },
      describe: {
        type: "boolean",
        description:
          "Module Enedis : `true` commande aussi la fiche technique (C68) des PRM, même de ceux qui en ont déjà une. Ignoré par les autres connecteurs.",
      },
      dryRun: {
        type: "boolean",
        description:
          "Module Enedis, plan seul (avec `action: orders`) : `true` calcule et journalise les commandes SGE que l'état des PRM appelle (`details.orders`, `details.dryRun`) sans en envoyer aucune. Module GTB WIT, plan seul : WIT est lu et les valeurs calculées, le journal dit ce qui serait écrit par fluxItem (`details.items`, `details.valuesPlanned`), rien n'est écrit. Ignoré par les autres connecteurs.",
      },
      action: {
        type: "string",
        enum: [
          "collect",
          "orders",
          "discover",
          "informatives",
          "reference",
          "climatology",
          "decadal",
        ],
        description:
          "Module Enedis : le geste demandé. `collect` (par défaut) relève le dépôt SFTP et écrit les séries (`references` ; les fichiers lus sont retirés du dépôt, ceux en erreur y restent et sont relus à chaque relève) ; `orders` dresse le bilan des PRM et envoie les commandes SGE (`references`, `from`, `to`, `types`, `describe`, `dryRun`), refusé au palier « flux ». Module GTB WIT : `discover` ne relit que la liste des flux (GTB, flux et fluxItems enregistrés, aucun point lu), pour toutes les GTB ou `references` ; ne se combine pas avec `dryRun`. Module GRDF : `informatives` interroge les consommations informatives (journalières, non facturantes) au lieu des publiées, pour tous les PCE ou `references`, depuis `from` ; `reference` lit la fiche des PCE (données contractuelles et techniques, selon le périmètre du droit d'accès) et leurs injections publiées de biométhane (depuis `from`). Météo-France : `climatology` collecte les archives quotidiennes officielles depuis les CSV data.gouv sans clé API (`references` : stations, `from` et `to` : bornes inclusives du rejeu). `decadal` collecte les cumuls décadaires publics.",
      },
    },
    required: [],
  },
  ConnectorRunInterruption: {
    type: "object",
    additionalProperties: false,
    required: ["detectedAt", "checkpointAt", "total", "done"],
    properties: {
      detectedAt: {
        type: "string",
        format: "date-time",
      },
      checkpointAt: {
        type: "string",
        format: "date-time",
      },
      total: {
        type: "integer",
        minimum: 0,
      },
      done: {
        type: "integer",
        minimum: 0,
      },
      currentItem: {
        type: "string",
      },
    },
    description:
      "Interruption détectée au redémarrage. Avancement du dernier point de reprise, pas un bilan d'écriture. detectedAt n'est pas l'heure exacte de l'arrêt. Aucune commande n'est renvoyée automatiquement.",
  },
  ConnectorCompleteness: {
    type: "object",
    additionalProperties: false,
    required: ["reference", "asOf", "method", "synthetic", "streams"],
    properties: {
      reference: {
        type: "string",
      },
      asOf: {
        type: "string",
        format: "date-time",
      },
      method: {
        type: "string",
      },
      synthetic: {
        type: "boolean",
        const: false,
      },
      streams: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ConnectorStreamCompleteness",
        },
      },
    },
  },
  ConnectorStreamCompleteness: {
    type: "object",
    additionalProperties: false,
    required: [
      "kind",
      "label",
      "from",
      "to",
      "state",
      "expectedDays",
      "completeDays",
      "partialDays",
      "missingDays",
      "observedDays",
      "estimatedDays",
      "receivedIntervals",
      "latestAt",
      "method",
    ],
    properties: {
      kind: {
        type: "string",
      },
      label: {
        type: "string",
      },
      from: {
        type: "string",
        format: "date-time",
      },
      to: {
        type: "string",
        format: "date-time",
      },
      state: {
        type: "string",
        enum: ["complete", "partial", "missing", "unknown"],
      },
      expectedDays: {
        type: ["integer", "null"],
        minimum: 0,
      },
      completeDays: {
        type: "integer",
        minimum: 0,
      },
      partialDays: {
        type: "integer",
        minimum: 0,
      },
      missingDays: {
        type: ["integer", "null"],
        minimum: 0,
      },
      observedDays: {
        type: "integer",
        minimum: 0,
      },
      estimatedDays: {
        type: "integer",
        minimum: 0,
      },
      receivedIntervals: {
        type: "integer",
        minimum: 0,
      },
      latestAt: {
        type: ["string", "null"],
      },
      method: {
        type: "string",
      },
    },
  },
  ConnectorCoverage: {
    type: "object",
    additionalProperties: false,
    required: [
      "asOf",
      "provider",
      "method",
      "classificationAvailable",
      "total",
      "current",
      "late",
      "missing",
      "pending",
      "unknown",
      "excluded",
      "entries",
    ],
    properties: {
      asOf: {
        type: "string",
      },
      provider: {
        type: "string",
        enum: ["enedis", "grdf"],
      },
      method: {
        type: "string",
      },
      classificationAvailable: {
        type: "boolean",
      },
      total: {
        type: "integer",
        minimum: 0,
      },
      current: {
        type: "integer",
        minimum: 0,
      },
      late: {
        type: "integer",
        minimum: 0,
      },
      missing: {
        type: "integer",
        minimum: 0,
      },
      pending: {
        type: "integer",
        minimum: 0,
      },
      unknown: {
        type: "integer",
        minimum: 0,
      },
      excluded: {
        type: "integer",
        minimum: 0,
      },
      entries: {
        type: "array",
        items: {
          $ref: "#/components/schemas/ConnectorCoverageEntry",
        },
      },
    },
  },
  ConnectorCoverageEntry: {
    type: "object",
    additionalProperties: false,
    required: ["reference", "state"],
    properties: {
      reference: {
        type: "string",
      },
      state: {
        type: "string",
        enum: ["current", "late", "missing", "pending", "unknown", "excluded"],
      },
      latestAt: {
        type: "string",
      },
    },
  },
  ConnectorReferenceEntry: {
    type: "object",
    additionalProperties: false,
    description:
      "Référence (PRM ou PCE) portée par au moins un point actif du type attendu par un connecteur Enedis ou GRDF, avec ses points et la fin du dernier relevé réel écrit.",
    properties: {
      provider: {
        type: "string",
        enum: ["enedis", "grdf"],
      },
      reference: {
        type: "string",
      },
      latestAt: {
        type: "string",
        description:
          "Fin du relevé réel le plus récent des séries du fournisseur (ISO 8601) ; absent sans relevé. Pour Enedis, la courbe de charge et l'énergie quotidienne seulement, comme l'état des PRM du bilan du module.",
      },
      points: {
        type: "array",
        items: {
          type: "object",
          additionalProperties: false,
          properties: {
            id: {
              type: "string",
            },
            label: {
              type: "string",
            },
            brandId: {
              type: "string",
            },
            brandName: {
              type: "string",
            },
            siteName: {
              type: "string",
            },
            companyName: {
              type: "string",
              description: "Entreprise (Company) du Site qui porte le point.",
            },
          },
          required: [
            "id",
            "label",
            "brandId",
            "brandName",
            "siteName",
            "companyName",
          ],
        },
      },
    },
    required: ["provider", "reference", "points"],
  },
  SyncRun: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      connectorId: {
        type: "string",
      },
      status: {
        type: "string",
        enum: ["running", "success", "failure"],
      },
      mode: {
        type: "string",
        enum: ["simulated", "api"],
      },
      startedAt: {
        type: "string",
      },
      finishedAt: {
        type: "string",
      },
      itemCount: {
        type: "integer",
      },
      gapCount: {
        type: "integer",
      },
      error: {
        type: "string",
      },
      triggeredByUserId: {
        type: "string",
      },
    },
    required: [
      "id",
      "connectorId",
      "status",
      "mode",
      "startedAt",
      "itemCount",
      "gapCount",
    ],
  },
  PointSyncStatus: {
    type: "object",
    additionalProperties: false,
    description: "Synchronisation ciblée d'un point encore en cours.",
    properties: {
      pointId: {
        type: "string",
      },
      startedAt: {
        type: "string",
        format: "date-time",
      },
    },
    required: ["pointId", "startedAt"],
  },
  MeasurementBatch: {
    type: "object",
    additionalProperties: false,
    properties: {
      seriesId: {
        type: "string",
      },
      values: {
        type: "array",
        items: {
          $ref: "#/components/schemas/MeasurementValue",
        },
      },
    },
    required: ["seriesId", "values"],
  },
  MeasurementCorrectionInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      value: {
        type: ["number", "null"],
      },
      quality: {
        type: "string",
        enum: ["corrected", "missing"],
      },
    },
    required: ["value", "quality"],
  },
  SupplierInvoice: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      brandId: {
        type: "string",
      },
      siteId: {
        type: "string",
      },
      deliveryPointId: {
        type: "string",
      },
      supplier: {
        type: "string",
      },
      invoiceNumber: {
        type: "string",
      },
      energy: {
        type: "string",
        enum: ["electricity", "gas"],
      },
      periodStart: {
        type: "string",
      },
      periodEnd: {
        type: "string",
      },
      issuedAt: {
        type: "string",
      },
      consumptionKwh: {
        type: ["number", "null"],
      },
      amountExclTaxEur: {
        type: ["number", "null"],
      },
      amountInclTaxEur: {
        type: ["number", "null"],
      },
      currency: {
        type: "string",
      },
      documentSha256: {
        type: "string",
      },
      documentName: {
        type: "string",
      },
      extraction: {
        type: "object",
        additionalProperties: true,
        description:
          "Extraction OCR/vision versionnée (`SupplierInvoiceExtraction`), à valider par un manager.",
      },
      reviewStatus: {
        type: "string",
        enum: ["pending", "validated", "disputed"],
      },
      reviewedByUserId: {
        type: "string",
      },
      reviewedAt: {
        type: "string",
      },
      createdAt: {
        type: "string",
      },
      updatedAt: {
        type: "string",
      },
    },
    required: [
      "id",
      "brandId",
      "siteId",
      "supplier",
      "invoiceNumber",
      "energy",
      "periodStart",
      "periodEnd",
      "consumptionKwh",
      "amountExclTaxEur",
      "amountInclTaxEur",
      "currency",
      "reviewStatus",
      "createdAt",
      "updatedAt",
    ],
  },
  SupplierInvoiceInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      id: {
        type: "string",
      },
      siteId: {
        type: "string",
      },
      deliveryPointId: {
        type: "string",
      },
      supplier: {
        type: "string",
      },
      invoiceNumber: {
        type: "string",
      },
      energy: {
        type: "string",
        enum: ["electricity", "gas"],
      },
      periodStart: {
        type: "string",
      },
      periodEnd: {
        type: "string",
      },
      issuedAt: {
        type: "string",
      },
      consumptionKwh: {
        type: ["number", "null"],
      },
      amountExclTaxEur: {
        type: ["number", "null"],
      },
      amountInclTaxEur: {
        type: ["number", "null"],
      },
      documentSha256: {
        type: "string",
      },
      documentName: {
        type: "string",
      },
    },
    required: [
      "siteId",
      "supplier",
      "invoiceNumber",
      "energy",
      "periodStart",
      "periodEnd",
    ],
  },
  InvoiceReviewInput: {
    type: "object",
    additionalProperties: false,
    properties: {
      reviewStatus: {
        type: "string",
        enum: ["pending", "validated", "disputed"],
      },
    },
    required: ["reviewStatus"],
  },
} as const;
